msgid ""
msgstr ""
"POT-Creation-Date: 2026-09-10 11:57-0400\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=utf-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: es-CO\n"
"Project-Id-Version: \n"
"Report-Msgid-Bugs-To: \n"
"PO-Revision-Date: \n"
"Last-Translator: \n"
"Language-Team: \n"
"Plural-Forms: \n"

#: src/pages/DashboardPage.tsx:382
msgid "(Admin)"
msgstr "(Administrador)"

#: src/pages/SubscriptionPage.tsx:886
msgid "(Canceling)"
msgstr "(Cancelando)"

#: src/pages/AgentsPage.tsx:1086
msgid "(default)"
msgstr "(predeterminado)"

#: src/pages/UserManagementPage.tsx:241
msgid "(Personal Account)"
msgstr "(Cuenta personal)"

#: src/components/Layout.tsx:302
msgid "(Personal)"
msgstr "(Personal)"

#. placeholder {0}: agents.length
#: src/pages/AgentsPage.tsx:430
msgid "{0, plural, one {# agent} other {# agents}}"
msgstr "{0, plural, one {# agente} many {# de agentes} other {# agentes}}"

#. placeholder {0}: log.agentExecutions.length
#: src/pages/UserDetailAuditPage.tsx:869
msgid "{0, plural, one {# AGENT} other {# AGENTS}}"
msgstr "{0, plural, one {# AGENTE} many {# DE AGENTES} other {# AGENTES}}"

#. placeholder {0}: entity.factCount
#: src/pages/MemoryPage.tsx:1290
msgid "{0, plural, one {# memory} other {# memories}}"
msgstr "{0, plural, one {# recuerdo} many {# de recuerdos} other {# recuerdos}}"

#. placeholder {0}: allSessionPrompts.length
#: src/pages/UserDetailAuditPage.tsx:405
msgid "{0, plural, one {# prompt in this conversation} other {# prompts in this conversation}}"
msgstr "{0, plural, one {# prompt en esta conversación} many {# de prompts en esta conversación} other {# prompts en esta conversación}}"

#. placeholder {0}: log.sessionPrompts?.length ?? 0
#. placeholder {0}: selectedAudit.metadata.promptCount
#: src/pages/UserDetailAuditPage.tsx:860
#: src/pages/UserDetailAuditPage.tsx:955
msgid "{0, plural, one {# prompt} other {# prompts}}"
msgstr "{0, plural, one {# prompt} many {# de prompts} other {# prompts}}"

#. placeholder {0}: log.agentExecutions.length
#: src/pages/UserDetailAuditPage.tsx:867
msgid "{0, plural, one {Agent: {agentNames}} other {Agents: {agentNames}}}"
msgstr "{0, plural, one {Agente: {agentNames}} many {Agentes: {agentNames}} other {Agentes: {agentNames}}}"

#. placeholder {0}: appliedPromo.code
#. placeholder {1}: pricing.perSeatLabel
#: src/components/UpgradeModal.tsx:230
msgid "{0} applied: {1}/seat for your first month"
msgstr "{0} aplicado: {1}/puesto tu primer mes"

#. placeholder {0}: appliedPromo.code
#. placeholder {1}: pricing.perSeatLabel
#: src/components/UpgradeModal.tsx:234
msgid "{0} applied: {1}/seat/mo"
msgstr "{0} aplicado: {1}/puesto/mes"

#. placeholder {0}: appliedPromo.code
#. placeholder {1}: pricing.perSeatLabel
#: src/components/UpgradeModal.tsx:232
msgid "{0} applied: {1}/seat/mo for as long as you stay"
msgstr "{0} aplicado: {1}/puesto/mes mientras sigas con nosotros"

#. placeholder {0}: appliedPromo.code
#. placeholder {1}: pricing.perSeatLabel
#. placeholder {2}: duration.months
#: src/components/UpgradeModal.tsx:228
msgid "{0} applied: {1}/seat/mo for your first {2} months"
msgstr "{0} aplicado: {1}/puesto/mes tus primeros {2} meses"

#: src/components/UpgradeModal.tsx:164
#~ msgid "{0} applied: {1}% off your first {2} months"
#~ msgstr "{0} aplicado: {1}% de descuento en tus primeros {2} meses"

#: src/components/UpgradeModal.tsx:166
#~ msgid "{0} applied: {1}% off your first year"
#~ msgstr "{0} aplicado: {1}% de descuento en tu primer año"

#. placeholder {0}: agentPrompt.length
#: src/pages/AgentsPage.tsx:870
msgid "{0} chars"
msgstr "{0} caracteres"

#. placeholder {0}: dict.deny_list_count
#: src/pages/AgentsPage.tsx:714
#: src/pages/DictionaryManagementPage.tsx:264
msgid "{0} deny list"
msgstr "Lista de bloqueo de {0}"

#. placeholder {0}: conn.serviceName
#: src/pages/ConnectionsPage.tsx:392
msgid "{0} disconnected"
msgstr "{0} desconectado"

#. placeholder {0}: totalTokensIn.toLocaleString()
#. placeholder {1}: totalTokensOut.toLocaleString()
#: src/pages/DashboardPage.tsx:366
msgid "{0} in · {1} out"
msgstr "{0} entrada · {1} salida"

#. placeholder {0}: valid.code
#. placeholder {1}: valid.trialDays
#. placeholder {2}: valid.maxSeats
#: src/components/UpgradeModal.tsx:405
msgid "{0} is good for {1} days of Max across up to {2} seats. When it ends your company drops back to Pro, with nothing to cancel."
msgstr "{0} te da {1} días de Max para hasta {2} puestos. Cuando termine, tu empresa vuelve a Pro y no hay nada que cancelar."

#. placeholder {0}: valid.code
#. placeholder {1}: valid.trialDays
#: src/components/UpgradeModal.tsx:409
msgid "{0} is good for {1} days of Max company-wide. When it ends your company drops back to Pro, with nothing to cancel."
msgstr "{0} te da {1} días de Max para toda la empresa. Cuando termine, tu empresa vuelve a Pro y no hay nada que cancelar."

#. placeholder {0}: valid.code
#: src/components/UpgradeModal.tsx:434
msgid "{0} needs a card"
msgstr "{0} necesita una tarjeta"

#. placeholder {0}: dict.term_count
#: src/pages/AgentsPage.tsx:713
#: src/pages/DictionaryManagementPage.tsx:263
msgid "{0} terms"
msgstr "{0} términos"

#. placeholder {0}: detail.tokens
#. placeholder {0}: tokens.toLocaleString()
#: src/pages/DashboardPage.tsx:603
#: src/pages/MemoryPage.tsx:1353
msgid "{0} tokens"
msgstr "{0} tokens"

#. placeholder {0}: moneyLabel(monthly)
#: src/pages/SubscriptionPage.tsx:106
msgid "{0}/mo"
msgstr "{0}/mes"

#. placeholder {0}: maxPricing.perSeatLabel
#: src/pages/SignupPage.tsx:634
msgid "{0}/seat/mo"
msgstr "{0}/puesto/mes"

#. placeholder {0}: optionSlot.perSeatAmount
#: src/components/UpgradeModal.tsx:205
msgid "{0}/seat/mo billed yearly"
msgstr "{0}/puesto/mes con facturación anual"

#: src/pages/SignupPage.tsx:656
#~ msgid "{0}% off"
#~ msgstr "{0} % de descuento"

#. placeholder {0}: subscriptionDetails.discount.coupon.percent_off
#: src/pages/SubscriptionPage.tsx:938
msgid "{0}% OFF"
msgstr "{0} % DE DESCUENTO"

#. placeholder {0}: (executionModal.elapsedMs / 1000).toFixed(1)
#: src/pages/AgentsPage.tsx:1056
msgid "{0}s elapsed"
msgstr "{0} s transcurridos"

#: src/pages/ConnectionsPage.tsx:684
msgid "{activeCount} Active"
msgstr "{activeCount} activos"

#: src/pages/SubscriptionPage.tsx:84
msgid "{amountStr}/mo"
msgstr "{amountStr}/mes"

#: src/pages/SubscriptionPage.tsx:83
msgid "{amountStr}/mo billed annually"
msgstr "{amountStr}/mes con cobro anual"

#: src/pages/ConnectionsPage.tsx:743
msgid "{catalogCount} items indexed"
msgstr "{catalogCount} elementos indexados"

#: src/pages/ConnectionsPage.tsx:742
msgid "{catalogCount} items indexed · Last sync {lastSyncDate}"
msgstr "{catalogCount} elementos indexados · Última sincronización {lastSyncDate}"

#: src/utils/licenses.ts:159
msgid "{claimed, plural, one {# {tierLabel} seat is in use past the licensed block.} other {# {tierLabel} seats are in use past the licensed block.}}"
msgstr "{claimed, plural, one {# puesto {tierLabel} está en uso por encima del bloque licenciado.} many {# de puestos {tierLabel} están en uso por encima del bloque licenciado.} other {# puestos {tierLabel} están en uso por encima del bloque licenciado.}}"

#: src/pages/UserDetailAuditPage.tsx:669
msgid "{d}d"
msgstr "{d} d"

#: src/utils/relativeTime.ts:17
msgid "{day}d ago"
msgstr "hace {day} d"

#: src/pages/DashboardPage.tsx:389
msgid "{daysRemaining, plural, one {# day remaining} other {# days remaining}}"
msgstr "{daysRemaining, plural, one {queda # día} many {quedan # de días} other {quedan # días}}"

#: src/pages/UserDetailAuditPage.tsx:432
msgid "{diffDays}d ago"
msgstr "hace {diffDays} d"

#: src/pages/UserDetailAuditPage.tsx:430
msgid "{diffHours}h ago"
msgstr "hace {diffHours} h"

#: src/pages/UserDetailAuditPage.tsx:429
msgid "{diffMins}m ago"
msgstr "hace {diffMins} min"

#: src/utils/relativeTime.ts:15
msgid "{hr}h ago"
msgstr "hace {hr} h"

#: src/pages/SubscriptionPage.tsx:490
#~ msgid "{maxFeatureLine}. $0 today; first charge after your {trialDays}-day trial."
#~ msgstr "{maxFeatureLine}. $0 hoy; el primer cobro se hace al terminar tu prueba de {trialDays} días."

#: src/pages/SubscriptionPage.tsx:406
msgid "{maxFeatureLine}. Billed today, then every renewal until canceled."
msgstr "{maxFeatureLine}. Se cobra hoy y en cada renovación hasta que canceles."

#: src/utils/relativeTime.ts:14
msgid "{min}m ago"
msgstr "hace {min} min"

#: src/utils/relativeTime.ts:19
msgid "{mon}mo ago"
msgstr "hace {mon} meses"

#: src/pages/DashboardPage.tsx:350
msgid "{monthName}, month to date"
msgstr "{monthName}, del mes a la fecha"

#: src/pages/OnboardingPage.tsx:481
msgid "{palDisplayName} runs 24 hours a day, seven days a week: silently intercepting, masking, and protecting. You focus on building. Leave the risk management to us."
msgstr "{palDisplayName} funciona 24 horas al día, siete días a la semana: intercepta, reemplaza y protege en silencio. Tú concéntrate en construir. Déjanos la gestión del riesgo."

#: src/pages/UserDetailAuditPage.tsx:556
msgid "{platformCount, plural, one {# platform} other {# platforms}}"
msgstr "{platformCount, plural, one {# plataforma} many {# de plataformas} other {# plataformas}}"

#: src/components/ProviderDetailModal.tsx:228
#: src/components/ProviderDetailModal.tsx:250
msgid "{providerName} activity report"
msgstr "Informe de actividad de {providerName}"

#: src/components/ProviderDetailModal.tsx:253
msgid "{providerVendor} · last {days} days · {scopeLabel}"
msgstr "{providerVendor} · últimos {days} días · {scopeLabel}"

#: src/pages/SubscriptionPage.tsx:106
msgid "{range} seats"
msgstr "{range} puestos"

#: src/pages/DashboardPage.tsx:354
msgid "{scopeUserCount, plural, one {# team member} other {# team members}}"
msgstr "{scopeUserCount, plural, one {# integrante del equipo} many {# de integrantes del equipo} other {# integrantes del equipo}}"

#: src/pages/SalesforceOAuthCallbackPage.tsx:55
msgid "{serviceName} authentication completed."
msgstr "Autenticación de {serviceName} completada."

#: src/pages/ConnectionsPage.tsx:183
msgid "{serviceName} authentication failed"
msgstr "Falló la autenticación de {serviceName}"

#: src/pages/SalesforceOAuthCallbackPage.tsx:63
msgid "{serviceName} authentication failed."
msgstr "Falló la autenticación de {serviceName}."

#: src/pages/ConnectionsPage.tsx:535
msgid "{serviceName} authentication was cancelled."
msgstr "Se canceló la autenticación de {serviceName}."

#: src/pages/ConnectionsPage.tsx:180
msgid "{serviceName} connected successfully"
msgstr "{serviceName} se conectó correctamente"

#: src/pages/ConnectionsPage.tsx:489
msgid "{serviceName} connection could not be verified"
msgstr "No se pudo verificar la conexión de {serviceName}"

#: src/pages/ConnectionsPage.tsx:513
msgid "{serviceName} OAuth start did not return an authorization URL"
msgstr "El inicio de OAuth de {serviceName} no devolvió una URL de autorización"

#: src/utils/licenses.ts:123
msgid "{tierLabel} seats: {claimed} in use, {licensed} licensed ({over} over)"
msgstr "Puestos {tierLabel}: {claimed} en uso, {licensed} licenciados ({over} por encima)"

#: src/utils/licenses.ts:128
msgid "{tierLabel} seats: {claimed} of {licensed} used"
msgstr "Puestos {tierLabel}: {claimed} de {licensed} en uso"

#: src/utils/licenses.ts:126
msgid "{tierLabel} seats: none purchased"
msgstr "Puestos {tierLabel}: ninguno comprado"

#: src/components/ProviderDetailModal.tsx:206
#: src/components/ProviderDetailModal.tsx:430
msgid "{tokensInLabel} in · {tokensOutLabel} out"
msgstr "{tokensInLabel} entrada · {tokensOutLabel} salida"

#: src/pages/SignupPage.tsx:129
#~ msgid "{trialDays}-day free trial • First charge: {trialEndFormatted}"
#~ msgstr "Prueba gratis de {trialDays} días • Primer cobro: {trialEndFormatted}"

#: src/pages/SubscriptionPage.tsx:408
#~ msgid "{trialDays}-day free trial. We'll save your card today and only charge after the trial ends."
#~ msgstr "Prueba gratis de {trialDays} días. Hoy se guarda tu tarjeta y solo se cobra cuando termine la prueba."

#: src/pages/SignupPage.tsx:631
#~ msgid "{trialDays}-day no-cost trial"
#~ msgstr "Prueba sin costo de {trialDays} días"

#: src/utils/relativeTime.ts:21
msgid "{yr}y ago"
msgstr "hace {yr} años"

#: src/pages/InvitePage.tsx:759
#: src/pages/SignupPage.tsx:697
msgid "© 2026 WEB3 REX INC. All Rights Reserved."
msgstr "© 2026 WEB3 REX INC. Todos los derechos reservados."

#: src/pages/InvitePage.tsx:612
#: src/pages/LoginPage.tsx:232
#: src/pages/SignupPage.tsx:566
msgid "← Use a different email"
msgstr "← Usar otro correo"

#: src/pages/DictionaryManagementPage.tsx:182
msgid "+ Create New Catalog"
msgstr "+ Crear catálogo"

#. placeholder {0}: quarantined.length
#. placeholder {1}: sensitive.length
#: src/pages/MemoryPage.tsx:987
msgid "<0>Memory Guard</0> held back: {0, plural, one {# looked like an instruction} other {# looked like instructions}}, {1, plural, one {# touches a sensitive topic} other {# touch sensitive topics}}. Instructions are never used in prompts; sensitive notes are recalled only in conversations on the same topic."
msgstr "<0>Memory Guard</0> retuvo: {0, plural, one {# parecía una instrucción} many {# de parecían instrucciones} other {# parecían instrucciones}}, {1, plural, one {# toca un tema sensible} many {# de tocan temas sensibles} other {# tocan temas sensibles}}. Las instrucciones nunca se usan en los prompts; las notas sensibles solo se recuerdan en conversaciones sobre el mismo tema."

#: src/pages/MemoryPage.tsx:424
#~ msgid "<0>Memory Guard</0> quarantined {0, plural, one {# entry} other {# entries}} that looked like instructions rather than facts. They are never used in prompts."
#~ msgstr "<0>Memory Guard</0> puso en cuarentena {0, plural, one {# entrada} many {# de entradas} other {# entradas}} que parecían instrucciones y no datos. Nunca se usan en los prompts."

#: src/pages/OnboardingPage.tsx:705
#~ msgid "<0>Nothing due today.</0> Your card is saved but not charged until your trial ends on day five. Cancel any time before then with one click."
#~ msgstr "<0>Hoy no se cobra nada.</0> Tu tarjeta queda guardada y no se cobra hasta que la prueba termine el quinto día. Puedes cancelar antes con un clic."

#: src/pages/SignupPage.tsx:126
#~ msgid "${0}/month"
#~ msgstr "${0}/mes"

#: src/pages/OnboardingPage.tsx:167
#~ msgid "$0 today"
#~ msgstr "$0 hoy"

#: src/pages/UserDetailAuditPage.tsx:669
msgid "1 year"
msgstr "1 año"

#: src/pages/DashboardPage.tsx:451
#: src/pages/DashboardPage.tsx:457
msgid "1y"
msgstr "1 a"

#: src/pages/OnboardingPage.tsx:484
msgid "24/7 protection"
msgstr "Protección 24/7"

#: src/pages/DashboardPage.tsx:454
msgid "24h"
msgstr "24 h"

#: src/components/connections/ConnectionHealthPanel.tsx:71
msgid "3:00 AM ET"
msgstr "3:00 a. m. ET"

#: src/pages/DashboardPage.tsx:449
#: src/pages/DashboardPage.tsx:455
msgid "30d"
msgstr "30 d"

#: src/pages/DashboardPage.tsx:450
#: src/pages/DashboardPage.tsx:456
msgid "90d"
msgstr "90 d"

#: src/App.tsx:209
#~ msgid "A hosted MCP endpoint that lets your AI assistant use Salesforce and Microsoft 365 while it only ever sees Privacy Twins."
#~ msgstr "Un endpoint MCP alojado que permite que tu asistente de IA use Salesforce y Microsoft 365 viendo únicamente valores sintéticos."

#: src/App.tsx:209
#~ msgid "A hosted MCP endpoint that lets your AI assistant use Salesforce while it only ever sees Privacy Twins."
#~ msgstr "Un endpoint MCP administrado que le permite a tu asistente de IA usar Salesforce sin ver nunca nada distinto de los valores sintéticos."

#: src/App.tsx:209
msgid "A hosted MCP endpoint that lets your AI assistant use Salesforce, HubSpot, Microsoft 365 and Google Workspace while it only ever sees Privacy Twins."
msgstr "Un endpoint MCP alojado que le permite a tu asistente de IA usar Salesforce, HubSpot, Microsoft 365 y Google Workspace mientras solo ve Privacy Twins."

#: src/pages/ResetPasswordPage.tsx:112
#: src/pages/SignupPage.tsx:359
msgid "A lowercase letter"
msgstr "Una letra minúscula"

#: src/pages/OnboardingPage.tsx:317
msgid "A new discipline: Privacy Engineering."
msgstr "Una nueva disciplina: la ingeniería de privacidad."

#: src/pages/ResetPasswordPage.tsx:113
#: src/pages/SignupPage.tsx:360
msgid "A number"
msgstr "Un número"

#: src/pages/UserManagementPage.tsx:219
msgid "Access Denied"
msgstr "Acceso denegado"

#: src/pages/ConnectionsPage.tsx:945
#: src/pages/ConnectionsPage.tsx:1002
msgid "Access token"
msgstr "Token de acceso"

#. placeholder {0}: new Date(account.subscriptionEndDate).toLocaleDateString()
#: src/pages/DashboardPage.tsx:397
msgid "Access until {0}"
msgstr "Acceso hasta el {0}"

#: src/components/Layout.tsx:296
msgid "Account"
msgstr "Cuenta"

#: src/pages/InvitePage.tsx:514
msgid "ACCURACY"
msgstr "PRECISIÓN"

#: src/pages/DashboardPage.tsx:433
msgid "across all {scopeUserCount} team members"
msgstr "en los {scopeUserCount} integrantes del equipo"

#: src/pages/AgentsPage.tsx:674
#: src/pages/ApiKeysPage.tsx:139
#: src/pages/DictionaryManagementPage.tsx:210
#: src/pages/UserManagementPage.tsx:287
msgid "Actions"
msgstr "Acciones"

#: src/pages/OnboardingPage.tsx:724
#~ msgid "Activate"
#~ msgstr "Activar"

#. placeholder {0}: valid.code
#: src/components/UpgradeModal.tsx:426
msgid "Activate {0} on a call"
msgstr "Activar {0} en una llamada"

#: src/pages/OnboardingPage.tsx:518
msgid "Activate PrivacyPal"
msgstr "Activar PrivacyPal"

#: src/components/connections/ConnectionStatusBadge.tsx:40
#: src/pages/AgentsPage.tsx:481
#: src/pages/DashboardPage.tsx:678
#: src/pages/MemoryPage.tsx:130
msgid "Active"
msgstr "Activo"

#: src/pages/SubscriptionPage.tsx:975
msgid "Active Discount: {couponName}"
msgstr "Descuento activo: {couponName}"

#. placeholder {0}: activeKeys.length
#: src/pages/ApiKeysPage.tsx:113
msgid "Active Keys ({0})"
msgstr "Llaves activas ({0})"

#: src/pages/SubscriptionPage.tsx:1133
msgid "Active Subscription"
msgstr "Suscripción activa"

#: src/components/ProviderDetailModal.tsx:213
msgid "Active users"
msgstr "Usuarios activos"

#: src/pages/UserDetailAuditPage.tsx:650
msgid "Active window"
msgstr "Ventana activa"

#: src/pages/MemoryPage.tsx:644
msgid "Activity"
msgstr "Actividad"

#: src/components/Layout.tsx:167
msgid "Activity Dashboard"
msgstr "Panel de actividad"

#: src/pages/DashboardPage.tsx:284
msgid "Activity Stream"
msgstr "Flujo de actividad"

#: src/pages/DashboardPage.tsx:442
msgid "Activity stream range"
msgstr "Rango del flujo de actividad"

#: src/pages/AgentsPage.tsx:1417
#: src/pages/AgentsPage.tsx:1432
#: src/pages/DictionaryManagementPage.tsx:486
#: src/pages/DictionaryManagementPage.tsx:512
msgid "Add"
msgstr "Agregar"

#: src/pages/AgentsPage.tsx:1431
#: src/pages/DictionaryManagementPage.tsx:509
msgid "Add a deny list term..."
msgstr "Agrega un término a la lista de bloqueo..."

#: src/pages/AgentsPage.tsx:1416
#: src/pages/DictionaryManagementPage.tsx:483
msgid "Add a term..."
msgstr "Agrega un término..."

#: src/pages/UserManagementPage.tsx:352
#: src/pages/UserManagementPage.tsx:435
#: src/pages/UserManagementPage.tsx:471
msgid "Add license"
msgstr "Agregar licencia"

#: src/pages/UserManagementPage.tsx:471
msgid "Add License"
msgstr "Agregar licencia"

#: src/pages/PrivateMcpPage.tsx:1270
msgid "Add new Private MCP"
msgstr "Agregar un Private MCP"

#: src/pages/MemoryPage.tsx:837
msgid "Adds relevant memories to what you send, in twin-space."
msgstr "Agrega los recuerdos relevantes a lo que envías, en el espacio de valores sintéticos."

#: src/pages/UserManagementPage.tsx:421
msgid "Admin"
msgstr "Administrador"

#: src/components/Layout.tsx:306
#: src/pages/UserManagementPage.tsx:316
msgid "Administrator"
msgstr "Administrador"

#: src/pages/OnboardingPage.tsx:171
#~ msgid "After trial: ${discountedPrice}/mo (promo applied)"
#~ msgstr "Después de la prueba: ${discountedPrice}/mes (promoción aplicada)"

#: src/pages/AgentsPage.tsx:881
msgid "Agent Created"
msgstr "Agente creado"

#: src/pages/AgentsPage.tsx:224
msgid "Agent created!"
msgstr "¡Agente creado!"

#: src/pages/AgentsPage.tsx:244
msgid "Agent deleted"
msgstr "Agente eliminado"

#: src/pages/AgentsPage.tsx:831
msgid "Agent Name"
msgstr "Nombre del agente"

#: src/pages/AgentsPage.tsx:207
msgid "Agent name is required"
msgstr "El nombre del agente es obligatorio"

#: src/pages/AgentsPage.tsx:1102
msgid "Agent Output"
msgstr "Salida del agente"

#: src/pages/AgentsPage.tsx:208
msgid "Agent prompt is required"
msgstr "El prompt del agente es obligatorio"

#: src/pages/AgentsPage.tsx:881
msgid "Agent Updated"
msgstr "Agente actualizado"

#: src/pages/AgentsPage.tsx:224
msgid "Agent updated!"
msgstr "¡Agente actualizado!"

#: src/components/Layout.tsx:195
msgid "Agents"
msgstr "Agentes"

#: src/components/ProviderDetailModal.tsx:491
msgid "Aggregate statistics only. Individual conversations are available to administrators in User Management."
msgstr "Solo estadísticas agregadas. Las conversaciones individuales están disponibles para los administradores en Gestión de usuarios."

#: src/pages/DashboardPage.tsx:632
msgid "AI App"
msgstr "App de IA"

#: src/pages/OnboardingPage.tsx:326
msgid "AI Services"
msgstr "Servicios de IA"

#: src/pages/OnboardingPage.tsx:484
msgid "AI-native privacy"
msgstr "Privacidad nativa de IA"

#: src/pages/MemoryPage.tsx:134
#: src/pages/MemoryPage.tsx:1147
msgid "All"
msgstr "Todo"

#: src/utils/licenses.ts:167
msgid "All {licensed} prepaid {tierLabel} seats are in use. {noSeatLine}"
msgstr "Los {licensed} puestos {tierLabel} prepagados están en uso. {noSeatLine}"

#: src/pages/DashboardPage.tsx:619
msgid "all {scopeUserCount} team members"
msgstr "los {scopeUserCount} integrantes del equipo"

#: src/components/ProviderDetailModal.tsx:105
msgid "all {userCount} team members"
msgstr "los {userCount} integrantes del equipo"

#: src/pages/ConnectionsPage.tsx:864
msgid "All credentials are encrypted at rest and transmitted over TLS. Only domain administrators can manage connections."
msgstr "Todas las credenciales se cifran en reposo y se transmiten por TLS. Solo los administradores del dominio pueden gestionar las conexiones."

#: src/pages/LoginPage.tsx:388
msgid "Already have an account? Sign in"
msgstr "¿Ya tienes cuenta? Ingresa"

#: src/pages/AgentsPage.tsx:821
msgid "AN"
msgstr "AN"

#: src/pages/LoginPage.tsx:91
msgid "An error occurred"
msgstr "Ocurrió un error"

#: src/pages/LoginPage.tsx:52
msgid "An error occurred during authentication."
msgstr "Ocurrió un error durante la autenticación."

#: src/pages/SignupPage.tsx:626
#~ msgid "An individual account: one seat, one person. Your login, your devices. Unlimited prompts and all features."
#~ msgstr "Una cuenta individual: un puesto, una persona. Tu ingreso, tus dispositivos. Prompts ilimitados y todas las funciones."

#: src/pages/ResetPasswordPage.tsx:111
#: src/pages/SignupPage.tsx:358
msgid "An uppercase letter"
msgstr "Una letra mayúscula"

#: src/pages/OnboardingPage.tsx:174
msgid "Analysis failed"
msgstr "Falló el análisis"

#: src/pages/AgentsPage.tsx:476
#: src/pages/AgentsPage.tsx:847
#: src/pages/AgentsPage.tsx:894
msgid "Analyst"
msgstr "Analista"

#: src/pages/AgentsPage.tsx:950
#: src/pages/AgentsPage.tsx:1017
msgid "Analyst Agent"
msgstr "Agente analista"

#: src/pages/AgentsPage.tsx:856
msgid "Analyst agents run against audit data after pipeline processing completes."
msgstr "Los agentes analistas se ejecutan sobre los datos de auditoría cuando termina el procesamiento del pipeline."

#: src/pages/UserDetailAuditPage.tsx:695
msgid "ANALYTIC AGENT"
msgstr "AGENTE ANALÍTICO"

#: src/pages/AgentsPage.tsx:1054
msgid "Analyzing audit data..."
msgstr "Analizando los datos de auditoría..."

#: src/pages/SubscriptionPage.tsx:835
msgid "annual"
msgstr "anual"

#: src/components/UpgradeModal.tsx:198
#: src/pages/SubscriptionPage.tsx:183
#: src/pages/SubscriptionPage.tsx:323
#: src/pages/SubscriptionPage.tsx:402
#: src/pages/SubscriptionPage.tsx:882
msgid "Annual"
msgstr "Anual"

#: src/pages/SubscriptionPage.tsx:831
msgid "Annual Bill"
msgstr "Cobro anual"

#: src/pages/PrivateMcpPage.tsx:1021
#: src/pages/PrivateMcpPage.tsx:1216
msgid "any"
msgstr "cualquiera"

#: src/App.tsx:182
msgid "API Access"
msgstr "Acceso a la API"

#: src/pages/ConnectionsPage.tsx:1029
#: src/pages/ConnectionsPage.tsx:1216
msgid "API Key"
msgstr "Llave de API"

#: src/pages/ApiKeysPage.tsx:258
msgid "API Key Created"
msgstr "Llave de API creada"

#: src/pages/ApiKeysPage.tsx:59
msgid "API key revoked"
msgstr "Llave de API revocada"

#: src/components/Layout.tsx:274
msgid "API Keys"
msgstr "Llaves de API"

#: src/pages/PrivateMcpPage.tsx:583
#: src/pages/PrivateMcpPage.tsx:760
msgid "App registration"
msgstr "Registro de la app"

#: src/components/Layout.tsx:662
msgid "Apple Silicon only (M1 and later). Apple menu → About This Mac to check."
msgstr "Solo Apple Silicon (M1 en adelante). Menú Apple → Acerca de este Mac para verificarlo."

#: src/pages/PrivateMcpPage.tsx:790
#: src/pages/PrivateMcpPage.tsx:837
msgid "Application (client) ID"
msgstr "ID de aplicación (cliente)"

#: src/pages/OnboardingPage.tsx:199
#~ msgid "Applied: {percentOff}% off"
#~ msgstr "Aplicado: {percentOff} % de descuento"

#: src/pages/OnboardingPage.tsx:200
#~ msgid "Applied: discount active"
#~ msgstr "Aplicado: descuento activo"

#: src/pages/OnboardingPage.tsx:193
#: src/pages/SignupPage.tsx:651
#~ msgid "Apply"
#~ msgstr "Aplicar"

#: src/pages/MemoryPage.tsx:745
msgid "Archive"
msgstr "Archivar"

#: src/pages/MemoryPage.tsx:132
msgid "Archived"
msgstr "Archivados"

#: src/pages/SubscriptionPage.tsx:1047
msgid "Are you sure you want to cancel your subscription? You will have access until the end of your current billing period."
msgstr "¿Seguro que quieres cancelar tu suscripción? Conservarás el acceso hasta que termine el periodo de facturación actual."

#. placeholder {0}: deleteAgentConfirm.name
#: src/pages/AgentsPage.tsx:1168
msgid "Are you sure you want to delete agent \"{0}\"? This action cannot be undone."
msgstr "¿Seguro que quieres eliminar el agente «{0}»? Esta acción no se puede deshacer."

#. placeholder {0}: deleteConfirm.dictionaryName
#. placeholder {0}: deleteDictConfirm.dictionaryName
#: src/pages/AgentsPage.tsx:1178
#: src/pages/DictionaryManagementPage.tsx:350
msgid "Are you sure you want to delete catalog \"{0}\"? This action cannot be undone."
msgstr "¿Seguro que quieres eliminar el catálogo «{0}»? Esta acción no se puede deshacer."

#: src/pages/UserDetailAuditPage.tsx:697
msgid "Ask about this user's data patterns or security footprint."
msgstr "Pregunta por los patrones de datos o la huella de seguridad de este usuario."

#: src/components/MaxUpsell.tsx:99
msgid "Ask your admin about PrivacyPal Max"
msgstr "Pregúntale a tu administrador por PrivacyPal Max"

#: src/pages/UserDetailAuditPage.tsx:1063
msgid "Associated Files ({associatedFileCount})"
msgstr "Archivos asociados ({associatedFileCount})"

#: src/pages/ResetPasswordPage.tsx:110
#: src/pages/SignupPage.tsx:357
msgid "At least 8 characters"
msgstr "Mínimo 8 caracteres"

#: src/pages/InvitePage.tsx:706
#: src/pages/LoginPage.tsx:31
msgid "At least 8 characters, including an uppercase letter, a lowercase letter, and a number."
msgstr "Mínimo 8 caracteres, con una mayúscula, una minúscula y un número."

#: src/pages/AgentsPage.tsx:1386
#: src/pages/DictionaryManagementPage.tsx:420
msgid "At least one term or one deny list entry is required"
msgstr "Se requiere al menos un término o una entrada en la lista de bloqueo"

#: src/pages/UserDetailAuditPage.tsx:1116
msgid "Attached Files"
msgstr "Archivos adjuntos"

#: src/pages/AgentsPage.tsx:959
msgid "Audit Data to Analyze"
msgstr "Datos de auditoría por analizar"

#: src/components/connections/ConnectionStatusBadge.tsx:20
msgid "Auth failed"
msgstr "Falló la autenticación"

#: src/pages/ConnectionsPage.tsx:1216
msgid "Auth Method"
msgstr "Método de autenticación"

#: src/pages/ConnectionsPage.tsx:549
msgid "Authenticate"
msgstr "Autenticar"

#: src/pages/ConnectionsPage.tsx:890
msgid "Authenticate your connection"
msgstr "Autentica tu conexión"

#: src/components/connections/ConnectionAuthError.tsx:23
msgid "Authentication failed — reconnect to update credentials."
msgstr "Falló la autenticación. Vuelve a conectarte para actualizar las credenciales."

#: src/pages/LoginPage.tsx:49
msgid "Authentication failed. Please try again."
msgstr "Falló la autenticación. Inténtalo de nuevo."

#: src/pages/ConnectionsPage.tsx:1140
msgid "Automatically exclude messages from recognized bot accounts"
msgstr "Excluir automáticamente los mensajes de cuentas de bot reconocidas"

#: src/pages/AgentsPage.tsx:406
msgid "Autonomous agents that augment the platform with intelligent detection, analysis, and decision-making."
msgstr "Agentes autónomos que amplían la plataforma con detección, análisis y toma de decisiones inteligentes."

#: src/pages/ConnectionsPage.tsx:1085
#: src/pages/ConnectionsPage.tsx:1192
#: src/pages/OnboardingPage.tsx:303
#: src/pages/OnboardingPage.tsx:336
#: src/pages/OnboardingPage.tsx:409
#: src/pages/OnboardingPage.tsx:465
#: src/pages/OnboardingPage.tsx:489
#: src/pages/OnboardingPage.tsx:524
msgid "Back"
msgstr "Atrás"

#: src/pages/SubscriptionPage.tsx:736
msgid "Back to Dashboard"
msgstr "Volver al panel"

#: src/pages/AuthCallbackPage.tsx:159
#: src/pages/ForgotPasswordPage.tsx:107
#: src/pages/ForgotPasswordPage.tsx:152
#: src/pages/ResetPasswordPage.tsx:172
#: src/pages/VerifyEmailPage.tsx:127
#: src/pages/VerifyEmailPage.tsx:143
msgid "Back to sign in"
msgstr "Volver al ingreso"

#: src/pages/UserDetailAuditPage.tsx:574
#: src/pages/UserDetailAuditPage.tsx:596
msgid "Back to User Management"
msgstr "Volver a Gestión de usuarios"

#: src/pages/UserDetailAuditPage.tsx:557
msgid "Based on the user's activity patterns, {subject} shows {totalPrompts} total prompts with activity across {platformsLabel}."
msgstr "Según los patrones de actividad del usuario, {subject} registra {totalPrompts} prompts en total, con actividad en {platformsLabel}."

#: src/components/Layout.tsx:736
msgid "Before you install"
msgstr "Antes de instalar"

#: src/pages/SubscriptionPage.tsx:185
msgid "Best value"
msgstr "La mejor relación precio-valor"

#: src/components/UpgradeModal.tsx:592
msgid "Billing is not available right now. Please try again later."
msgstr "La facturación no está disponible en este momento. Inténtalo de nuevo más tarde."

#: src/components/UpgradeModal.tsx:469
msgid "Book a trial call"
msgstr "Agenda una llamada de prueba"

#: src/pages/ConnectionsPage.tsx:615
msgid "Bot API access with read permissions on target groups. Create a bot via @BotFather and add it to your groups."
msgstr "Acceso a la API de bots con permisos de lectura sobre los grupos objetivo. Crea un bot con @BotFather y agrégalo a tus grupos."

#: src/pages/MemoryPage.tsx:1191
msgid "Bring memory from another AI"
msgstr "Traer memoria de otra IA"

#: src/pages/OnboardingPage.tsx:505
msgid "Bringing PrivacyPal online..."
msgstr "Poniendo PrivacyPal en línea..."

#: src/pages/UserDetailAuditPage.tsx:446
msgid "Browser Extension"
msgstr "Extensión del navegador"

#: src/pages/ConnectionsPage.tsx:738
msgid "Business Data Catalog"
msgstr "Catálogo de datos del negocio"

#: src/pages/ConnectionsPage.tsx:484
msgid "BusinessDataConnection verification failed"
msgstr "Falló la verificación de BusinessDataConnection"

#: src/pages/InvitePage.tsx:726
msgid "By clicking initialize, you agree to our <0>Terms of Service</0>. <1/>PrivacyPal does not have access to your LLM prompt history."
msgstr "Al hacer clic en inicializar, aceptas nuestros <0>Términos del servicio</0>. <1/>PrivacyPal no tiene acceso al historial de prompts de tu LLM."

#: src/pages/SignupPage.tsx:512
msgid "By continuing, you agree to our <0>Terms of Service</0>."
msgstr "Al continuar, aceptas nuestros <0>Términos del servicio</0>."

#: src/pages/ConnectionsPage.tsx:904
#: src/pages/ConnectionsPage.tsx:959
msgid "Callback URL copied"
msgstr "URL de retorno copiada"

#: src/pages/ConnectionsPage.tsx:901
msgid "Callback URL to register"
msgstr "URL de retorno por registrar"

#: src/components/ConfirmationModal.tsx:49
#: src/pages/AgentsPage.tsx:923
#: src/pages/AgentsPage.tsx:980
#: src/pages/AgentsPage.tsx:1170
#: src/pages/AgentsPage.tsx:1180
#: src/pages/AgentsPage.tsx:1454
#: src/pages/ApiKeysPage.tsx:236
#: src/pages/DictionaryManagementPage.tsx:352
#: src/pages/DictionaryManagementPage.tsx:561
#: src/pages/MemoryPage.tsx:1502
#: src/pages/SubscriptionPage.tsx:384
#: src/pages/SubscriptionPage.tsx:532
#: src/pages/UserManagementPage.tsx:471
#: src/pages/UserManagementPage.tsx:472
#: src/pages/UserManagementPage.tsx:473
#: src/pages/UserManagementPage.tsx:479
msgid "Cancel"
msgstr "Cancelar"

#: src/pages/SubscriptionPage.tsx:1190
msgid "Cancel before your trial ends and you won't be charged."
msgstr "Cancela antes de que termine la prueba y no se te cobrará."

#: src/pages/SubscriptionPage.tsx:896
#: src/pages/SubscriptionPage.tsx:1046
#: src/pages/SubscriptionPage.tsx:1048
msgid "Cancel Subscription"
msgstr "Cancelar la suscripción"

#: src/pages/SubscriptionPage.tsx:1198
#: src/pages/SubscriptionPage.tsx:1216
#: src/pages/SubscriptionPage.tsx:1218
msgid "Cancel Trial"
msgstr "Cancelar la prueba"

#: src/pages/SubscriptionPage.tsx:1217
msgid "Cancel your free trial now? You'll keep access until your trial ends, and your card won't be charged."
msgstr "¿Cancelar ahora tu prueba gratis? Conservarás el acceso hasta que termine y no se cobrará tu tarjeta."

#: src/pages/SubscriptionPage.tsx:896
#: src/pages/SubscriptionPage.tsx:1198
msgid "Cancelling..."
msgstr "Cancelando..."

#: src/pages/SubscriptionPage.tsx:497
msgid "Card"
msgstr "Tarjeta"

#: src/components/UpgradeModal.tsx:259
#: src/pages/SubscriptionPage.tsx:347
msgid "Card Details"
msgstr "Datos de la tarjeta"

#: src/components/UpgradeModal.tsx:139
#: src/pages/SubscriptionPage.tsx:258
#: src/pages/SubscriptionPage.tsx:453
msgid "Card element not found"
msgstr "No se encontró el campo de la tarjeta"

#: src/pages/OnboardingPage.tsx:172
#~ msgid "Card verified today. First charge {firstChargeDate} unless cancelled."
#~ msgstr "Tarjeta verificada hoy. El primer cobro se hace el {firstChargeDate}, salvo que canceles."

#: src/pages/AgentsPage.tsx:1450
#: src/pages/DictionaryManagementPage.tsx:543
msgid "Case Sensitive"
msgstr "Distingue mayúsculas"

#: src/pages/AgentsPage.tsx:376
#: src/pages/DictionaryManagementPage.tsx:128
msgid "Catalog deleted successfully!"
msgstr "¡Catálogo eliminado!"

#: src/pages/AgentsPage.tsx:619
#: src/pages/AgentsPage.tsx:628
#: src/pages/DictionaryManagementPage.tsx:173
msgid "Catalog Management"
msgstr "Gestión de catálogos"

#: src/pages/AgentsPage.tsx:1397
#: src/pages/DictionaryManagementPage.tsx:440
msgid "Catalog Name *"
msgstr "Nombre del catálogo *"

#: src/pages/AgentsPage.tsx:1385
#: src/pages/DictionaryManagementPage.tsx:416
msgid "Catalog name is required"
msgstr "El nombre del catálogo es obligatorio"

#: src/pages/AgentsPage.tsx:364
#: src/pages/DictionaryManagementPage.tsx:106
msgid "Catalog saved successfully!"
msgstr "¡Catálogo guardado!"

#: src/pages/SubscriptionPage.tsx:515
msgid "Change"
msgstr "Cambiar"

#: src/pages/ConnectionsPage.tsx:614
msgid "ChannelMessage.Read.All, Chat.Read.All via Microsoft Graph. Requires Azure AD app with application permissions."
msgstr "ChannelMessage.Read.All y Chat.Read.All por Microsoft Graph. Requiere una app de Azure AD con permisos de aplicación."

#: src/pages/ConnectionsPage.tsx:613
msgid "channels:history, groups:history, im:history, users:read scopes. Create a Slack app with Bot Token permissions."
msgstr "Alcances channels:history, groups:history, im:history y users:read. Crea una app de Slack con permisos de Bot Token."

#: src/components/UpgradeModal.tsx:292
msgid "Charged today. No trial period. Cancel anytime; you keep the free plan."
msgstr "Se cobra hoy. Sin periodo de prueba. Cancela cuando quieras; conservas el plan gratuito."

#: src/pages/SubscriptionPage.tsx:331
msgid "Charged today. No trial period. The free plan stays yours if you ever cancel."
msgstr "Se cobra hoy. Sin periodo de prueba. Si algún día cancelas, el plan gratuito sigue siendo tuyo."

#: src/pages/DashboardPage.tsx:321
msgid "ChatGPT, Claude, Gemini, Grok and Perplexity chats are protected. Cowork, Claude Code, Codex, Copilot, agents and API traffic pass through unprotected."
msgstr "Los chats de ChatGPT, Claude, Gemini, Grok y Perplexity están protegidos. Cowork, Claude Code, Codex, Copilot, los agentes y el tráfico de API pasan sin protección."

#: src/components/UpgradeModal.tsx:388
msgid "Check code"
msgstr "Verificar código"

#: src/pages/ForgotPasswordPage.tsx:78
msgid "Check your email"
msgstr "Revisa tu correo"

#: src/pages/OnboardingPage.tsx:734
#~ msgid "Checking subscription status..."
#~ msgstr "Verificando el estado de la suscripción..."

#: src/pages/ResetPasswordPage.tsx:142
msgid "Checking your reset link…"
msgstr "Verificando tu enlace de restablecimiento…"

#: src/components/UpgradeModal.tsx:388
msgid "Checking..."
msgstr "Verificando..."

#: src/pages/ResetPasswordPage.tsx:180
msgid "Choose a new password"
msgstr "Elige una contraseña nueva"

#: src/pages/SubscriptionPage.tsx:406
#~ msgid "Choose your plan"
#~ msgstr "Elige tu plan"

#: src/pages/SignupPage.tsx:615
#~ msgid "Choose Your Plan"
#~ msgstr "Elige tu plan"

#: src/pages/SubscriptionPage.tsx:1180
msgid "Choose your plan for unlimited access"
msgstr "Elige tu plan y obtén acceso ilimitado"

#: src/pages/InvitePage.tsx:617
msgid "Claim Your Invite"
msgstr "Reclama tu invitación"

#: src/components/connections/ConnectionCard.tsx:47
msgid "Click to connect"
msgstr "Haz clic para conectar"

#: src/pages/ConnectionsPage.tsx:968
#: src/pages/PrivateMcpPage.tsx:1133
#: src/pages/PrivateMcpPage.tsx:1210
msgid "Client ID"
msgstr "ID de cliente"

#: src/pages/ConnectionsPage.tsx:972
#: src/pages/PrivateMcpPage.tsx:1025
#: src/pages/PrivateMcpPage.tsx:1146
#: src/pages/PrivateMcpPage.tsx:1220
msgid "Client secret"
msgstr "Secreto del cliente"

#: src/components/Layout.tsx:526
#: src/components/Layout.tsx:546
#: src/components/Layout.tsx:760
#: src/pages/AgentsPage.tsx:731
#: src/pages/DictionaryManagementPage.tsx:286
msgid "Close"
msgstr "Cerrar"

#: src/components/Layout.tsx:437
msgid "Close menu"
msgstr "Cerrar el menú"

#: src/components/Layout.tsx:739
msgid "Close other AI apps if the installer prompts you. PrivacyPal hooks in at the system edge for full coverage."
msgstr "Cierra las demás apps de IA si el instalador te lo pide. PrivacyPal se engancha en el borde del sistema para dar cobertura total."

#: src/components/ProviderDetailModal.tsx:261
msgid "Close report"
msgstr "Cerrar el informe"

#: src/pages/SalesforceOAuthCallbackPage.tsx:72
msgid "Close window"
msgstr "Cerrar la ventana"

#. placeholder {0}: maxPromo.code
#: src/pages/SignupPage.tsx:650
msgid "Code {0} applied for as long as you stay."
msgstr "Código {0} aplicado mientras sigas con nosotros."

#. placeholder {0}: maxPromo.code
#. placeholder {1}: maxPromoDuration.months
#: src/pages/SignupPage.tsx:646
msgid "Code {0} applied for your first {1} months."
msgstr "Código {0} aplicado tus primeros {1} meses."

#. placeholder {0}: maxPromo.code
#: src/pages/SignupPage.tsx:648
msgid "Code {0} applied to your first month."
msgstr "Código {0} aplicado a tu primer mes."

#. placeholder {0}: maxPromo.code
#: src/pages/SignupPage.tsx:652
msgid "Code {0} applied."
msgstr "Código {0} aplicado."

#. placeholder {0}: maxPromo.code
#. placeholder {1}: maxPricing.perSeatLabel
#. placeholder {2}: maxPricing.listLabel
#: src/pages/SignupPage.tsx:435
msgid "Code <0>{0}</0> is live: PrivacyPal Max at {1}/seat/mo instead of {2}. Create your account and it carries through to checkout."
msgstr "El código <0>{0}</0> está activo: PrivacyPal Max a {1}/puesto/mes en vez de {2}. Crea tu cuenta y el código sigue contigo hasta el pago."

#. placeholder {0}: registerTrial.code
#. placeholder {1}: registerTrial.trialDays
#: src/pages/SignupPage.tsx:576
msgid "Code <0>{0}</0> switched PrivacyPal Max on for your whole company for {1} days. No card was taken and there is nothing to cancel: when the trial ends your team moves to Pro."
msgstr "El código <0>{0}</0> activó PrivacyPal Max para toda tu empresa durante {1} días. No cobramos ninguna tarjeta y no hay nada que cancelar: cuando termine la prueba, tu equipo pasa a Pro."

#. placeholder {0}: registerTrial?.code
#: src/pages/SignupPage.tsx:580
msgid "Code <0>{0}</0> switched PrivacyPal Max on for your whole company. No card was taken and there is nothing to cancel: when the trial ends your team moves to Pro."
msgstr "El código <0>{0}</0> activó PrivacyPal Max para toda tu empresa. No cobramos ninguna tarjeta y no hay nada que cancelar: cuando termine la prueba, tu equipo pasa a Pro."

#: src/pages/MemoryPage.tsx:113
msgid "Coding"
msgstr "Programación"

#: src/pages/ConnectionsPage.tsx:610
msgid "Collaboration Tools"
msgstr "Herramientas de colaboración"

#: src/pages/ConnectionsPage.tsx:764
msgid "Collapse"
msgstr "Contraer"

#: src/components/Layout.tsx:306
msgid "Company Member"
msgstr "Integrante de la empresa"

#: src/pages/SubscriptionPage.tsx:1123
msgid "Company Subscription"
msgstr "Suscripción de la empresa"

#: src/components/UpgradeModal.tsx:650
msgid "Company-wide trial"
msgstr "Prueba para toda la empresa"

#: src/pages/ConnectionsPage.tsx:549
msgid "Complete"
msgstr "Completo"

#: src/pages/ConnectionsPage.tsx:424
msgid "Complete {serviceName} authentication before saving configuration."
msgstr "Completa la autenticación de {serviceName} antes de guardar la configuración."

#: src/pages/ConnectionsPage.tsx:392
#~ msgid "Complete Salesforce authentication before saving configuration."
#~ msgstr "Completa la autenticación con Salesforce antes de guardar la configuración."

#: src/pages/SignupPage.tsx:178
#~ msgid "Complete Signup"
#~ msgstr "Completar el registro"

#: src/pages/AuthCallbackPage.tsx:172
msgid "Completing authentication..."
msgstr "Completando la autenticación..."

#: src/pages/OnboardingPage.tsx:319
msgid "Compliance checklists are reactive. Privacy Engineering is proactive: automated agents embedded across your stack that intercept sensitive data before it ever reaches an AI."
msgstr "Las listas de cumplimiento son reactivas. La ingeniería de privacidad es proactiva: agentes automáticos integrados en todo tu stack que interceptan los datos sensibles antes de que lleguen a una IA."

#: src/pages/ConnectionsPage.tsx:549
msgid "Configure"
msgstr "Configurar"

#: src/pages/OnboardingPage.tsx:508
msgid "Configuring your protection layer. This takes just a moment."
msgstr "Configurando tu capa de protección. Toma solo un momento."

#: src/components/ConfirmationModal.tsx:55
msgid "Confirm"
msgstr "Confirmar"

#: src/pages/ResetPasswordPage.tsx:231
msgid "Confirm new password"
msgstr "Confirma la contraseña nueva"

#: src/pages/InvitePage.tsx:710
#: src/pages/SignupPage.tsx:505
msgid "Confirm Password"
msgstr "Confirmar la contraseña"

#: src/components/connections/ConnectionCard.tsx:52
msgid "Connect"
msgstr "Conectar"

#: src/App.tsx:196
msgid "Connect Salesforce, HubSpot, Notion, and other business systems so your AI works on Privacy Twins, never the real records."
msgstr "Conecta Salesforce, HubSpot, Notion y otros sistemas de tu empresa para que tu IA trabaje con Privacy Twins, nunca con los registros reales."

#: src/App.tsx:196
#~ msgid "Connect Salesforce, Notion, and other business systems so your AI works on Privacy Twins, never the real records."
#~ msgstr "Conecta Salesforce, Notion y otros sistemas de tu empresa para que tu IA trabaje sobre los valores sintéticos y nunca sobre los registros reales."

#: src/pages/ConnectionsPage.tsx:678
msgid "Connect third-party services to enable PrivacyPal to scan and protect sensitive data across your organization."
msgstr "Conecta servicios de terceros para que PrivacyPal analice y proteja los datos sensibles de toda tu organización."

#: src/pages/ConnectionsPage.tsx:604
msgid "Connect to Dropbox Business to monitor shared files, Paper documents, and team folders."
msgstr "Conéctate a Dropbox Business para monitorear archivos compartidos, documentos de Paper y carpetas de equipo."

#: src/pages/ConnectionsPage.tsx:600
msgid "Connect to Google Drive to scan documents, spreadsheets, and presentations stored in your organization's workspace."
msgstr "Conéctate a Google Drive para analizar documentos, hojas de cálculo y presentaciones guardados en el espacio de trabajo de tu organización."

#: src/pages/ConnectionsPage.tsx:649
msgid "Connect to Microsoft SQL Server instances to catalog and scan database content for PII."
msgstr "Conéctate a instancias de Microsoft SQL Server para catalogar y analizar el contenido de las bases de datos en busca de PII."

#: src/pages/ConnectionsPage.tsx:651
msgid "Connect to MySQL or MariaDB instances to identify and catalog sensitive data across tables."
msgstr "Conéctate a instancias de MySQL o MariaDB para identificar y catalogar datos sensibles en las tablas."

#: src/pages/ConnectionsPage.tsx:602
msgid "Connect to Notion workspaces to scan pages, databases, and embedded content for sensitive data."
msgstr "Conéctate a espacios de Notion para analizar páginas, bases de datos y contenido incrustado en busca de datos sensibles."

#: src/pages/ConnectionsPage.tsx:615
msgid "Connect to Telegram groups and channels used by your organization to detect sensitive data sharing."
msgstr "Conéctate a los grupos y canales de Telegram que usa tu organización para detectar el envío de datos sensibles."

#: src/pages/ConnectionsPage.tsx:1092
msgid "Connect with HubSpot"
msgstr "Conectar con HubSpot"

#: src/pages/ConnectionsPage.tsx:1088
msgid "Connect with Salesforce"
msgstr "Conectar con Salesforce"

#: src/pages/PrivateMcpPage.tsx:895
msgid "Connect your assistant to Gmail and Google Drive through Privacy Twins"
msgstr "Conecte su asistente a Gmail y Google Drive a través de Privacy Twins"

#: src/pages/PrivateMcpPage.tsx:1087
msgid "Connect your assistant to HubSpot's MCP server through Privacy Twins"
msgstr "Conecta tu asistente al servidor MCP de HubSpot a través de Privacy Twins"

#: src/pages/PrivateMcpPage.tsx:733
msgid "Connect your assistant to Outlook mail and OneDrive files through Privacy Twins"
msgstr "Conecta tu asistente al correo de Outlook y a los archivos de OneDrive mediante valores sintéticos"

#: src/pages/PrivateMcpPage.tsx:556
msgid "Connect your assistant to Salesforce through Privacy Twins"
msgstr "Conecta tu asistente a Salesforce por medio de los valores sintéticos"

#: src/components/connections/ConnectionHealthPanel.tsx:64
msgid "Connected"
msgstr "Conectado"

#: src/pages/ConnectionsPage.tsx:916
msgid "Connected App Consumer Key"
msgstr "Consumer Key de la Connected App"

#: src/pages/ConnectionsPage.tsx:925
msgid "Connected App Consumer Secret"
msgstr "Consumer Secret de la Connected App"

#: src/pages/PrivateMcpPage.tsx:1292
msgid "Connected users"
msgstr "Usuarios conectados"

#: src/pages/PrivateMcpPage.tsx:1371
msgid "Connected users are visible to administrators only."
msgstr "Los usuarios conectados solo son visibles para los administradores."

#: src/pages/ConnectionsPage.tsx:1227
msgid "Connection Failed"
msgstr "Falló la conexión"

#. placeholder {0}: revokeTarget.email || revokeTarget.userId
#: src/pages/PrivateMcpPage.tsx:498
msgid "Connection revoked for {0}"
msgstr "Conexión revocada para {0}"

#: src/pages/ConnectionsPage.tsx:1212
msgid "Connection Verified"
msgstr "Conexión verificada"

#: src/components/Layout.tsx:223
#: src/pages/ConnectionsPage.tsx:676
msgid "Connections"
msgstr "Conexiones"

#: src/pages/SubscriptionPage.tsx:789
msgid "Connections, Private MCP and API access"
msgstr "Connections, Private MCP y acceso a la API"

#: src/pages/PrivateMcpPage.tsx:1329
msgid "Connector"
msgstr "Conector"

#: src/pages/PrivateMcpPage.tsx:569
#: src/pages/PrivateMcpPage.tsx:746
#: src/pages/PrivateMcpPage.tsx:908
#: src/pages/PrivateMcpPage.tsx:1100
msgid "Connector URL"
msgstr "URL del conector"

#: src/pages/PrivateMcpPage.tsx:321
msgid "Connector URL copied to clipboard"
msgstr "URL del conector copiada al portapapeles"

#: src/pages/ConnectionsPage.tsx:915
#: src/pages/PrivateMcpPage.tsx:613
#: src/pages/PrivateMcpPage.tsx:673
msgid "Consumer Key"
msgstr "Consumer Key"

#: src/pages/ConnectionsPage.tsx:919
msgid "Consumer Secret"
msgstr "Consumer Secret"

#: src/pages/AgentsPage.tsx:1445
#: src/pages/DictionaryManagementPage.tsx:527
msgid "Context Words (Optional)"
msgstr "Palabras de contexto (opcional)"

#: src/pages/InvitePage.tsx:523
msgid "Context-aware masking"
msgstr "Enmascaramiento sensible al contexto"

#: src/pages/ConnectionsPage.tsx:1095
#: src/pages/ConnectionsPage.tsx:1097
#: src/pages/OnboardingPage.tsx:306
#: src/pages/OnboardingPage.tsx:416
#: src/pages/OnboardingPage.tsx:467
#: src/pages/SignupPage.tsx:509
#: src/pages/UserManagementPage.tsx:472
#: src/pages/UserManagementPage.tsx:473
msgid "Continue"
msgstr "Continuar"

#: src/pages/SignupPage.tsx:665
#~ msgid "Continue to Payment"
#~ msgstr "Continuar al pago"

#: src/components/UpgradeModal.tsx:449
msgid "Continue with a card"
msgstr "Continuar con tarjeta"

#: src/pages/LoginPage.tsx:355
msgid "Continue with Google"
msgstr "Continuar con Google"

#: src/pages/LoginPage.tsx:369
msgid "Continue with Microsoft"
msgstr "Continuar con Microsoft"

#: src/pages/UserDetailAuditPage.tsx:951
msgid "Conversation Details"
msgstr "Detalles de la conversación"

#: src/pages/UserDetailAuditPage.tsx:963
msgid "Conversation History ({detailPromptCount} prompts)"
msgstr "Historial de la conversación ({detailPromptCount} prompts)"

#: src/components/Layout.tsx:150
msgid "Copied to clipboard"
msgstr "Copiado al portapapeles"

#: src/components/Layout.tsx:622
#: src/components/Layout.tsx:726
#: src/pages/ConnectionsPage.tsx:904
#: src/pages/ConnectionsPage.tsx:959
msgid "Copy"
msgstr "Copiar"

#: src/pages/PrivateMcpPage.tsx:63
msgid "Copy connector URL to clipboard"
msgstr "Copiar la URL del conector al portapapeles"

#: src/pages/ApiKeysPage.tsx:262
msgid "Copy this key now. For security, it will not be displayed again."
msgstr "Copia esta llave ahora. Por seguridad, no se volverá a mostrar."

#: src/components/Layout.tsx:508
msgid "Copy to clipboard"
msgstr "Copiar al portapapeles"

#: src/pages/MemoryPage.tsx:753
msgid "Correct"
msgstr "Corregir"

#: src/pages/MemoryPage.tsx:1485
msgid "Correct this memory"
msgstr "Corregir este recuerdo"

#: src/pages/InvitePage.tsx:116
#: src/pages/LoginPage.tsx:87
#: src/pages/SignupPage.tsx:222
msgid "Could not send a verification code"
msgstr "No se pudo enviar el código de verificación"

#: src/pages/OnboardingPage.tsx:122
#~ msgid "Could not validate promo code"
#~ msgstr "No se pudo validar el código promocional"

#: src/pages/ConnectionsPage.tsx:953
msgid "Create a HubSpot app with OAuth authentication (a project app with private distribution is enough for your own account), add the exact callback URL below as a redirect URL, and set the required and optional scopes shown. Then paste the app's Client ID and Client secret. You install the app into your HubSpot account in a popup; tokens are exchanged server-side and stored encrypted."
msgstr "Crea una app de HubSpot con autenticación OAuth (para tu propia cuenta basta una app de proyecto con distribución privada), agrega la URL de retorno exacta de abajo como URL de redirección y configura los alcances obligatorios y opcionales que se muestran. Luego pega el Client ID y el Client secret de la app. Instalas la app en tu cuenta de HubSpot en una ventana emergente; los tokens se intercambian en el servidor y se guardan cifrados."

#: src/pages/ConnectionsPage.tsx:998
msgid "Create a service key (Development, then Keys) or a legacy private app in your HubSpot account with the read scopes crm.objects.contacts.read, crm.objects.companies.read and crm.objects.deals.read. Paste its access token here. The token is verified with one read before the connection is saved."
msgstr "Crea una service key (Development y luego Keys) o una app privada heredada en tu cuenta de HubSpot con los alcances de lectura crm.objects.contacts.read, crm.objects.companies.read y crm.objects.deals.read. Pega aquí su token de acceso. El token se verifica con una lectura antes de guardar la conexión."

#: src/pages/LoginPage.tsx:166
#: src/pages/LoginPage.tsx:331
msgid "Create Account"
msgstr "Crear cuenta"

#: src/pages/AgentsPage.tsx:929
msgid "Create Agent"
msgstr "Crear agente"

#: src/pages/ConnectionsPage.tsx:953
#~ msgid "Create an app in HubSpot with OAuth authentication, add the exact callback URL below as a redirect URL, and set the required and optional scopes shown. Then paste the app's Client ID and Client secret. You install the app into your HubSpot account in a popup; tokens are exchanged server-side and stored encrypted."
#~ msgstr ""

#: src/pages/ConnectionsPage.tsx:998
#~ msgid "Create an app in your HubSpot account with static access-token authentication (a private app) and the read scopes crm.objects.contacts.read, crm.objects.companies.read and crm.objects.deals.read. Paste its access token here. The token is verified with one read before the connection is saved."
#~ msgstr ""

#: src/pages/AgentsPage.tsx:1394
#: src/pages/DictionaryManagementPage.tsx:435
msgid "Create New Catalog"
msgstr "Crear catálogo"

#: src/pages/SignupPage.tsx:426
msgid "Create Your Account"
msgstr "Crea tu cuenta"

#: src/pages/ApiKeysPage.tsx:138
msgid "Created"
msgstr "Creado"

#: src/pages/MemoryPage.tsx:120
msgid "Creative"
msgstr "Creatividad"

#: src/pages/ConnectionsPage.tsx:621
msgid "CRM & Business Systems"
msgstr "CRM y sistemas del negocio"

#: src/pages/UserDetailAuditPage.tsx:538
msgid "CSV report downloaded ({days} days)"
msgstr "Informe CSV descargado ({days} días)"

#: src/pages/MemoryPage.tsx:127
msgid "Current focus"
msgstr "Enfoque actual"

#: src/pages/DashboardPage.tsx:374
#: src/pages/SubscriptionPage.tsx:766
msgid "Current Plan"
msgstr "Plan actual"

#: src/pages/SubscriptionPage.tsx:876
msgid "Current Subscription"
msgstr "Suscripción actual"

#: src/pages/AgentsPage.tsx:1405
#: src/pages/DictionaryManagementPage.tsx:463
msgid "Custom Company Term"
msgstr "Término propio de la empresa"

#: src/pages/AgentsPage.tsx:1406
#: src/pages/DictionaryManagementPage.tsx:464
msgid "Custom PII"
msgstr "PII personalizada"

#: src/pages/AgentsPage.tsx:1404
#: src/pages/DictionaryManagementPage.tsx:462
msgid "Custom Term"
msgstr "Término personalizado"

#: src/pages/ConnectionsPage.tsx:1107
msgid "Customize how PrivacyPal scans and processes data from this connection."
msgstr "Personaliza cómo PrivacyPal analiza y procesa los datos de esta conexión."

#: src/components/ProviderDetailModal.tsx:302
msgid "Daily prompts by tool"
msgstr "Prompts diarios por herramienta"

#: src/pages/ConnectionsPage.tsx:1064
msgid "Database"
msgstr "Base de datos"

#: src/pages/ConnectionsPage.tsx:1074
msgid "Database password"
msgstr "Contraseña de la base de datos"

#: src/pages/ConnectionsPage.tsx:1070
msgid "Database username"
msgstr "Usuario de la base de datos"

#: src/pages/ConnectionsPage.tsx:646
msgid "Databases"
msgstr "Bases de datos"

#: src/pages/AgentsPage.tsx:606
#: src/pages/AgentsPage.tsx:692
#: src/pages/AgentsPage.tsx:718
#: src/pages/AgentsPage.tsx:1169
#: src/pages/AgentsPage.tsx:1179
#: src/pages/DictionaryManagementPage.tsx:235
#: src/pages/DictionaryManagementPage.tsx:271
#: src/pages/DictionaryManagementPage.tsx:351
msgid "Delete"
msgstr "Eliminar"

#: src/pages/AgentsPage.tsx:1167
msgid "Delete Agent"
msgstr "Eliminar el agente"

#: src/pages/AgentsPage.tsx:1177
#: src/pages/DictionaryManagementPage.tsx:349
msgid "Delete Catalog"
msgstr "Eliminar el catálogo"

#: src/pages/UserManagementPage.tsx:462
msgid "Demote"
msgstr "Bajar de rol"

#: src/pages/UserManagementPage.tsx:375
msgid "Demote to Member"
msgstr "Bajar a integrante"

#: src/pages/UserManagementPage.tsx:473
msgid "Demote User to Member"
msgstr "Bajar al usuario a integrante"

#: src/pages/AgentsPage.tsx:673
#: src/pages/DictionaryManagementPage.tsx:209
msgid "Deny List"
msgstr "Lista de bloqueo"

#. placeholder {0}: selectedDictionary.deny_list.length
#: src/pages/AgentsPage.tsx:753
#: src/pages/DictionaryManagementPage.tsx:317
msgid "Deny List ({0})"
msgstr "Lista de bloqueo ({0})"

#: src/pages/AgentsPage.tsx:1429
#: src/pages/DictionaryManagementPage.tsx:500
msgid "Deny List (Terms to exclude from detection)"
msgstr "Lista de bloqueo (términos que se excluyen de la detección)"

#: src/pages/AgentsPage.tsx:862
msgid "Describe what this agent should do..."
msgstr "Describe lo que debe hacer este agente..."

#: src/pages/DashboardPage.tsx:638
#: src/pages/DashboardPage.tsx:700
msgid "Details"
msgstr "Detalles"

#: src/pages/UserDetailAuditPage.tsx:1103
msgid "Detected Entity Types"
msgstr "Tipos de entidad detectados"

#: src/pages/OnboardingPage.tsx:433
msgid "Developer"
msgstr "Desarrollador"

#: src/pages/ApiKeysPage.tsx:92
msgid "Developer API Keys"
msgstr "Llaves de API para desarrolladores"

#: src/App.tsx:183
msgid "Developer keys for the PrivacyPal API and SDK: encode, decode and batch protection inside your own tools and pipelines."
msgstr "Llaves de desarrollador para la API y el SDK de PrivacyPal: protección de codificación, decodificación y lotes dentro de tus propias herramientas y pipelines."

#: src/pages/AgentsPage.tsx:1446
#: src/pages/DictionaryManagementPage.tsx:537
msgid "diagnosis, condition, disease (comma-separated)"
msgstr "diagnóstico, condición, enfermedad (separados por comas)"

#: src/pages/ForgotPasswordPage.tsx:88
msgid "Didn't get it? Check your spam folder, or resend below."
msgstr "¿No te llegó? Revisa la carpeta de spam o vuelve a enviarlo abajo."

#: src/pages/ConnectionsPage.tsx:1216
msgid "Direct Connection"
msgstr "Conexión directa"

#: src/pages/PrivateMcpPage.tsx:777
#: src/pages/PrivateMcpPage.tsx:833
msgid "Directory (tenant) ID"
msgstr "ID de directorio (tenant)"

#: src/pages/AgentsPage.tsx:684
#: src/pages/AgentsPage.tsx:709
#: src/pages/DictionaryManagementPage.tsx:224
#: src/pages/DictionaryManagementPage.tsx:259
msgid "Disabled"
msgstr "Deshabilitado"

#: src/components/connections/ConnectionActions.tsx:39
#: src/components/connections/ConnectionActions.tsx:61
msgid "Disconnect"
msgstr "Desconectar"

#: src/pages/SignupPage.tsx:656
#~ msgid "Discount applied"
#~ msgstr "Descuento aplicado"

#: src/pages/SubscriptionPage.tsx:982
msgid "Discount applied to your subscription"
msgstr "Descuento aplicado a tu suscripción"

#. placeholder {0}: new Date(subscriptionDetails.discount.end).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })
#: src/pages/SubscriptionPage.tsx:954
msgid "Discount expires {0}"
msgstr "El descuento vence el {0}"

#: src/pages/ConnectionsPage.tsx:597
msgid "Document Repositories"
msgstr "Repositorios de documentos"

#: src/pages/LoginPage.tsx:386
msgid "Don't have an account? Sign up"
msgstr "¿No tienes cuenta? Regístrate"

#: src/pages/AgentsPage.tsx:935
#: src/pages/ApiKeysPage.tsx:293
#: src/pages/ConnectionsPage.tsx:1219
msgid "Done"
msgstr "Listo"

#: src/pages/UserManagementPage.tsx:359
#: src/pages/UserManagementPage.tsx:442
#: src/pages/UserManagementPage.tsx:478
msgid "Downgrade to Pro"
msgstr "Bajar a Pro"

#: src/pages/UserManagementPage.tsx:476
msgid "Downgrade User to Pro"
msgstr "Bajar al usuario a Pro"

#: src/pages/UserDetailAuditPage.tsx:783
msgid "Download audit data as CSV"
msgstr "Descargar los datos de auditoría en CSV"

#: src/components/Layout.tsx:656
msgid "Download for Apple Silicon"
msgstr "Descargar para Apple Silicon"

#: src/components/Layout.tsx:710
msgid "Download for ARM64"
msgstr "Descargar para ARM64"

#: src/components/Layout.tsx:601
msgid "Download for Windows"
msgstr "Descargar para Windows"

#: src/components/Layout.tsx:701
msgid "Download for x86_64"
msgstr "Descargar para x86_64"

#: src/components/Layout.tsx:362
#: src/components/Layout.tsx:471
msgid "Download Now"
msgstr "Descargar ahora"

#: src/components/Layout.tsx:540
msgid "Download PrivacyPal"
msgstr "Descargar PrivacyPal"

#: src/components/Layout.tsx:349
msgid "Download PrivacyPal for desktop"
msgstr "Descargar PrivacyPal para computador"

#: src/pages/AgentsPage.tsx:1094
msgid "Duration:"
msgstr "Duración:"

#: src/pages/UserDetailAuditPage.tsx:702
msgid "e.g. 'Summarize data exfiltration risks'"
msgstr "p. ej. «Resume los riesgos de exfiltración de datos»"

#: src/pages/ConnectionsPage.tsx:1061
msgid "e.g. 5432"
msgstr "p. ej. 5432"

#: src/pages/ConnectionsPage.tsx:1056
msgid "e.g. db.example.com"
msgstr "p. ej. db.example.com"

#: src/pages/MemoryPage.tsx:1099
msgid "e.g. I prefer short answers with a summary first"
msgstr "p. ej. Prefiero respuestas cortas con un resumen primero"

#: src/pages/AgentsPage.tsx:834
msgid "e.g. Location Sharing Guard"
msgstr "p. ej. Guardia de ubicación compartida"

#: src/pages/ConnectionsPage.tsx:1065
msgid "e.g. mydb"
msgstr "p. ej. mibd"

#: src/pages/ApiKeysPage.tsx:223
msgid "e.g. Production Backend, Staging App"
msgstr "p. ej. Backend de producción, App de pruebas"

#: src/pages/InvitePage.tsx:494
msgid "Early Beta Release"
msgstr "Versión beta temprana"

#: src/pages/AgentsPage.tsx:600
#: src/pages/AgentsPage.tsx:691
#: src/pages/AgentsPage.tsx:717
#: src/pages/AgentsPage.tsx:732
#: src/pages/DictionaryManagementPage.tsx:232
#: src/pages/DictionaryManagementPage.tsx:268
#: src/pages/DictionaryManagementPage.tsx:289
msgid "Edit"
msgstr "Editar"

#. placeholder {0}: dictionary.name
#: src/pages/AgentsPage.tsx:1394
#: src/pages/DictionaryManagementPage.tsx:435
msgid "Edit: {0}"
msgstr "Editar: {0}"

#: src/pages/AgentsPage.tsx:790
msgid "Edit: {editingAgentOriginalName}"
msgstr "Editar: {editingAgentOriginalName}"

#: src/pages/MemoryPage.tsx:118
msgid "Education"
msgstr "Educación"

#: src/pages/ApiKeysPage.tsx:136
msgid "Elements Protected"
msgstr "Elementos protegidos"

#: src/pages/ForgotPasswordPage.tsx:126
#: src/pages/LoginPage.tsx:288
msgid "Email"
msgstr "Correo"

#: src/pages/SignupPage.tsx:196
msgid "Email is required"
msgstr "El correo es obligatorio"

#: src/pages/VerifyEmailPage.tsx:97
msgid "Email verified"
msgstr "Correo verificado"

#: src/pages/ConnectionsPage.tsx:1187
msgid "Enable deep content scanning (adds some additional latency)"
msgstr "Habilitar el análisis profundo de contenido (agrega algo de latencia)"

#: src/pages/AgentsPage.tsx:485
#: src/pages/AgentsPage.tsx:684
#: src/pages/AgentsPage.tsx:709
#: src/pages/AgentsPage.tsx:741
#: src/pages/AgentsPage.tsx:896
#: src/pages/AgentsPage.tsx:1411
#: src/pages/DictionaryManagementPage.tsx:224
#: src/pages/DictionaryManagementPage.tsx:259
#: src/pages/DictionaryManagementPage.tsx:300
#: src/pages/DictionaryManagementPage.tsx:470
msgid "Enabled"
msgstr "Habilitado"

#: src/pages/ResetPasswordPage.tsx:182
msgid "Enter and confirm your new password below."
msgstr "Escribe y confirma tu contraseña nueva aquí abajo."

#: src/pages/OnboardingPage.tsx:182
#~ msgid "Enter code"
#~ msgstr "Escribe el código"

#: src/pages/SignupPage.tsx:638
#~ msgid "Enter code (optional)"
#~ msgstr "Escribe el código (opcional)"

#: src/pages/SubscriptionPage.tsx:374
msgid "Enter promo code"
msgstr "Escribe el código promocional"

#: src/pages/ConnectionsPage.tsx:1182
msgid ""
"Enter table names to exclude, separated by commas\n"
"e.g. _migrations, sessions, cache"
msgstr ""
"Escribe los nombres de las tablas por excluir, separados por comas\n"
"p. ej. _migrations, sessions, cache"

#: src/pages/AuthCallbackPage.tsx:90
#: src/pages/InvitePage.tsx:123
#: src/pages/LoginPage.tsx:100
#: src/pages/SignupPage.tsx:230
msgid "Enter the 6-digit code from the email."
msgstr "Escribe el código de 6 dígitos que llegó al correo."

#: src/pages/ConnectionsPage.tsx:1035
msgid "Enter your API key"
msgstr "Escribe tu llave de API"

#: src/pages/ConnectionsPage.tsx:601
#: src/pages/ConnectionsPage.tsx:614
msgid "Enter your Azure AD application client secret"
msgstr "Escribe el client secret de tu aplicación de Azure AD"

#: src/pages/InvitePage.tsx:618
msgid "Enter your details to activate your private instance of PrivacyPal."
msgstr "Escribe tus datos para activar tu instancia privada de PrivacyPal."

#: src/pages/SignupPage.tsx:427
msgid "Enter your details to get started with PrivacyPal."
msgstr "Escribe tus datos para empezar con PrivacyPal."

#: src/pages/ForgotPasswordPage.tsx:115
msgid "Enter your email address and we'll send you a link to reset it."
msgstr "Escribe tu correo y te enviaremos un enlace para restablecerla."

#: src/pages/PrivateMcpPage.tsx:129
msgid "Enter your Google Workspace domain on its own, such as example.com."
msgstr "Escriba solo el dominio de su Google Workspace, por ejemplo example.com."

#: src/pages/PrivateMcpPage.tsx:144
msgid "Enter your HubSpot account ID as digits only, as shown in the account menu in HubSpot."
msgstr "Escribe el ID de tu cuenta de HubSpot solo con dígitos, como aparece en el menú de la cuenta en HubSpot."

#: src/pages/ConnectionsPage.tsx:616
msgid "Enter your Mattermost personal access token"
msgstr "Escribe tu token de acceso personal de Mattermost"

#: src/pages/ConnectionsPage.tsx:605
msgid "Enter your NetDocuments client ID and secret separated by a colon"
msgstr "Escribe el client ID y el secret de NetDocuments separados por dos puntos"

#: src/pages/MemoryPage.tsx:951
msgid "Entities linked"
msgstr "Entidades enlazadas"

#: src/pages/AgentsPage.tsx:670
#: src/pages/AgentsPage.tsx:737
#: src/pages/DictionaryManagementPage.tsx:206
#: src/pages/DictionaryManagementPage.tsx:296
msgid "Entity Type"
msgstr "Tipo de entidad"

#: src/pages/AgentsPage.tsx:1401
#: src/pages/DictionaryManagementPage.tsx:453
msgid "Entity Type *"
msgstr "Tipo de entidad *"

#: src/pages/MemoryPage.tsx:1517
msgid "Erase all memory?"
msgstr "¿Borrar toda la memoria?"

#: src/pages/MemoryPage.tsx:1471
#: src/pages/MemoryPage.tsx:1519
msgid "Erase everything"
msgstr "Borrar todo"

#: src/pages/MemoryPage.tsx:1447
msgid "Erasing destroys the encryption keys that make your memory readable: every copy, including exports and synced devices, becomes meaningless. It cannot be undone."
msgstr "Borrar destruye las llaves de cifrado que hacen legible tu memoria: cada copia, incluidas las exportaciones y los dispositivos sincronizados, queda sin sentido. No se puede deshacer."

#: src/pages/ConnectionsPage.tsx:1204
msgid "Establishing connection..."
msgstr "Estableciendo la conexión..."

#: src/pages/SignupPage.tsx:675
msgid "Evaluating Max for a team? <0>Book a trial call</0> and we will issue a code."
msgstr "¿Estás evaluando Max para un equipo? <0>Agenda una llamada de prueba</0> y te emitimos un código."

#: src/pages/MemoryPage.tsx:103
msgid "Event"
msgstr "Evento"

#: src/pages/UserDetailAuditPage.tsx:949
msgid "Event Details #{eventIdSuffix}"
msgstr "Detalles del evento n.º {eventIdSuffix}"

#: src/pages/MemoryPage.tsx:1538
msgid "Every memory filed under this topic is deleted. This cannot be undone."
msgstr "Se eliminan todos los recuerdos archivados bajo este tema. Esto no se puede deshacer."

#: src/pages/MemoryPage.tsx:1528
msgid "Every memory that mentions them is deleted, along with the entity itself. This cannot be undone."
msgstr "Se eliminan todos los recuerdos que lo mencionan, junto con la entidad misma. Esto no se puede deshacer."

#: src/pages/OnboardingPage.tsx:275
msgid "Every time your team uses an LLM (ChatGPT, Copilot, Claude), a piece of your IP, your client data, your trade secrets quietly walks out the door."
msgstr "Cada vez que tu equipo usa un LLM (ChatGPT, Copilot, Claude), una parte de tu propiedad intelectual, de los datos de tus clientes y de tus secretos comerciales se va en silencio."

#. placeholder {0}: entity.displayValue
#: src/pages/MemoryPage.tsx:498
msgid "Everything about {0} was forgotten"
msgstr "Se olvidó todo sobre {0}"

#: src/pages/MemoryPage.tsx:365
msgid "Everything about this topic was forgotten"
msgstr "Se olvidó todo sobre este tema"

#: src/pages/MemoryPage.tsx:1179
msgid "Everything else"
msgstr "Todo lo demás"

#: src/pages/SignupPage.tsx:658
msgid "Everything in Pro, plus protection for Cowork, Claude Code, Codex, Copilot, agents and the APIs, with Connections, Private MCP, API access, team seats and full usage history."
msgstr "Todo lo de Pro, más protección para Cowork, Claude Code, Codex, Copilot, agentes y las API, con Connections, Private MCP, acceso a la API, puestos de equipo e historial de uso completo."

#: src/pages/SignupPage.tsx:587
msgid "Everything is unlocked: Cowork, Claude Code, Codex, Copilot, agents and the APIs, plus Connections, Private MCP, API access, team seats and full usage history."
msgstr "Todo queda desbloqueado: Cowork, Claude Code, Codex, Copilot, agentes y las API, además de Connections, Private MCP, acceso a la API, puestos de equipo e historial de uso completo."

#: src/pages/MemoryPage.tsx:732
msgid "Evidence"
msgstr "Evidencia"

#: src/pages/ConnectionsPage.tsx:1146
msgid "Excluded HubSpot properties"
msgstr "Propiedades de HubSpot excluidas"

#: src/pages/ConnectionsPage.tsx:1161
msgid "Excluded Salesforce fields"
msgstr "Campos de Salesforce excluidos"

#: src/pages/ConnectionsPage.tsx:1177
msgid "Excluded Table Names"
msgstr "Nombres de tablas excluidas"

#: src/pages/AgentsPage.tsx:990
msgid "Execute Agent"
msgstr "Ejecutar el agente"

#: src/pages/AgentsPage.tsx:1064
msgid "Execution Complete"
msgstr "Ejecución completada"

#: src/pages/AgentsPage.tsx:294
msgid "Execution failed"
msgstr "Falló la ejecución"

#: src/pages/AgentsPage.tsx:1073
msgid "Execution Failed"
msgstr "Falló la ejecución"

#: src/pages/AgentsPage.tsx:1134
msgid "Execution History"
msgstr "Historial de ejecuciones"

#: src/pages/ConnectionsPage.tsx:764
msgid "Expand"
msgstr "Expandir"

#. placeholder {0}: subscriptionDetails.paymentMethod.expMonth
#. placeholder {1}: subscriptionDetails.paymentMethod.expYear
#: src/pages/SubscriptionPage.tsx:501
msgid "Expires {0}/{1}"
msgstr "Vence {0}/{1}"

#: src/pages/MemoryPage.tsx:1458
msgid "Export memory"
msgstr "Exportar la memoria"

#: src/pages/PrivateMcpPage.tsx:619
msgid "External Client App consumer key"
msgstr "Consumer key de la app cliente externa"

#: src/pages/MemoryPage.tsx:100
msgid "Fact"
msgstr "Dato"

#: src/pages/UserManagementPage.tsx:109
msgid "Failed to add a license for this user"
msgstr "No se pudo agregar una licencia para este usuario"

#: src/pages/MemoryPage.tsx:401
msgid "Failed to archive memory"
msgstr "No se pudo archivar el recuerdo"

#: src/pages/SubscriptionPage.tsx:706
msgid "Failed to cancel subscription. Please try again."
msgstr "No se pudo cancelar la suscripción. Inténtalo de nuevo."

#: src/pages/SignupPage.tsx:104
#~ msgid "Failed to complete signup"
#~ msgstr "No se pudo completar el registro"

#: src/components/UpgradeModal.tsx:152
#: src/components/UpgradeModal.tsx:499
msgid "Failed to complete the upgrade"
msgstr "No se pudo completar la mejora"

#: src/pages/MemoryPage.tsx:459
msgid "Failed to correct memory"
msgstr "No se pudo corregir el recuerdo"

#: src/pages/ApiKeysPage.tsx:49
msgid "Failed to create API key"
msgstr "No se pudo crear la llave de API"

#: src/pages/ConnectionsPage.tsx:494
msgid "Failed to create connection"
msgstr "No se pudo crear la conexión"

#: src/components/UpgradeModal.tsx:144
#: src/pages/SubscriptionPage.tsx:267
#: src/pages/SubscriptionPage.tsx:462
msgid "Failed to create payment method"
msgstr "No se pudo crear el método de pago"

#: src/pages/SubscriptionPage.tsx:283
msgid "Failed to create subscription"
msgstr "No se pudo crear la suscripción"

#: src/pages/AgentsPage.tsx:248
msgid "Failed to delete agent"
msgstr "No se pudo eliminar el agente"

#: src/pages/AgentsPage.tsx:377
#: src/pages/DictionaryManagementPage.tsx:131
msgid "Failed to delete catalog"
msgstr "No se pudo eliminar el catálogo"

#: src/pages/MemoryPage.tsx:380
msgid "Failed to delete memory"
msgstr "No se pudo eliminar el recuerdo"

#: src/pages/UserManagementPage.tsx:195
msgid "Failed to demote user to member"
msgstr "No se pudo bajar al usuario a integrante"

#: src/pages/ConnectionsPage.tsx:395
msgid "Failed to disconnect"
msgstr "No se pudo desconectar"

#: src/pages/UserDetailAuditPage.tsx:541
msgid "Failed to download CSV report"
msgstr "No se pudo descargar el informe CSV"

#: src/pages/MemoryPage.tsx:549
msgid "Failed to erase memory"
msgstr "No se pudo borrar la memoria"

#: src/pages/MemoryPage.tsx:534
msgid "Failed to export memory"
msgstr "No se pudo exportar la memoria"

#. placeholder {0}: entity.displayValue
#: src/pages/MemoryPage.tsx:502
msgid "Failed to forget {0}"
msgstr "No se pudo olvidar a {0}"

#: src/pages/MemoryPage.tsx:370
msgid "Failed to forget this topic"
msgstr "No se pudo olvidar este tema"

#: src/components/Layout.tsx:138
msgid "Failed to generate invite link. Please ensure you have a company account."
msgstr "No se pudo generar el enlace de invitación. Verifica que tengas una cuenta de empresa."

#: src/pages/MemoryPage.tsx:517
msgid "Failed to import memory"
msgstr "No se pudo importar la memoria"

#: src/pages/ApiKeysPage.tsx:32
msgid "Failed to load API keys"
msgstr "No se pudieron cargar las llaves de API"

#: src/pages/MemoryPage.tsx:270
msgid "Failed to load audit trail"
msgstr "No se pudo cargar el registro de auditoría"

#: src/pages/AgentsPage.tsx:354
#: src/pages/DictionaryManagementPage.tsx:79
msgid "Failed to load catalog details"
msgstr "No se pudieron cargar los detalles del catálogo"

#: src/pages/AgentsPage.tsx:345
#: src/pages/DictionaryManagementPage.tsx:62
msgid "Failed to load catalogs"
msgstr "No se pudieron cargar los catálogos"

#: src/pages/PrivateMcpPage.tsx:311
msgid "Failed to load connected users"
msgstr "No se pudieron cargar los usuarios conectados"

#: src/pages/ConnectionsPage.tsx:234
msgid "Failed to load connections"
msgstr "No se pudieron cargar las conexiones"

#: src/pages/UserManagementPage.tsx:88
msgid "Failed to load data"
msgstr "No se pudieron cargar los datos"

#: src/pages/MemoryPage.tsx:261
msgid "Failed to load people and projects"
msgstr "No se pudieron cargar las personas y los proyectos"

#: src/pages/MemoryPage.tsx:227
msgid "Failed to load team memory"
msgstr "No se pudo cargar la memoria del equipo"

#: src/pages/PrivateMcpPage.tsx:275
msgid "Failed to load the Google Workspace app registration"
msgstr "No se pudo cargar el registro de la aplicación de Google Workspace"

#: src/pages/PrivateMcpPage.tsx:293
msgid "Failed to load the HubSpot app registration"
msgstr "No se pudo cargar el registro de la app de HubSpot"

#: src/pages/PrivateMcpPage.tsx:257
msgid "Failed to load the Microsoft 365 app registration"
msgstr "No se pudo cargar el registro de la app de Microsoft 365"

#: src/pages/PrivateMcpPage.tsx:241
msgid "Failed to load the Salesforce app registration"
msgstr "No se pudo cargar el registro de la app de Salesforce"

#: src/pages/MemoryPage.tsx:252
msgid "Failed to load the timeline"
msgstr "No se pudo cargar la línea de tiempo"

#: src/pages/UserDetailAuditPage.tsx:232
msgid "Failed to load user audit data"
msgstr "No se pudieron cargar los datos de auditoría del usuario"

#: src/pages/MemoryPage.tsx:197
msgid "Failed to load your memory"
msgstr "No se pudo cargar tu memoria"

#: src/pages/MemoryPage.tsx:243
msgid "Failed to load your profile"
msgstr "No se pudo cargar tu perfil"

#: src/pages/UserManagementPage.tsx:126
msgid "Failed to make user admin"
msgstr "No se pudo hacer administrador al usuario"

#: src/utils/licenses.ts:205
msgid "Failed to move the user to {tierLabel}"
msgstr "No se pudo mover al usuario a {tierLabel}"

#: src/pages/MemoryPage.tsx:485
msgid "Failed to refresh your profile"
msgstr "No se pudo actualizar tu perfil"

#: src/pages/MemoryPage.tsx:444
msgid "Failed to remember that"
msgstr "No se pudo recordar eso"

#: src/pages/MemoryPage.tsx:302
msgid "Failed to remove team memory"
msgstr "No se pudo eliminar la memoria del equipo"

#: src/pages/PrivateMcpPage.tsx:365
#: src/pages/PrivateMcpPage.tsx:401
#: src/pages/PrivateMcpPage.tsx:445
#: src/pages/PrivateMcpPage.tsx:489
msgid "Failed to remove the app registration"
msgstr "No se pudo eliminar el registro de la app"

#: src/pages/VerifyEmailPage.tsx:62
msgid "Failed to resend."
msgstr "No se pudo reenviar."

#: src/pages/ResetPasswordPage.tsx:102
msgid "Failed to reset password. Please try again."
msgstr "No se pudo restablecer la contraseña. Inténtalo de nuevo."

#: src/pages/MemoryPage.tsx:411
msgid "Failed to restore memory"
msgstr "No se pudo restaurar el recuerdo"

#: src/pages/ApiKeysPage.tsx:62
msgid "Failed to revoke API key"
msgstr "No se pudo revocar la llave de API"

#: src/pages/PrivateMcpPage.tsx:502
msgid "Failed to revoke the connection"
msgstr "No se pudo revocar la conexión"

#: src/pages/AgentsPage.tsx:226
msgid "Failed to save agent"
msgstr "No se pudo guardar el agente"

#: src/pages/AgentsPage.tsx:365
#: src/pages/DictionaryManagementPage.tsx:108
msgid "Failed to save catalog"
msgstr "No se pudo guardar el catálogo"

#: src/pages/ConnectionsPage.tsx:436
msgid "Failed to save configuration"
msgstr "No se pudo guardar la configuración"

#: src/pages/PrivateMcpPage.tsx:347
#: src/pages/PrivateMcpPage.tsx:384
#: src/pages/PrivateMcpPage.tsx:427
#: src/pages/PrivateMcpPage.tsx:471
msgid "Failed to save the app registration"
msgstr "No se pudo guardar el registro de la app"

#: src/pages/MemoryPage.tsx:291
msgid "Failed to share memory"
msgstr "No se pudo compartir el recuerdo"

#: src/pages/ConnectionsPage.tsx:542
msgid "Failed to start {serviceName} OAuth"
msgstr "No se pudo iniciar OAuth de {serviceName}"

#: src/pages/ConnectionsPage.tsx:407
msgid "Failed to start reconnect"
msgstr "No se pudo iniciar la reconexión"

#: src/pages/ConnectionsPage.tsx:505
#~ msgid "Failed to start Salesforce OAuth"
#~ msgstr "No se pudo iniciar OAuth de Salesforce"

#: src/pages/ConnectionsPage.tsx:317
msgid "Failed to start scan"
msgstr "No se pudo iniciar el análisis"

#: src/pages/ConnectionsPage.tsx:329
msgid "Failed to start sync"
msgstr "No se pudo iniciar la sincronización"

#: src/pages/OnboardingPage.tsx:147
#~ msgid "Failed to start trial"
#~ msgstr "No se pudo iniciar la prueba"

#: src/pages/MemoryPage.tsx:347
msgid "Failed to update memory settings"
msgstr "No se pudo actualizar la configuración de la memoria"

#: src/pages/SubscriptionPage.tsx:470
#: src/pages/SubscriptionPage.tsx:471
msgid "Failed to update payment method"
msgstr "No se pudo actualizar el método de pago"

#: src/pages/MemoryPage.tsx:391
msgid "Failed to update pin"
msgstr "No se pudo cambiar el fijado"

#: src/pages/MemoryPage.tsx:333
msgid "Failed to update team memory"
msgstr "No se pudo actualizar la memoria del equipo"

#: src/pages/MemoryPage.tsx:472
msgid "Failed to update your profile"
msgstr "No se pudo guardar tu perfil"

#: src/pages/SubscriptionPage.tsx:682
msgid "Failed to upgrade to Max. Please try again."
msgstr "No se pudo subir a Max. Inténtalo de nuevo."

#: src/pages/MemoryPage.tsx:117
msgid "Family"
msgstr "Familia"

#: src/pages/ConnectionsPage.tsx:1166
msgid ""
"Fields to skip, e.g. Opportunity.Amount, Account.Secret_Field__c\n"
"Separate with commas or new lines"
msgstr ""
"Campos por omitir, p. ej. Opportunity.Amount, Account.Secret_Field__c\n"
"Sepáralos con comas o saltos de línea"

#: src/pages/UserDetailAuditPage.tsx:1072
msgid "FILE"
msgstr "ARCHIVO"

#: src/components/ProviderDetailModal.tsx:405
msgid "Files"
msgstr "Archivos"

#: src/components/ProviderDetailModal.tsx:208
msgid "Files protected"
msgstr "Archivos protegidos"

#: src/pages/ConnectionsPage.tsx:601
msgid "Files.Read.All application permission via Microsoft Graph API. Requires an Azure AD app registration."
msgstr "Permiso de aplicación Files.Read.All por la API de Microsoft Graph. Requiere un registro de app en Azure AD."

#: src/pages/ConnectionsPage.tsx:1140
msgid "Filter out known Bots"
msgstr "Filtrar los bots conocidos"

#: src/pages/MemoryPage.tsx:116
msgid "Finance"
msgstr "Finanzas"

#: src/pages/InvitePage.tsx:667
#: src/pages/SignupPage.tsx:479
msgid "First"
msgstr "Primero"

#: src/pages/LoginPage.tsx:263
msgid "First Name"
msgstr "Nombre"

#: src/pages/SignupPage.tsx:193
msgid "First name contains invalid characters"
msgstr "El nombre tiene caracteres no válidos"

#: src/pages/SignupPage.tsx:192
msgid "First name is required"
msgstr "El nombre es obligatorio"

#: src/pages/SubscriptionPage.tsx:195
#~ msgid "For teams and organizations. {maxFeatureLine}."
#~ msgstr "Para equipos y organizaciones. {maxFeatureLine}."

#: src/pages/MemoryPage.tsx:756
#: src/pages/MemoryPage.tsx:1529
msgid "Forget"
msgstr "Olvidar"

#. placeholder {0}: entity.displayValue
#: src/pages/MemoryPage.tsx:1307
msgid "Forget everything about {0}"
msgstr "Olvidar todo sobre {0}"

#. placeholder {0}: DOMAIN_LABEL[confirmDomain]
#. placeholder {0}: confirmEntity.displayValue
#: src/pages/MemoryPage.tsx:1527
#: src/pages/MemoryPage.tsx:1537
msgid "Forget everything about {0}?"
msgstr "¿Olvidar todo sobre {0}?"

#: src/pages/MemoryPage.tsx:896
#: src/pages/MemoryPage.tsx:1539
msgid "Forget this topic"
msgstr "Olvidar este tema"

#: src/pages/LoginPage.tsx:320
msgid "Forgot password?"
msgstr "¿Olvidaste la contraseña?"

#: src/pages/ForgotPasswordPage.tsx:113
msgid "Forgot your password?"
msgstr "¿Olvidaste tu contraseña?"

#: src/pages/MemoryPage.tsx:1008
msgid "Four short blocks PrivacyPal compiles from your memories and sends once at the start of each conversation. Edit any block; lock it to keep PrivacyPal from rewriting it."
msgstr "Cuatro bloques cortos que PrivacyPal compila a partir de tus recuerdos y envía una sola vez al inicio de cada conversación. Edita cualquier bloque; bloquéalo para que PrivacyPal no lo reescriba."

#: src/pages/SignupPage.tsx:616
msgid "Free"
msgstr "Gratis"

#: src/pages/ConnectionsPage.tsx:326
msgid "Full Business Data sync started — this may take a few minutes"
msgstr "Empezó la sincronización completa de los datos del negocio. Puede tardar unos minutos."

#: src/pages/InvitePage.tsx:663
#: src/pages/SignupPage.tsx:477
msgid "Full Name"
msgstr "Nombre completo"

#: src/pages/SubscriptionPage.tsx:859
msgid "full price"
msgstr "precio completo"

#: src/pages/ConnectionsPage.tsx:1187
msgid "Full Text Search"
msgstr "Búsqueda de texto completo"

#: src/pages/SubscriptionPage.tsx:791
msgid "Full usage history and team activity"
msgstr "Historial de uso completo y actividad del equipo"

#: src/pages/DashboardPage.tsx:467
msgid "Full usage history comes with Max"
msgstr "El historial de uso completo viene con Max"

#: src/pages/MemoryPage.tsx:121
msgid "General"
msgstr "General"

#: src/components/Layout.tsx:370
msgid "Generate an invite link to share with team members"
msgstr "Genera un enlace de invitación para compartir con tu equipo"

#: src/pages/ApiKeysPage.tsx:94
msgid "Generate API keys for third-party integrations using the PrivacyPal SDK. Usage is metered by sensitive elements protected."
msgstr "Genera llaves de API para integraciones de terceros con el SDK de PrivacyPal. El consumo se mide por elementos sensibles protegidos."

#: src/pages/ApiKeysPage.tsx:243
msgid "Generate Key"
msgstr "Generar llave"

#: src/pages/ApiKeysPage.tsx:215
msgid "Generate New API Key"
msgstr "Generar una llave de API"

#: src/pages/ApiKeysPage.tsx:106
msgid "Generate New Key"
msgstr "Generar una llave"

#: src/pages/OnboardingPage.tsx:369
msgid "Generating Privacy Twins..."
msgstr "Generando valores sintéticos..."

#: src/pages/ApiKeysPage.tsx:243
#: src/pages/OnboardingPage.tsx:412
msgid "Generating..."
msgstr "Generando..."

#: src/pages/ConnectionsPage.tsx:879
msgid "Get Started"
msgstr "Empezar"

#: src/pages/SignupPage.tsx:409
msgid "Get Started Free"
msgstr "Empezar gratis"

#: src/pages/ApiKeysPage.tsx:217
msgid "Give your key a descriptive name so you can identify it later."
msgstr "Ponle a tu llave un nombre descriptivo para que la identifiques después."

#: src/pages/SignupPage.tsx:665
msgid "Go Max"
msgstr "Pásate a Max"

#: src/pages/UserManagementPage.tsx:225
msgid "Go to Dashboard"
msgstr "Ir al panel"

#: src/pages/InvitePage.tsx:250
msgid "Go to Login"
msgstr "Ir al ingreso"

#: src/pages/SubscriptionPage.tsx:1141
msgid "Go to User Management"
msgstr "Ir a Gestión de usuarios"

#: src/pages/PrivateMcpPage.tsx:964
msgid "Google does not offer a secretless client for a hosted callback, so this connector needs one. It is encrypted before storage and never shown again, here or anywhere else."
msgstr "Google no ofrece un cliente sin secreto para una URL de retorno alojada, así que este conector necesita uno. Se cifra antes de guardarse y no se vuelve a mostrar, ni aquí ni en ningún otro lugar."

#: src/pages/PrivateMcpPage.tsx:443
msgid "Google Workspace app registration removed"
msgstr "Se eliminó el registro de la aplicación de Google Workspace"

#: src/pages/PrivateMcpPage.tsx:420
msgid "Google Workspace app registration saved"
msgstr "Se guardó el registro de la aplicación de Google Workspace"

#: src/pages/SubscriptionPage.tsx:361
msgid "Have a promo code?"
msgstr "¿Tienes un código promocional?"

#: src/pages/MemoryPage.tsx:114
msgid "Health"
msgstr "Salud"

#: src/pages/MemoryPage.tsx:953
msgid "Held back"
msgstr "Retenidos"

#: src/pages/MemoryPage.tsx:131
msgid "Held back (sensitive)"
msgstr "Retenidos (sensibles)"

#: src/pages/ResetPasswordPage.tsx:210
msgid "Hide"
msgstr "Ocultar"

#: src/pages/ResetPasswordPage.tsx:208
msgid "Hide password"
msgstr "Ocultar la contraseña"

#: src/pages/MemoryPage.tsx:1342
msgid "Hide why"
msgstr "Ocultar el porqué"

#: src/pages/MemoryPage.tsx:107
msgid "High confidence"
msgstr "Confianza alta"

#: src/components/ProviderDetailModal.tsx:192
msgid "high risk"
msgstr "riesgo alto"

#: src/pages/UserDetailAuditPage.tsx:864
msgid "HIGH RISK"
msgstr "RIESGO ALTO"

#: src/pages/AgentsPage.tsx:594
msgid "History"
msgstr "Historial"

#: src/pages/ConnectionsPage.tsx:1055
#: src/pages/PrivateMcpPage.tsx:1330
msgid "Host"
msgstr "Host"

#: src/pages/PrivateMcpPage.tsx:678
msgid "Hosted MCP server"
msgstr "Servidor MCP alojado"

#: src/pages/PrivateMcpPage.tsx:629
msgid "Hosted MCP server <0>(optional)</0>"
msgstr "Servidor MCP alojado <0>(opcional)</0>"

#: src/pages/OnboardingPage.tsx:428
msgid "How do you work?"
msgstr "¿Cómo funcionas?"

#: src/pages/PrivateMcpPage.tsx:1214
msgid "HubSpot account ID"
msgstr "ID de la cuenta de HubSpot"

#: src/pages/PrivateMcpPage.tsx:1166
msgid "HubSpot account ID (optional)"
msgstr "ID de la cuenta de HubSpot (opcional)"

#: src/pages/ConnectionsPage.tsx:978
msgid "HubSpot app Client secret"
msgstr "Client secret de la app de HubSpot"

#: src/pages/PrivateMcpPage.tsx:487
msgid "HubSpot app registration removed"
msgstr "Se eliminó el registro de la app de HubSpot"

#: src/pages/PrivateMcpPage.tsx:464
msgid "HubSpot app registration saved"
msgstr "Se guardó el registro de la app de HubSpot"

#: src/pages/PrivateMcpPage.tsx:1158
msgid "HubSpot's MCP server requires the client secret together with PKCE, so this connector needs one. It is encrypted before storage and never shown again, here or anywhere else."
msgstr "El servidor MCP de HubSpot exige el secreto de cliente junto con PKCE, así que este conector necesita uno. Se cifra antes de guardarse y no se vuelve a mostrar, ni aquí ni en ningún otro lugar."

#: src/pages/SignupPage.tsx:672
msgid "I have a trial code for my company"
msgstr "Tengo un código de prueba para mi empresa"

#: src/pages/OnboardingPage.tsx:337
msgid "I'm ready to see it work"
msgstr "Quiero verlo funcionar"

#. placeholder {0}: formData.email
#: src/pages/InvitePage.tsx:572
msgid "If <0>{0}</0> can receive mail, we've sent it a 6-digit code. Enter it below to verify your address and finish accepting your invite — your account is only created after this step."
msgstr "Si <0>{0}</0> puede recibir correo, ya se le envió un código de 6 dígitos. Escríbelo aquí abajo para verificar tu dirección y terminar de aceptar la invitación: tu cuenta solo se crea después de este paso."

#. placeholder {0}: formData.email
#: src/pages/SignupPage.tsx:523
msgid "If <0>{0}</0> can receive mail, we've sent it a 6-digit code. Enter it below to verify your address. Your account is only created after this step."
msgstr "Si <0>{0}</0> puede recibir correo, ya se le envió un código de 6 dígitos. Escríbelo aquí abajo para verificar tu dirección. Tu cuenta solo se crea después de este paso."

#: src/pages/LoginPage.tsx:182
msgid "If <0>{email}</0> can receive mail, we've sent it a 6-digit code. Enter it below — your account is only created after this step. The code expires in 10 minutes."
msgstr "Si <0>{email}</0> puede recibir correo, ya se le envió un código de 6 dígitos. Escríbelo aquí abajo: tu cuenta solo se crea después de este paso. El código vence en 10 minutos."

#: src/pages/ForgotPasswordPage.tsx:81
msgid "If an account exists for <0>{trimmedEmail}</0>, you'll receive a password reset email shortly. The link expires in 20 minutes."
msgstr "Si existe una cuenta para <0>{trimmedEmail}</0>, en un momento llegará un correo para restablecer la contraseña. El enlace vence en 20 minutos."

#: src/pages/LoginPage.tsx:139
#: src/pages/VerifyEmailPage.tsx:62
msgid "If that account exists, a new verification email has been sent."
msgstr "Si esa cuenta existe, ya se envió un correo de verificación nuevo."

#: src/pages/InvitePage.tsx:176
#: src/pages/InvitePage.tsx:179
#: src/pages/LoginPage.tsx:130
#: src/pages/SignupPage.tsx:308
#: src/pages/SignupPage.tsx:311
msgid "If that address can receive mail, we've sent a new code."
msgstr "Si esa dirección puede recibir correo, ya se envió un código nuevo."

#: src/pages/MemoryPage.tsx:1223
msgid "Import"
msgstr "Importar"

#: src/pages/MemoryPage.tsx:514
msgid "Import started. New memories appear once they are distilled."
msgstr "Importación iniciada. Los recuerdos nuevos aparecen cuando terminen de destilarse."

#. placeholder {0}: IMPORT_PLATFORM_NAME[imported]
#: src/pages/MemoryPage.tsx:693
msgid "imported from {0}"
msgstr "importado de {0}"

#: src/pages/MemoryPage.tsx:1223
msgid "Importing…"
msgstr "Importando…"

#: src/pages/PrivateMcpPage.tsx:1239
msgid "In HubSpot, go to Development, then MCP Connectors, and create an MCP connector with the redirect URL below. Copy its client ID and client secret here. There are no scopes to choose: HubSpot grants the connector what its MCP tools need, limited by each user's own HubSpot permissions, and every user approves it once when they connect."
msgstr "En HubSpot, ve a Development y luego a MCP Connectors, y crea un conector MCP con la URL de redirección de abajo. Copia aquí su ID de cliente y su secreto de cliente. No hay alcances que elegir: HubSpot le otorga al conector lo que necesitan sus herramientas MCP, limitado por los permisos de HubSpot de cada usuario, y cada usuario lo aprueba una vez cuando se conecta."

#: src/pages/PrivateMcpPage.tsx:1044
msgid "In your own Google Cloud project, enable {GOOGLE_APIS}, set the OAuth consent screen user type to \"Internal\", and create an OAuth client of type \"Web application\" with the redirect URI below. Request the scopes <0>{GOOGLE_SCOPES}</0>. Internal apps skip Google's verification review, and their refresh tokens do not expire after seven days the way an external app still in testing does."
msgstr "En su propio proyecto de Google Cloud, habilite {GOOGLE_APIS}, defina el tipo de usuario de la pantalla de consentimiento de OAuth como \"Internal\" y cree un cliente de OAuth de tipo \"Web application\" con la URI de redirección que aparece abajo. Solicite los permisos <0>{GOOGLE_SCOPES}</0>. Las aplicaciones internas no pasan por la revisión de verificación de Google, y sus tokens de actualización no caducan a los siete días como sí ocurre con una aplicación externa en modo de prueba."

#: src/pages/ConnectionsPage.tsx:898
msgid "In your Salesforce org, create a Connected App with OAuth enabled, register the exact callback URL below, and grant the scopes shown. Then paste your My Domain URL and the app's Consumer Key/Secret. You approve access in a popup — tokens are exchanged server-side and stored encrypted."
msgstr "En tu organización de Salesforce, crea una Connected App con OAuth habilitado, registra la URL de retorno exacta que aparece abajo y otorga los alcances indicados. Después pega la URL de tu My Domain y el Consumer Key/Secret de la app. La autorización se aprueba en una ventana emergente: los tokens se intercambian en el servidor y se guardan cifrados."

#: src/pages/DashboardPage.tsx:376
msgid "Inactive"
msgstr "Inactivo"

#: src/pages/ConnectionsPage.tsx:1139
msgid "Include private channels and direct messages in privacy scans"
msgstr "Incluir los canales privados y los mensajes directos en los análisis de privacidad"

#: src/components/MaxUpsell.tsx:71
msgid "Included with PrivacyPal Max"
msgstr "Incluido con PrivacyPal Max"

#: src/pages/MemoryPage.tsx:849
msgid "Incognito"
msgstr "Incógnito"

#: src/pages/SignupPage.tsx:623
#: src/pages/SubscriptionPage.tsx:169
#~ msgid "Individual"
#~ msgstr "Individual"

#: src/pages/SubscriptionPage.tsx:491
#~ msgid "Individual account: one seat, one person. Unlimited prompts and all features. $0 today; first charge after your {trialDays}-day trial."
#~ msgstr "Cuenta individual: un puesto, una persona. Prompts ilimitados y todas las funciones. $0 hoy; el primer cobro se hace al terminar tu prueba de {trialDays} días."

#: src/pages/InvitePage.tsx:721
msgid "Initialize Privacy Agent"
msgstr "Inicializar el agente de privacidad"

#: src/pages/AgentsPage.tsx:959
msgid "Input Prompt to Analyze"
msgstr "Prompt de entrada por analizar"

#: src/pages/UserDetailAuditPage.tsx:717
msgid "Insight:"
msgstr "Hallazgo:"

#: src/pages/InvitePage.tsx:542
msgid "Installs in your browser. Works across major LLMs instantly."
msgstr "Se instala en tu navegador. Funciona de inmediato con los principales LLM."

#: src/pages/MemoryPage.tsx:102
msgid "Instruction"
msgstr "Instrucción"

#: src/pages/ConnectionsPage.tsx:605
msgid "Integrate with NetDocuments to scan legal documents, matter files, and workspace content."
msgstr "Intégrate con NetDocuments para analizar documentos legales, expedientes y contenido del espacio de trabajo."

#: src/pages/ConnectionsPage.tsx:601
msgid "Integrate with OneDrive for Business to monitor files shared across your Microsoft 365 tenant."
msgstr "Intégrate con OneDrive for Business para monitorear los archivos compartidos en tu tenant de Microsoft 365."

#: src/pages/ConnectionsPage.tsx:616
msgid "Integrate with your self-hosted or cloud Mattermost instance to scan channels for privacy risks."
msgstr "Intégrate con tu instancia de Mattermost propia o en la nube para analizar los canales en busca de riesgos de privacidad."

#: src/pages/ConnectionsPage.tsx:652
msgid "Integrate with your Supabase project to scan PostgreSQL tables and storage buckets."
msgstr "Intégrate con tu proyecto de Supabase para analizar las tablas de PostgreSQL y los buckets de almacenamiento."

#: src/App.tsx:142
msgid "Intelligent agents that watch your privacy pipeline in real time and analyze audit data for anomalies."
msgstr "Agentes inteligentes que vigilan tu flujo de privacidad en tiempo real y analizan los datos de auditoría en busca de anomalías."

#: src/pages/UserDetailAuditPage.tsx:707
#~ msgid "Interactions"
#~ msgstr "Interacciones"

#: src/pages/LoginPage.tsx:51
msgid "Invalid authentication data received."
msgstr "Se recibieron datos de autenticación no válidos."

#: src/pages/InvitePage.tsx:44
msgid "Invalid invite link"
msgstr "Enlace de invitación no válido"

#: src/pages/InvitePage.tsx:232
msgid "Invalid Invite Link"
msgstr "Enlace de invitación no válido"

#: src/pages/ResetPasswordPage.tsx:149
msgid "Invalid link"
msgstr "Enlace no válido"

#: src/pages/InvitePage.tsx:78
msgid "Invalid or expired invite link"
msgstr "Enlace de invitación no válido o vencido"

#: src/pages/OnboardingPage.tsx:120
#: src/pages/SignupPage.tsx:396
#~ msgid "Invalid promo code"
#~ msgstr "Código promocional no válido"

#: src/components/Layout.tsx:492
msgid "Invite Link Generated"
msgstr "Enlace de invitación generado"

#: src/pages/InvitePage.tsx:476
msgid "Invite Only"
msgstr "Solo por invitación"

#: src/components/Layout.tsx:460
msgid "Invite Team Members"
msgstr "Invitar a tu equipo"

#: src/App.tsx:195
msgid "IP Connections"
msgstr "Conexiones de PI"

#: src/components/connections/ConnectionAuthError.tsx:34
#: src/components/connections/ConnectionHealthPanel.tsx:50
#: src/components/connections/ConnectionHealthPanel.tsx:58
msgid "Items indexed"
msgstr "Elementos indexados"

#: src/utils/relativeTime.ts:13
msgid "just now"
msgstr "hace un momento"

#: src/pages/UserDetailAuditPage.tsx:428
msgid "Just now"
msgstr "Hace un momento"

#: src/pages/SubscriptionPage.tsx:1049
msgid "Keep Subscription"
msgstr "Conservar la suscripción"

#: src/pages/SubscriptionPage.tsx:1219
msgid "Keep Trial"
msgstr "Conservar la prueba"

#: src/pages/ApiKeysPage.tsx:134
#: src/pages/ApiKeysPage.tsx:183
msgid "Key"
msgstr "Llave"

#: src/pages/InvitePage.tsx:675
#: src/pages/SignupPage.tsx:480
msgid "Last"
msgstr "Último"

#: src/components/ProviderDetailModal.tsx:201
msgid "last {days} days"
msgstr "últimos {days} días"

#: src/pages/DashboardPage.tsx:615
msgid "Last {usageDays} days"
msgstr "Últimos {usageDays} días"

#: src/components/ProviderDetailModal.tsx:408
msgid "Last active"
msgstr "Última actividad"

#: src/components/connections/ConnectionAuthError.tsx:30
#: src/components/connections/ConnectionHealthPanel.tsx:45
msgid "Last good scan"
msgstr "Último análisis correcto"

#. placeholder {0}: fmt(entity.lastMentionedAt)
#: src/pages/MemoryPage.tsx:1292
msgid "last mentioned {0}"
msgstr "última mención {0}"

#: src/pages/LoginPage.tsx:274
msgid "Last Name"
msgstr "Apellido"

#: src/pages/SignupPage.tsx:195
msgid "Last name contains invalid characters"
msgstr "El apellido tiene caracteres no válidos"

#: src/pages/SignupPage.tsx:194
msgid "Last name is required"
msgstr "El apellido es obligatorio"

#: src/components/connections/ConnectionHealthPanel.tsx:35
#: src/components/connections/ConnectionHealthPanel.tsx:45
msgid "Last scanned"
msgstr "Último análisis"

#: src/pages/PrivateMcpPage.tsx:1331
msgid "Last updated"
msgstr "Última actualización"

#: src/pages/ApiKeysPage.tsx:137
msgid "Last Used"
msgstr "Último uso"

#: src/pages/InvitePage.tsx:506
msgid "LATENCY"
msgstr "LATENCIA"

#: src/pages/OnboardingPage.tsx:297
msgid "Leak sealed. PrivacyPal is on the job."
msgstr "Fuga sellada. PrivacyPal está trabajando."

#: src/components/connections/ConnectionCard.tsx:68
msgid "Legacy credentials — OAuth recommended"
msgstr "Credenciales heredadas. Se recomienda OAuth."

#: src/pages/MemoryPage.tsx:115
msgid "Legal"
msgstr "Legal"

#: src/pages/OnboardingPage.tsx:491
msgid "Let's do this"
msgstr "Manos a la obra"

#: src/pages/OnboardingPage.tsx:262
msgid "Let's go"
msgstr "Vamos"

#: src/pages/UserManagementPage.tsx:105
msgid "License added ({seatTier} seat)"
msgstr "Licencia agregada (puesto {seatTier})"

#: src/pages/SubscriptionPage.tsx:903
msgid "Licenses"
msgstr "Licencias"

#: src/pages/ResetPasswordPage.tsx:149
#: src/pages/VerifyEmailPage.tsx:106
msgid "Link expired"
msgstr "El enlace venció"

#: src/components/Layout.tsx:687
msgid "Linux agent shield"
msgstr "Escudo de agentes para Linux"

#: src/components/Layout.tsx:748
msgid "Linux: install.sh needs no root and installs into your home directory. Run privacypal login once, then privacypal status to confirm which agents are covered."
msgstr "Linux: install.sh no necesita root y se instala en tu carpeta personal. Ejecuta privacypal login una vez y luego privacypal status para confirmar qué agentes quedan cubiertos."

#: src/components/UpgradeModal.tsx:653
msgid "Live today, cancel anytime"
msgstr "Activo hoy, cancela cuando quieras"

#: src/pages/MemoryPage.tsx:766
msgid "Loading evidence…"
msgstr "Cargando evidencia…"

#: src/pages/AgentsPage.tsx:1146
msgid "Loading history..."
msgstr "Cargando el historial..."

#: src/pages/OnboardingPage.tsx:742
#~ msgid "Loading secure payment form..."
#~ msgstr "Cargando el formulario de pago seguro..."

#: src/pages/MemoryPage.tsx:1062
msgid "Lock"
msgstr "Bloquear"

#: src/pages/MemoryPage.tsx:1062
msgid "Locked"
msgstr "Bloqueado"

#: src/pages/LoginPage.tsx:75
msgid "Login failed"
msgstr "Falló el ingreso"

#: src/pages/MemoryPage.tsx:109
msgid "Low confidence"
msgstr "Confianza baja"

#: src/components/ProviderDetailModal.tsx:192
msgid "low risk"
msgstr "riesgo bajo"

#: src/components/Layout.tsx:745
msgid "macOS: open the DMG, drag PrivacyPal to Applications, then launch from Applications. Gatekeeper may ask you to confirm the first launch."
msgstr "macOS: abre el DMG, arrastra PrivacyPal a Aplicaciones y ábrelo desde ahí. Gatekeeper puede pedirte confirmar la primera apertura."

#: src/pages/UserManagementPage.tsx:370
#: src/pages/UserManagementPage.tsx:457
msgid "Make Admin"
msgstr "Hacer administrador"

#: src/pages/InvitePage.tsx:497
#: src/pages/SignupPage.tsx:412
msgid "Make AI Safe for Work.<0/>Instantly."
msgstr "Haz que la IA sea segura para el trabajo.<0/>Al instante."

#: src/pages/UserManagementPage.tsx:472
msgid "Make User Administrator"
msgstr "Hacer administrador al usuario"

#: src/pages/AgentsPage.tsx:630
#: src/pages/DictionaryManagementPage.tsx:175
msgid "Manage custom catalogs for PII detection. Add terms to detect and deny lists to prevent false positives."
msgstr "Gestiona catálogos propios para detectar PII. Agrega términos por detectar y listas de bloqueo para evitar falsos positivos."

#: src/pages/DashboardPage.tsx:417
msgid "Manage Subscription →"
msgstr "Gestionar la suscripción →"

#: src/pages/SubscriptionPage.tsx:869
msgid "Manage your {tierLabel} subscription"
msgstr "Gestiona tu suscripción {tierLabel}"

#: src/pages/SubscriptionPage.tsx:868
msgid "Manage your company {tierLabel} subscription"
msgstr "Gestiona la suscripción {tierLabel} de tu empresa"

#: src/pages/SubscriptionPage.tsx:1124
msgid "Manage your company subscription"
msgstr "Gestiona la suscripción de tu empresa"

#. placeholder {0}: company.name
#: src/pages/UserManagementPage.tsx:240
msgid "Managing users for <0>{0}</0>"
msgstr "Gestionando los usuarios de <0>{0}</0>"

#: src/pages/DashboardPage.tsx:376
msgid "Max Plan"
msgstr "Plan Max"

#: src/components/UpgradeModal.tsx:377
msgid "MAX-XXXX-XXXX"
msgstr "MAX-XXXX-XXXX"

#: src/pages/PrivateMcpPage.tsx:1116
msgid "MCP connector"
msgstr "Conector MCP"

#: src/pages/AgentsPage.tsx:1403
#: src/pages/DictionaryManagementPage.tsx:461
msgid "Medical Condition"
msgstr "Condición médica"

#: src/pages/MemoryPage.tsx:108
msgid "Medium confidence"
msgstr "Confianza media"

#: src/components/ProviderDetailModal.tsx:192
msgid "medium risk"
msgstr "riesgo medio"

#: src/pages/OnboardingPage.tsx:245
msgid "Meet your PrivacyPal."
msgstr "Te presentamos a tu PrivacyPal."

#: src/pages/UserManagementPage.tsx:319
msgid "Member"
msgstr "Integrante"

#: src/pages/MemoryPage.tsx:641
#: src/pages/MemoryPage.tsx:950
msgid "Memories"
msgstr "Recuerdos"

#: src/pages/MemoryPage.tsx:1384
msgid "Memories your team has shared. Values stay Privacy Twins for everyone except the person who shared them; real values never leave the sharer's vault."
msgstr "Recuerdos que compartió tu equipo. Para todos, salvo quien los compartió, los valores siguen siendo valores sintéticos; los valores reales nunca salen de la bóveda de quien comparte."

#: src/components/Layout.tsx:209
msgid "Memory"
msgstr "Memoria"

#: src/pages/MemoryPage.tsx:399
msgid "Memory archived"
msgstr "Recuerdo archivado"

#: src/pages/MemoryPage.tsx:1318
msgid "Memory audit trail"
msgstr "Registro de auditoría de la memoria"

#: src/pages/MemoryPage.tsx:456
msgid "Memory corrected"
msgstr "Recuerdo corregido"

#: src/pages/MemoryPage.tsx:378
msgid "Memory deleted"
msgstr "Recuerdo eliminado"

#: src/pages/MemoryPage.tsx:542
msgid "Memory erased and encryption keys destroyed"
msgstr "Memoria borrada y llaves de cifrado destruidas"

#: src/pages/MemoryPage.tsx:532
msgid "Memory exported"
msgstr "Memoria exportada"

#: src/pages/MemoryPage.tsx:803
msgid "Memory is off"
msgstr "La memoria está apagada"

#: src/pages/MemoryPage.tsx:1170
msgid "Memory is off, so nothing has been remembered."
msgstr "La memoria está apagada, así que no se ha recordado nada."

#: src/pages/MemoryPage.tsx:927
msgid "Memory is off, so team memory takes effect once you turn memory on."
msgstr "La memoria está apagada, así que la memoria del equipo se activa cuando la enciendas."

#: src/pages/MemoryPage.tsx:803
msgid "Memory is on"
msgstr "La memoria está encendida"

#: src/pages/MemoryPage.tsx:389
msgid "Memory pinned"
msgstr "Recuerdo fijado"

#: src/pages/MemoryPage.tsx:409
msgid "Memory restored"
msgstr "Recuerdo restaurado"

#: src/pages/MemoryPage.tsx:345
msgid "Memory settings updated"
msgstr "Configuración de la memoria actualizada"

#: src/pages/MemoryPage.tsx:285
msgid "Memory shared with your team"
msgstr "Recuerdo compartido con tu equipo"

#: src/pages/MemoryPage.tsx:791
msgid "Memory that follows you across every AI. Stored as Privacy Twins: PrivacyPal holds the shape of what you know, never your secrets."
msgstr "Una memoria que te acompaña en todas las IA. Se guarda como valores sintéticos: PrivacyPal conserva la forma de lo que sabes, nunca tus secretos."

#: src/pages/MemoryPage.tsx:389
msgid "Memory unpinned"
msgstr "Recuerdo desfijado"

#: src/pages/UserDetailAuditPage.tsx:1041
msgid "Metadata & Tokens"
msgstr "Metadatos y tokens"

#: src/pages/PrivateMcpPage.tsx:399
msgid "Microsoft 365 app registration removed"
msgstr "Registro de la app de Microsoft 365 eliminado"

#: src/pages/PrivateMcpPage.tsx:377
msgid "Microsoft 365 app registration saved"
msgstr "Registro de la app de Microsoft 365 guardado"

#: src/pages/PrivateMcpPage.tsx:1027
#: src/pages/PrivateMcpPage.tsx:1222
msgid "Missing"
msgstr "Falta"

#: src/pages/VerifyEmailPage.tsx:24
msgid "Missing verification token. Please use the link from your email."
msgstr "Falta el token de verificación. Usa el enlace que llegó a tu correo."

#: src/pages/UserDetailAuditPage.tsx:1052
msgid "Model"
msgstr "Modelo"

#: src/pages/AgentsPage.tsx:1086
msgid "Model:"
msgstr "Modelo:"

#: src/pages/ConnectionsPage.tsx:613
msgid "Monitor Slack messages across channels and direct messages for sensitive data and PII exposure."
msgstr "Monitorea los mensajes de Slack en canales y mensajes directos para detectar datos sensibles y exposición de PII."

#: src/pages/SubscriptionPage.tsx:834
msgid "month"
msgstr "mes"

#: src/pages/SubscriptionPage.tsx:835
msgid "monthly"
msgstr "mensual"

#: src/components/UpgradeModal.tsx:198
#: src/pages/SubscriptionPage.tsx:187
#: src/pages/SubscriptionPage.tsx:323
#: src/pages/SubscriptionPage.tsx:402
#: src/pages/SubscriptionPage.tsx:882
msgid "Monthly"
msgstr "Mensual"

#: src/pages/SubscriptionPage.tsx:831
msgid "Monthly Bill"
msgstr "Cobro mensual"

#: src/components/ProviderDetailModal.tsx:302
msgid "Monthly prompts by tool"
msgstr "Prompts mensuales por herramienta"

#: src/pages/PrivateMcpPage.tsx:1273
msgid "More connectors coming soon"
msgstr "Pronto habrá más conectores"

#: src/pages/PrivateMcpPage.tsx:1259
msgid "More Private MCP connectors are coming soon"
msgstr "Pronto habrá más conectores de Private MCP"

#: src/pages/ConnectionsPage.tsx:911
#: src/pages/PrivateMcpPage.tsx:600
#: src/pages/PrivateMcpPage.tsx:669
msgid "My Domain login URL"
msgstr "URL de ingreso de My Domain"

#: src/pages/MemoryPage.tsx:401
#~ msgid "My memory"
#~ msgstr "Mi memoria"

#: src/pages/SubscriptionPage.tsx:927
#: src/pages/UserDetailAuditPage.tsx:581
msgid "N/A"
msgstr "N/D"

#: src/pages/AgentsPage.tsx:669
#: src/pages/ApiKeysPage.tsx:133
#: src/pages/ApiKeysPage.tsx:182
#: src/pages/DictionaryManagementPage.tsx:205
msgid "Name"
msgstr "Nombre"

#: src/pages/InvitePage.tsx:687
msgid "name@company.com"
msgstr "nombre@empresa.com"

#: src/components/Layout.tsx:644
msgid "Native builds for Apple Silicon and Intel Macs. Pick the one that matches your chip."
msgstr "Compilaciones nativas para Mac con Apple Silicon e Intel. Elige la que corresponda a tu chip."

#: src/pages/ApiKeysPage.tsx:75
msgid "Never"
msgstr "Nunca"

#: src/pages/SubscriptionPage.tsx:543
msgid "New Card Details"
msgstr "Datos de la tarjeta nueva"

#: src/pages/AgentsPage.tsx:647
msgid "New Catalog"
msgstr "Catálogo nuevo"

#: src/pages/MemoryPage.tsx:807
msgid "New conversations build your memory, and relevant memories are shared with the AI you are using."
msgstr "Las conversaciones nuevas construyen tu memoria, y los recuerdos relevantes se comparten con la IA que estés usando."

#: src/pages/ResetPasswordPage.tsx:193
msgid "New password"
msgstr "Contraseña nueva"

#: src/pages/AgentsPage.tsx:423
#: src/pages/AgentsPage.tsx:790
msgid "New Privacy Agent"
msgstr "Agente de privacidad nuevo"

#: src/pages/SubscriptionPage.tsx:920
msgid "Next Billing Cycle"
msgstr "Próximo ciclo de facturación"

#: src/components/connections/ConnectionHealthPanel.tsx:71
msgid "Next rebuild"
msgstr "Próxima reconstrucción"

#: src/pages/AgentsPage.tsx:742
#: src/pages/DictionaryManagementPage.tsx:301
msgid "No"
msgstr "No"

#: src/components/ProviderDetailModal.tsx:273
msgid "No {providerName} activity in the last {days} days"
msgstr "Sin actividad de {providerName} en los últimos {days} días"

#: src/utils/licenses.ts:197
msgid "No {tierLabel} seats available. Purchase additional {tierLabel} seats through your PrivacyPal contact."
msgstr "No hay puestos {tierLabel} disponibles. Compra más puestos {tierLabel} con tu contacto de PrivacyPal."

#: src/pages/ApiKeysPage.tsx:125
msgid "No active API keys. Generate one to get started with the SDK."
msgstr "No hay llaves de API activas. Genera una para empezar con el SDK."

#: src/pages/DashboardPage.tsx:686
msgid "No activity"
msgstr "Sin actividad"

#: src/pages/MemoryPage.tsx:1322
msgid "No activity recorded yet."
msgstr "Todavía no se ha registrado actividad."

#: src/pages/AgentsPage.tsx:436
msgid "No agents yet. Click <0>New Privacy Agent</0> to create your first one."
msgstr "Todavía no hay agentes. Haz clic en <0>Agente de privacidad nuevo</0> para crear el primero."

#: src/pages/UserDetailAuditPage.tsx:919
msgid "No audit logs available"
msgstr "No hay registros de auditoría disponibles"

#: src/pages/UserDetailAuditPage.tsx:919
msgid "No audit logs match your search"
msgstr "Ningún registro de auditoría coincide con tu búsqueda"

#: src/components/UpgradeModal.tsx:401
msgid "No card needed"
msgstr "Sin tarjeta"

#: src/pages/AgentsPage.tsx:659
#: src/pages/DictionaryManagementPage.tsx:194
msgid "No catalogs found. Create your first catalog to get started."
msgstr "No se encontraron catálogos. Crea el primero para empezar."

#: src/components/UpgradeModal.tsx:457
msgid "No code yet?"
msgstr "¿Todavía no tienes código?"

#: src/pages/SignupPage.tsx:600
msgid "No credit card needed for Pro. Upgrade whenever you're ready."
msgstr "Pro no necesita tarjeta de crédito. Mejora cuando estés listo."

#: src/pages/MemoryPage.tsx:1238
msgid "No dated memories yet. Events and plans show up here by month."
msgstr "Aún no hay recuerdos con fecha. Los eventos y planes aparecen aquí por mes."

#: src/pages/UserDetailAuditPage.tsx:410
#: src/pages/UserDetailAuditPage.tsx:856
#: src/pages/UserDetailAuditPage.tsx:857
#: src/pages/UserDetailAuditPage.tsx:898
msgid "No encoded prompt"
msgstr "Sin prompt codificado"

#: src/pages/MemoryPage.tsx:768
msgid "No evidence is stored for this memory. It may have been imported or typed in by you."
msgstr "No hay evidencia guardada para este recuerdo. Puede haber sido importado o escrito por ti."

#: src/pages/AgentsPage.tsx:1150
msgid "No execution history found for this agent."
msgstr "No se encontró historial de ejecuciones para este agente."

#: src/pages/UserDetailAuditPage.tsx:560
msgid "No file attachments detected."
msgstr "No se detectaron archivos adjuntos."

#: src/pages/PrivateMcpPage.tsx:1033
msgid "No Google Workspace app is registered yet. Ask an administrator to add one here."
msgstr "Todavía no hay una aplicación de Google Workspace registrada. Pídale a un administrador que agregue una aquí."

#: src/pages/PrivateMcpPage.tsx:1228
msgid "No HubSpot MCP connector is registered yet. Ask an administrator to add one here."
msgstr "Todavía no hay un conector MCP de HubSpot registrado. Pídele a un administrador que agregue uno aquí."

#: src/pages/OnboardingPage.tsx:484
msgid "No lock-in"
msgstr "Sin ataduras"

#: src/pages/MemoryPage.tsx:1169
msgid "No memories yet. Keep using your AI apps; memories are distilled in the background."
msgstr "Todavía no hay recuerdos. Sigue usando tus apps de IA; los recuerdos se destilan en segundo plano."

#: src/pages/PrivateMcpPage.tsx:843
msgid "No Microsoft 365 app is registered yet. Ask an administrator to add one here."
msgstr "Aún no hay una app de Microsoft 365 registrada. Pídele a un administrador que agregue una aquí."

#: src/pages/PrivateMcpPage.tsx:1321
msgid "No one has connected yet."
msgstr "Todavía nadie se ha conectado."

#: src/pages/SubscriptionPage.tsx:507
msgid "No payment method on file"
msgstr "No hay un método de pago registrado"

#: src/pages/MemoryPage.tsx:1280
msgid "No people or projects yet. They appear once a few memories mention the same name."
msgstr "Aún no hay personas ni proyectos. Aparecen cuando varios recuerdos mencionan el mismo nombre."

#: src/pages/MemoryPage.tsx:1359
msgid "No per-note explanation was recorded."
msgstr "No se registró una explicación por nota."

#: src/utils/licenses.ts:196
msgid "No Pro seats available. Pro is an individual account; team seats run on Max."
msgstr "No hay puestos Pro disponibles. Pro es una cuenta individual; los puestos de equipo funcionan con Max."

#: src/pages/UserDetailAuditPage.tsx:975
#~ msgid "No prompt text"
#~ msgstr "Sin texto del prompt"

#: src/pages/DashboardPage.tsx:61
msgid "No prompts"
msgstr "Sin prompts"

#: src/pages/PrivateMcpPage.tsx:685
msgid "No Salesforce app is registered yet. Ask an administrator to add one here."
msgstr "Todavía no hay una app de Salesforce registrada. Pídele a un administrador que agregue una aquí."

#: src/pages/ConnectionsPage.tsx:817
msgid "No sensitive data indexed yet. Click \"Scan\" on any active connection or \"Sync All\" to begin."
msgstr "Todavía no hay datos sensibles indexados. Haz clic en «Analizar» en cualquier conexión activa o en «Sincronizar todo» para empezar."

#: src/pages/UserDetailAuditPage.tsx:745
msgid "No usage data available"
msgstr "No hay datos de consumo disponibles"

#: src/pages/DashboardPage.tsx:539
msgid "No usage data yet"
msgstr "Todavía no hay datos de consumo"

#: src/pages/UserDetailAuditPage.tsx:550
msgid "No user data available for analysis."
msgstr "No hay datos del usuario disponibles para analizar."

#: src/pages/UserManagementPage.tsx:277
#: src/pages/UserManagementPage.tsx:394
msgid "No users found."
msgstr "No se encontraron usuarios."

#: src/pages/OnboardingPage.tsx:434
msgid "Non-technical"
msgstr "No técnico"

#: src/pages/PrivateMcpPage.tsx:49
msgid "Not configured"
msgstr "Sin configurar"

#: src/pages/PrivateMcpPage.tsx:588
#: src/pages/PrivateMcpPage.tsx:765
#: src/pages/PrivateMcpPage.tsx:927
#: src/pages/PrivateMcpPage.tsx:1121
msgid "Not configured yet"
msgstr "Todavía sin configurar"

#: src/pages/SubscriptionPage.tsx:1060
msgid "Not now"
msgstr "Ahora no"

#: src/pages/MemoryPage.tsx:1069
msgid "Not refreshed yet"
msgstr "Aún no se ha actualizado"

#: src/pages/UserDetailAuditPage.tsx:559
msgid "Notably, {pdfCount} PDF and {csvCount} CSV files have been shared."
msgstr "En particular, se compartieron {pdfCount} archivos PDF y {csvCount} archivos CSV."

#: src/pages/UserDetailAuditPage.tsx:698
msgid "Note: Analytic Agent is a placeholder. Real AI analysis coming soon."
msgstr "Nota: el agente analítico es un marcador de posición. Pronto habrá análisis real con IA."

#: src/pages/MemoryPage.tsx:875
msgid "Notes on these topics may be recalled only in conversations on the same topic."
msgstr "Las notas sobre estos temas solo pueden recordarse en conversaciones sobre el mismo tema."

#: src/pages/MemoryPage.tsx:1047
msgid "Nothing compiled yet."
msgstr "Aún no hay nada compilado."

#: src/pages/MemoryPage.tsx:1167
msgid "Nothing here."
msgstr "No hay nada aquí."

#: src/pages/MemoryPage.tsx:1402
msgid "Nothing shared yet. Use the Share button on one of your memories to give your team stable context."
msgstr "Todavía no has compartido nada. Usa el botón Compartir en uno de tus recuerdos para darle a tu equipo un contexto estable."

#: src/pages/LoginPage.tsx:50
msgid "OAuth callback error. Please try again."
msgstr "Error en el retorno de OAuth. Inténtalo de nuevo."

#: src/pages/PrivateMcpPage.tsx:922
msgid "OAuth client"
msgstr "Cliente de OAuth"

#: src/pages/PrivateMcpPage.tsx:939
#: src/pages/PrivateMcpPage.tsx:1015
msgid "OAuth client ID"
msgstr "ID de cliente de OAuth"

#: src/pages/PrivateMcpPage.tsx:952
msgid "OAuth client secret"
msgstr "Secreto de cliente de OAuth"

#: src/components/ProviderDetailModal.tsx:215
msgid "of {userCount} team members"
msgstr "de {userCount} integrantes del equipo"

#: src/pages/MemoryPage.tsx:923
msgid "Off. Team memory is opt in: turn it on to use the memories your teammates shared. Nothing of yours becomes visible until you share a memory yourself, and what teammates see is Privacy Twins, never your real values."
msgstr "Apagada. La memoria del equipo es opcional: enciéndela para usar los recuerdos que compartieron tus compañeros. Nada tuyo se vuelve visible hasta que tú compartas un recuerdo, y lo que ven tus compañeros son valores sintéticos, nunca tus valores reales."

#: src/pages/MemoryPage.tsx:922
msgid "On. Memories your teammates shared are used alongside your own, and teammates see only the memories you explicitly shared. Everything they see is Privacy Twins; real values never leave your vault."
msgstr "Encendida. Los recuerdos que compartieron tus compañeros se usan junto con los tuyos, y ellos solo ven los recuerdos que compartiste de forma explícita. Todo lo que ven son valores sintéticos; los valores reales nunca salen de tu bóveda."

#: src/pages/UserDetailAuditPage.tsx:1084
msgid "Onchain Audit Transaction"
msgstr "Transacción de auditoría en cadena"

#: src/pages/SubscriptionPage.tsx:174
#~ msgid "One seat, one person. Your login, your devices."
#~ msgstr "Un puesto, una persona. Tu ingreso, tus dispositivos."

#: src/pages/PrivateMcpPage.tsx:689
#: src/pages/PrivateMcpPage.tsx:847
#: src/pages/PrivateMcpPage.tsx:1037
#: src/pages/PrivateMcpPage.tsx:1232
msgid "Only administrators can change this registration."
msgstr "Solo los administradores pueden cambiar este registro."

#: src/pages/SubscriptionPage.tsx:417
#~ msgid "Only for a domain with a single user. Teams run on Max."
#~ msgstr "Solo para un dominio con un único usuario. Los equipos funcionan con Max."

#: src/components/Layout.tsx:332
msgid "Open menu"
msgstr "Abrir el menú"

#: src/pages/MemoryPage.tsx:104
msgid "Opinion"
msgstr "Opinión"

#. placeholder {0}: oauthOptionalScopes.join(', ')
#: src/pages/ConnectionsPage.tsx:964
msgid "Optional scopes (custom objects, custom properties, tickets): <0>{0}</0>"
msgstr "Alcances opcionales (objetos personalizados, propiedades personalizadas, tickets): <0>{0}</0>"

#: src/pages/LoginPage.tsx:338
msgid "OR"
msgstr "O"

#: src/components/Layout.tsx:609
msgid "Or install via command line"
msgstr "O instala por línea de comandos"

#: src/pages/InvitePage.tsx:657
#: src/pages/SignupPage.tsx:472
msgid "Or via Email"
msgstr "O por correo"

#: src/pages/UserDetailAuditPage.tsx:1009
msgid "Original Prompt Text"
msgstr "Texto original del prompt"

#: src/pages/UserDetailAuditPage.tsx:976
msgid "Original:"
msgstr "Original:"

#. placeholder {0}: detail.packConfidence.toFixed(2)
#: src/pages/MemoryPage.tsx:1355
msgid "pack confidence {0}"
msgstr "confianza del paquete {0}"

#: src/pages/AgentsPage.tsx:1090
msgid "Parse Attempts:"
msgstr "Intentos de análisis:"

#: src/pages/ConnectionsPage.tsx:1133
msgid "Passthrough Authorization"
msgstr "Autorización de paso"

#: src/pages/ConnectionsPage.tsx:1073
#: src/pages/InvitePage.tsx:695
#: src/pages/LoginPage.tsx:300
#: src/pages/SignupPage.tsx:491
msgid "Password"
msgstr "Contraseña"

#: src/pages/SignupPage.tsx:200
msgid "Password does not meet the requirements below"
msgstr "La contraseña no cumple los requisitos de abajo"

#: src/pages/InvitePage.tsx:99
msgid "Password must be at least 8 characters"
msgstr "La contraseña debe tener mínimo 8 caracteres"

#: src/pages/InvitePage.tsx:103
msgid "Password must include an uppercase letter, a lowercase letter, and a number"
msgstr "La contraseña debe incluir una mayúscula, una minúscula y un número"

#: src/pages/ResetPasswordPage.tsx:258
msgid "Password updated"
msgstr "Contraseña actualizada"

#: src/pages/InvitePage.tsx:94
#: src/pages/SignupPage.tsx:203
msgid "Passwords do not match"
msgstr "Las contraseñas no coinciden"

#: src/pages/ResetPasswordPage.tsx:88
#: src/pages/ResetPasswordPage.tsx:241
msgid "Passwords do not match."
msgstr "Las contraseñas no coinciden."

#: src/pages/UserDetailAuditPage.tsx:793
msgid "Past {days} days"
msgstr "Últimos {days} días"

#: src/pages/UserDetailAuditPage.tsx:793
msgid "Past 1 year"
msgstr "Último año"

#: src/pages/AgentsPage.tsx:966
msgid "Paste audit data, pipeline logs, or a summary for the agent to analyze..."
msgstr "Pega datos de auditoría, registros del pipeline o un resumen para que el agente los analice..."

#: src/pages/AgentsPage.tsx:965
msgid "Paste or type the prompt you want the agent to analyze for PII handling decisions..."
msgstr "Pega o escribe el prompt que quieres que el agente analice para decidir el manejo de PII..."

#: src/pages/MemoryPage.tsx:1213
msgid "Paste the exported memory text here"
msgstr "Pega aquí el texto de la memoria exportada"

#: src/pages/MemoryPage.tsx:1193
msgid "Paste the memory export from ChatGPT, Claude or Gemini. It is protected before it leaves the browser: the text is turned into Privacy Twins first, and only that twin-space version is ever stored."
msgstr "Pega la exportación de memoria de ChatGPT, Claude o Gemini. Se protege antes de salir del navegador: el texto se convierte primero en Privacy Twins y solo esa versión en espacio de gemelos se guarda."

#: src/pages/ConnectionsPage.tsx:603
msgid "Paste your Box application JSON config or developer token"
msgstr "Pega la configuración JSON de tu aplicación de Box o el token de desarrollador"

#: src/pages/ConnectionsPage.tsx:604
msgid "Paste your Dropbox app access token"
msgstr "Pega el token de acceso de tu app de Dropbox"

#: src/pages/ConnectionsPage.tsx:600
msgid "Paste your Google Cloud service account JSON key or API key"
msgstr "Pega la llave JSON de la cuenta de servicio de Google Cloud o la llave de API"

#: src/pages/ConnectionsPage.tsx:602
msgid "Paste your Notion internal integration token (secret_...)"
msgstr "Pega el token de integración interna de Notion (secret_...)"

#: src/pages/ConnectionsPage.tsx:613
msgid "Paste your Slack Bot User OAuth Token (xoxb-...)"
msgstr "Pega el OAuth Token del usuario bot de Slack (xoxb-...)"

#: src/pages/ConnectionsPage.tsx:615
msgid "Paste your Telegram Bot API token from @BotFather"
msgstr "Pega el token de la API de bots de Telegram que te dio @BotFather"

#: src/pages/MemoryPage.tsx:851
msgid "Pause capture and recall without deleting anything."
msgstr "Pausa la captura y la recuperación sin borrar nada."

#: src/components/UpgradeModal.tsx:159
#: src/pages/SubscriptionPage.tsx:286
msgid "Payment failed"
msgstr "Falló el pago"

#: src/pages/OnboardingPage.tsx:149
#~ msgid "Payment failed. Please try again."
#~ msgstr "Falló el pago. Inténtalo de nuevo."

#: src/pages/SubscriptionPage.tsx:680
msgid "Payment failed. Update the payment method below, then try the upgrade again."
msgstr "Falló el pago. Actualiza el método de pago aquí abajo y vuelve a intentar la mejora."

#: src/utils/licenses.ts:203
msgid "Payment failed. Update the payment method on the Subscription page."
msgstr "Falló el pago. Actualiza el método de pago en la página de Suscripción."

#: src/pages/DashboardPage.tsx:300
msgid "Payment failed. Update your payment method to keep protection active."
msgstr "Falló el pago. Actualiza tu método de pago para mantener activa la protección."

#: src/pages/SignupPage.tsx:672
#~ msgid "Payment Information"
#~ msgstr "Datos del pago"

#: src/pages/SubscriptionPage.tsx:492
msgid "Payment Method"
msgstr "Método de pago"

#: src/pages/SubscriptionPage.tsx:466
msgid "Payment method updated successfully"
msgstr "Método de pago actualizado"

#: src/pages/SignupPage.tsx:117
#~ msgid "Payment Summary"
#~ msgstr "Resumen del pago"

#: src/pages/MemoryPage.tsx:643
msgid "People & projects"
msgstr "Personas y proyectos"

#: src/pages/SubscriptionPage.tsx:121
msgid "Per seat per month. All seats bill at your band."
msgstr "Por puesto al mes. Todos los puestos se facturan según tu banda."

#: src/pages/SubscriptionPage.tsx:120
msgid "Per seat, billed annually. All seats bill at your band."
msgstr "Por puesto, con cobro anual. Todos los puestos se facturan según tu banda."

#: src/pages/MemoryPage.tsx:736
msgid "Pin"
msgstr "Fijar"

#: src/pages/MemoryPage.tsx:688
msgid "Pinned"
msgstr "Fijado"

#: src/pages/SubscriptionPage.tsx:920
msgid "Plan Ends"
msgstr "El plan termina"

#: src/pages/UserDetailAuditPage.tsx:1044
msgid "Platform"
msgstr "Plataforma"

#: src/pages/UserDetailAuditPage.tsx:757
msgid "Platforms"
msgstr "Plataformas"

#: src/pages/SignupPage.tsx:197
msgid "Please enter a valid email address"
msgstr "Escribe un correo válido"

#: src/pages/InvitePage.tsx:89
msgid "Please fill in all fields"
msgstr "Completa todos los campos"

#: src/pages/LoginPage.tsx:73
msgid "Please verify your email before signing in."
msgstr "Verifica tu correo antes de ingresar."

#: src/pages/LoginPage.tsx:331
msgid "Please wait..."
msgstr "Espera un momento..."

#: src/pages/PrivateMcpPage.tsx:1103
msgid "Point your AI assistant at this URL instead of HubSpot's own MCP server. PrivacyPal fronts HubSpot's MCP server and translates between twins and real CRM data at the boundary. Records created and updated through it carry real values, and HubSpot's write confirmations reach you with twins in place of real values."
msgstr "Apunta tu asistente de IA a esta URL en lugar del servidor MCP propio de HubSpot. PrivacyPal se ubica frente al servidor MCP de HubSpot y traduce entre gemelos y datos reales del CRM en el límite. Los registros creados y actualizados a través de ella llevan valores reales, y las confirmaciones de escritura de HubSpot te llegan con gemelos en lugar de los valores reales."

#: src/pages/PrivateMcpPage.tsx:911
msgid "Point your AI assistant at this URL; PrivacyPal translates between twins and real Google Workspace data at the boundary. Mail sent and files written through it carry real values."
msgstr "Apunte su asistente de IA a esta URL; PrivacyPal traduce entre gemelos y datos reales de Google Workspace en el límite. El correo enviado y los archivos escritos a través de ella llevan valores reales."

#: src/pages/PrivateMcpPage.tsx:749
msgid "Point your AI assistant at this URL; PrivacyPal translates between twins and real Microsoft 365 data at the boundary. Mail sent and files written through it carry real values."
msgstr "Apunta tu asistente de IA a esta URL; PrivacyPal traduce entre los valores sintéticos y los datos reales de Microsoft 365 en el límite del sistema. Los correos enviados y los archivos escritos a través de ella llevan valores reales."

#: src/pages/PrivateMcpPage.tsx:572
msgid "Point your AI assistant at this URL; PrivacyPal translates between twins and real Salesforce data at the boundary."
msgstr "Apunta tu asistente de IA a esta URL; PrivacyPal traduce entre los valores sintéticos y los datos reales de Salesforce en el límite del sistema."

#: src/pages/ConnectionsPage.tsx:520
msgid "Popup blocked. Please allow popups for this site and try again."
msgstr "Ventana emergente bloqueada. Permite las ventanas emergentes de este sitio e inténtalo de nuevo."

#: src/pages/ConnectionsPage.tsx:1060
msgid "Port"
msgstr "Puerto"

#: src/pages/AgentsPage.tsx:805
msgid "Pre-defined Agents"
msgstr "Agentes predefinidos"

#: src/pages/MemoryPage.tsx:101
msgid "Preference"
msgstr "Preferencia"

#: src/App.tsx:141
#: src/pages/AgentsPage.tsx:404
msgid "Privacy Agents"
msgstr "Agentes de privacidad"

#: src/pages/OnboardingPage.tsx:395
msgid "Privacy Twin"
msgstr "Valor sintético"

#: src/pages/UserDetailAuditPage.tsx:1017
msgid "Privacy Twin (Encoded) Prompt"
msgstr "Prompt con valor sintético (codificado)"

#: src/pages/UserDetailAuditPage.tsx:984
msgid "Privacy Twin (Encoded):"
msgstr "Valor sintético (codificado):"

#: src/pages/OnboardingPage.tsx:479
msgid "PrivacyPal doesn't sleep."
msgstr "PrivacyPal no duerme."

#: src/pages/OnboardingPage.tsx:429
msgid "PrivacyPal fits into your workflow, whether you're building integrations or simply want it to run quietly in the background."
msgstr "PrivacyPal se adapta a tu flujo de trabajo, ya sea que estés construyendo integraciones o que simplemente quieras que funcione en silencio en segundo plano."

#: src/components/Layout.tsx:556
msgid "PrivacyPal for desktop"
msgstr "PrivacyPal para computador"

#: src/pages/OnboardingPage.tsx:533
msgid "PrivacyPal is live. Taking you to your dashboard…"
msgstr "PrivacyPal está activo. Te llevamos a tu panel…"

#: src/pages/OnboardingPage.tsx:325
msgid "PrivacyPal Layer"
msgstr "Capa PrivacyPal"

#: src/pages/SignupPage.tsx:630
#: src/pages/SubscriptionPage.tsx:768
#: src/pages/SubscriptionPage.tsx:784
msgid "PrivacyPal Max"
msgstr "PrivacyPal Max"

#: src/pages/MemoryPage.tsx:331
msgid "PrivacyPal Max is required for team memory. Ask your admin to upgrade your seat."
msgstr "Se necesita PrivacyPal Max para la memoria del equipo. Pídele a tu administrador que mejore tu puesto."

#: src/components/MaxUpsell.tsx:39
#~ msgid "PrivacyPal Max is required for this feature"
#~ msgstr "Se necesita PrivacyPal Max para esta función"

#: src/pages/MemoryPage.tsx:289
msgid "PrivacyPal Max is required to share memories"
msgstr "Se necesita PrivacyPal Max para compartir recuerdos"

#: src/pages/SignupPage.tsx:615
msgid "PrivacyPal Pro"
msgstr "PrivacyPal Pro"

#: src/pages/SubscriptionPage.tsx:768
msgid "PrivacyPal Pro, free"
msgstr "PrivacyPal Pro, gratis"

#: src/App.tsx:208
#: src/components/Layout.tsx:238
#: src/pages/PrivateMcpPage.tsx:517
msgid "Private MCP"
msgstr "Private MCP"

#: src/pages/SubscriptionPage.tsx:53
msgid "Private MCP, Privacy Agents, IP Connections, agent governance, Multiplayer Memory"
msgstr "Private MCP, agentes de privacidad, conexiones de PI, gobierno de agentes y memoria multijugador"

#: src/pages/PrivateMcpPage.tsx:519
msgid "Private MCPs let your AI assistant work with your business systems while it only ever sees Privacy Twins. PrivacyPal translates between twins and real data at the system boundary. Each connector below is its own Private MCP."
msgstr "Los Private MCP permiten que tu asistente de IA trabaje con los sistemas de tu negocio viendo únicamente valores sintéticos. PrivacyPal traduce entre los valores sintéticos y los datos reales en el límite del sistema. Cada conector de abajo es su propio Private MCP."

#: src/pages/MemoryPage.tsx:789
msgid "Private Memory"
msgstr "Memoria privada"

#: src/pages/DashboardPage.tsx:376
msgid "Pro (Free)"
msgstr "Pro (Gratis)"

#: src/utils/licenses.ts:153
msgid "Pro is an individual account (one seat, one person), so a team cannot add Pro seats; this move is refused."
msgstr "Pro es una cuenta individual (un puesto, una persona), así que un equipo no puede agregar puestos Pro; este cambio se rechaza."

#: src/utils/licenses.ts:192
msgid "Pro is an individual account. A domain with more than one user runs on Max for every user."
msgstr "Pro es una cuenta individual. Un dominio con más de un usuario funciona con Max para todos."

#: src/pages/DashboardPage.tsx:376
msgid "Pro Plan"
msgstr "Plan Pro"

#: src/pages/SignupPage.tsx:125
#~ msgid "Pro Plan (individual)"
#~ msgstr "Plan Pro (individual)"

#: src/pages/OnboardingPage.tsx:166
#~ msgid "Pro Plan: {trialDays}-Day Trial"
#~ msgstr "Plan Pro: prueba de {trialDays} días"

#: src/components/UpgradeModal.tsx:302
#: src/components/UpgradeModal.tsx:523
#: src/pages/SubscriptionPage.tsx:420
msgid "Processing..."
msgstr "Procesando..."

#: src/pages/MemoryPage.tsx:640
msgid "Profile"
msgstr "Perfil"

#: src/pages/MemoryPage.tsx:482
msgid "Profile refreshed from your memories"
msgstr "Perfil actualizado a partir de tus recuerdos"

#: src/pages/MemoryPage.tsx:469
msgid "Profile updated"
msgstr "Perfil guardado"

#: src/components/UpgradeModal.tsx:216
#: src/pages/SubscriptionPage.tsx:365
#: src/pages/SubscriptionPage.tsx:858
msgid "Promo Code"
msgstr "Código promocional"

#: src/pages/OnboardingPage.tsx:178
#~ msgid "Promo Code <0>(optional)</0>"
#~ msgstr "Código promocional <0>(opcional)</0>"

#: src/pages/SignupPage.tsx:634
#~ msgid "Promotion Code"
#~ msgstr "Código de promoción"

#. placeholder {0}: promptIdx + 1
#: src/pages/UserDetailAuditPage.tsx:896
#: src/pages/UserDetailAuditPage.tsx:969
msgid "Prompt {0}"
msgstr "Prompt {0}"

#: src/components/ProviderDetailModal.tsx:361
#: src/components/ProviderDetailModal.tsx:363
msgid "Prompt share by tool"
msgstr "Participación de prompts por herramienta"

#: src/pages/DashboardPage.tsx:601
msgid "prompts"
msgstr "prompts"

#: src/components/ProviderDetailModal.tsx:402
#: src/pages/DashboardPage.tsx:634
msgid "Prompts"
msgstr "Prompts"

#: src/components/ProviderDetailModal.tsx:201
msgid "Prompts protected"
msgstr "Prompts protegidos"

#: src/components/ProviderDetailModal.tsx:276
msgid "Prompts sent through {toolNames} will appear here once protected."
msgstr "Los prompts enviados por {toolNames} aparecerán aquí una vez protegidos."

#: src/pages/DashboardPage.tsx:347
msgid "Prompts This Month"
msgstr "Prompts de este mes"

#: src/pages/ConnectionsPage.tsx:1151
msgid ""
"Properties to skip, e.g. deals.amount, companies.secret_codename\n"
"Separate with commas or new lines"
msgstr ""
"Propiedades que se omiten, p. ej. deals.amount, companies.secret_codename\n"
"Sepáralas con comas o saltos de línea"

#: src/components/UpgradeModal.tsx:627
msgid "Protect every AI surface: Cowork, Claude Code, Codex, Copilot, agents and the APIs, plus Connections, Private MCP, API access and full usage history."
msgstr "Protege cada superficie de IA: Cowork, Claude Code, Codex, Copilot, agentes y las API, además de Connections, Private MCP, acceso a la API e historial de uso completo."

#: src/pages/DashboardPage.tsx:328
msgid "Protect everything with Max"
msgstr "Protégelo todo con Max"

#: src/pages/DashboardPage.tsx:554
#: src/pages/UserDetailAuditPage.tsx:1048
msgid "Protected from"
msgstr "Protegido desde"

#: src/pages/OnboardingPage.tsx:367
msgid "Protected output"
msgstr "Salida protegida"

#: src/pages/DashboardPage.tsx:429
msgid "Protected prompts per day, by AI app"
msgstr "Prompts protegidos por día, según la app de IA"

#: src/pages/OnboardingPage.tsx:384
msgid "Protected text will appear here"
msgstr "El texto protegido aparecerá aquí"

#: src/pages/SubscriptionPage.tsx:788
msgid "Protection on every AI surface: Cowork, Claude Code, Codex, Copilot, Grok Bot, Hermes and the OpenAI, Anthropic and xAI APIs"
msgstr "Protección en cada superficie de IA: Cowork, Claude Code, Codex, Copilot, Grok Bot, Hermes y las API de OpenAI, Anthropic y xAI"

#: src/components/Layout.tsx:691
msgid "Protects command-line AI agents on Ubuntu, Fedora and WSL. This is a headless CLI, not a desktop app: it covers agents such as Claude Code and Codex, and does not cover browser AI."
msgstr "Protege los agentes de IA de línea de comandos en Ubuntu, Fedora y WSL. Es una CLI sin interfaz gráfica, no una aplicación de escritorio: cubre agentes como Claude Code y Codex, y no cubre la IA del navegador."

#: src/pages/DashboardPage.tsx:633
msgid "Provider"
msgstr "Proveedor"

#: src/pages/OnboardingPage.tsx:434
msgid "Proxy app & browser extension"
msgstr "App de proxy y extensión del navegador"

#: src/utils/licenses.ts:154
msgid "Purchase additional {tierLabel} seats before moving this user; until then this move is refused."
msgstr "Compra más puestos {tierLabel} antes de mover a este usuario; hasta entonces el cambio se rechaza."

#: src/pages/MemoryPage.tsx:133
msgid "Quarantined"
msgstr "En cuarentena"

#: src/pages/OnboardingPage.tsx:450
msgid "QUICK START"
msgstr "INICIO RÁPIDO"

#: src/pages/ConnectionsPage.tsx:603
msgid "Read access to all files and folders. Requires a Box custom app with Server Authentication (JWT)."
msgstr "Acceso de lectura a todos los archivos y carpetas. Requiere una app personalizada de Box con autenticación de servidor (JWT)."

#: src/pages/ConnectionsPage.tsx:605
msgid "Read access to cabinets and workspaces. Requires API client credentials from the NetDocuments admin console."
msgstr "Acceso de lectura a gabinetes y espacios de trabajo. Requiere credenciales de cliente de API de la consola de administración de NetDocuments."

#: src/pages/ConnectionsPage.tsx:602
msgid "Read content capability on the internal integration. Create an integration at notion.so/my-integrations."
msgstr "Capacidad de lectura de contenido en la integración interna. Crea una integración en notion.so/my-integrations."

#: src/pages/ConnectionsPage.tsx:649
msgid "Read-only access (db_datareader role) to target databases. Service account with SELECT permission on relevant schemas."
msgstr "Acceso de solo lectura (rol db_datareader) a las bases de datos objetivo. Cuenta de servicio con permiso SELECT sobre los esquemas relevantes."

#: src/pages/ConnectionsPage.tsx:600
msgid "Read-only access to files, folder listing, and metadata. Requires a Google Cloud service account key with Drive API enabled."
msgstr "Acceso de solo lectura a archivos, listado de carpetas y metadatos. Requiere una llave de cuenta de servicio de Google Cloud con la API de Drive habilitada."

#: src/pages/ConnectionsPage.tsx:650
msgid "Read-only user with find permission on target databases/collections. Connection via standard MongoDB URI."
msgstr "Usuario de solo lectura con permiso find sobre las bases de datos o colecciones objetivo. Conexión por URI estándar de MongoDB."

#: src/pages/ConnectionsPage.tsx:651
msgid "Read-only user with SELECT privilege on target databases. CREATE USER with limited grants recommended."
msgstr "Usuario de solo lectura con privilegio SELECT sobre las bases de datos objetivo. Se recomienda CREATE USER con permisos limitados."

#: src/pages/OnboardingPage.tsx:505
msgid "Ready to activate."
msgstr "Listo para activar."

#: src/pages/OnboardingPage.tsx:394
msgid "Real Value"
msgstr "Valor real"

#: src/pages/AgentsPage.tsx:476
#: src/pages/AgentsPage.tsx:847
#: src/pages/AgentsPage.tsx:894
msgid "Real-time"
msgstr "Tiempo real"

#: src/pages/AgentsPage.tsx:950
#: src/pages/AgentsPage.tsx:1017
msgid "Real-time Agent"
msgstr "Agente en tiempo real"

#: src/pages/AgentsPage.tsx:855
msgid "Real-time agents execute during streaming encode/decode operations to block, augment, or configure the pipeline."
msgstr "Los agentes en tiempo real se ejecutan durante las operaciones de codificación y decodificación en streaming para bloquear, ampliar o configurar el pipeline."

#: src/pages/OnboardingPage.tsx:325
msgid "Real-time interception & masking with Privacy Twins"
msgstr "Intercepción y reemplazo en tiempo real con valores sintéticos"

#: src/pages/SubscriptionPage.tsx:774
msgid "Real-time protection for ChatGPT, Claude, Gemini, Grok and Perplexity chats, attachments included. No card on file, nothing to cancel, free forever."
msgstr "Protección en tiempo real para los chats de ChatGPT, Claude, Gemini, Grok y Perplexity, adjuntos incluidos. Sin tarjeta registrada, nada que cancelar, gratis para siempre."

#: src/pages/SignupPage.tsx:619
msgid "Real-time protection for ChatGPT, Claude, Gemini, Grok and Perplexity chats, attachments included. One person, free forever."
msgstr "Protección en tiempo real para los chats de ChatGPT, Claude, Gemini, Grok y Perplexity, adjuntos incluidos. Una persona, gratis para siempre."

#: src/pages/InvitePage.tsx:511
msgid "Real-time scrubbing"
msgstr "Limpieza en tiempo real"

#: src/pages/OnboardingPage.tsx:326
msgid "Receive clean, safe data only"
msgstr "Recibe únicamente datos limpios y seguros"

#: src/components/connections/ConnectionActions.tsx:37
msgid "Reconnect"
msgstr "Volver a conectar"

#: src/pages/ConnectionsPage.tsx:956
msgid "Redirect URL to register"
msgstr "URL de redirección por registrar"

#: src/pages/SubscriptionPage.tsx:302
msgid "Redirecting to dashboard..."
msgstr "Redirigiendo al panel..."

#: src/pages/PrivateMcpPage.tsx:1307
msgid "Refresh"
msgstr "Actualizar"

#: src/pages/MemoryPage.tsx:1019
msgid "Refresh now"
msgstr "Actualizar ahora"

#: src/pages/MemoryPage.tsx:1068
msgid "Refreshed on {refreshedOn} by {refreshedBy}"
msgstr "Actualizado el {refreshedOn} por {refreshedBy}"

#: src/pages/MemoryPage.tsx:1019
msgid "Refreshing…"
msgstr "Actualizando…"

#: src/pages/PrivateMcpPage.tsx:854
msgid "Register an app in your own Microsoft Entra tenant as a public client: add the redirect URI below under the \"Mobile and desktop applications\" platform, and grant the delegated Microsoft Graph permissions <0>{M365_PERMISSIONS}</0> (admin consent if your tenant requires it). Only these public values are kept here; no secret is stored with PrivacyPal."
msgstr "Registra una app en tu propio tenant de Microsoft Entra como cliente público: agrega la URI de redirección de abajo en la plataforma \"Mobile and desktop applications\" y concede los permisos delegados de Microsoft Graph <0>{M365_PERMISSIONS}</0> (con consentimiento de administrador si tu tenant lo exige). Aquí solo se guardan estos valores públicos; PrivacyPal no almacena ningún secreto."

#: src/pages/PrivateMcpPage.tsx:695
msgid "Register an External Client App in your own Salesforce org with the OAuth scopes <0>mcp_api</0> and <1>refresh_token</1> and PKCE enabled. Only these public values are kept here; no secret is stored with PrivacyPal."
msgstr "Registra una External Client App en tu propia organización de Salesforce con los alcances de OAuth <0>mcp_api</0> y <1>refresh_token</1> y con PKCE habilitado. Aquí solo se guardan estos valores públicos; PrivacyPal no almacena ningún secreto."

#: src/pages/PrivateMcpPage.tsx:39
msgid "Registered"
msgstr "Registrada"

#. placeholder {0}: formatEpochMs(app.updatedAt)
#. placeholder {0}: formatEpochMs(googleApp.updatedAt)
#. placeholder {0}: formatEpochMs(hubspotApp.updatedAt)
#: src/pages/PrivateMcpPage.tsx:586
#: src/pages/PrivateMcpPage.tsx:763
#: src/pages/PrivateMcpPage.tsx:925
#: src/pages/PrivateMcpPage.tsx:1119
msgid "Registered. Last updated {0}"
msgstr "Registrada. Última actualización {0}"

#: src/pages/InvitePage.tsx:162
#: src/pages/LoginPage.tsx:116
#: src/pages/SignupPage.tsx:293
msgid "Registration failed"
msgstr "Falló el registro"

#: src/pages/MemoryPage.tsx:1118
msgid "Remember"
msgstr "Recordar"

#: src/pages/MemoryPage.tsx:1092
msgid "Remember something"
msgstr "Recordar algo"

#: src/pages/MemoryPage.tsx:440
msgid "Remembered"
msgstr "Recordado"

#: src/pages/MemoryPage.tsx:1431
#: src/pages/PrivateMcpPage.tsx:1380
#: src/pages/PrivateMcpPage.tsx:1390
#: src/pages/PrivateMcpPage.tsx:1400
#: src/pages/PrivateMcpPage.tsx:1410
msgid "Remove"
msgstr "Eliminar"

#: src/pages/PrivateMcpPage.tsx:1378
#: src/pages/PrivateMcpPage.tsx:1388
#: src/pages/PrivateMcpPage.tsx:1398
#: src/pages/PrivateMcpPage.tsx:1408
msgid "Remove app registration"
msgstr "Eliminar el registro de la app"

#: src/pages/PrivateMcpPage.tsx:659
#: src/pages/PrivateMcpPage.tsx:823
#: src/pages/PrivateMcpPage.tsx:1005
#: src/pages/PrivateMcpPage.tsx:1200
msgid "Remove registration"
msgstr "Eliminar el registro"

#: src/pages/PrivateMcpPage.tsx:1399
msgid "Remove the Google OAuth client for this workspace? The stored client secret is deleted with it, and users will not be able to connect their assistants to Gmail or Drive until an administrator registers a client again."
msgstr "¿Eliminar el cliente de OAuth de Google de este espacio de trabajo? El secreto de cliente guardado se elimina con él, y los usuarios no podrán conectar sus asistentes a Gmail ni a Drive hasta que un administrador registre un cliente de nuevo."

#: src/pages/PrivateMcpPage.tsx:1409
msgid "Remove the HubSpot MCP connector for this workspace? The stored client secret is deleted with it, and users will not be able to connect their assistants to HubSpot until an administrator registers a connector again."
msgstr "¿Eliminar el conector MCP de HubSpot de este espacio de trabajo? El secreto de cliente guardado se borra con él, y los usuarios no podrán conectar sus asistentes a HubSpot hasta que un administrador vuelva a registrar un conector."

#: src/pages/PrivateMcpPage.tsx:1389
msgid "Remove the Microsoft Entra app registration for this workspace? Users will not be able to connect their assistants to Microsoft 365 until an administrator registers an app again."
msgstr "¿Eliminar el registro de la app de Microsoft Entra de este espacio de trabajo? Los usuarios no podrán conectar sus asistentes a Microsoft 365 hasta que un administrador registre una app de nuevo."

#: src/pages/PrivateMcpPage.tsx:1379
msgid "Remove the Salesforce External Client App registration for this workspace? Users will not be able to connect their assistants until an administrator registers an app again."
msgstr "¿Eliminar el registro de la External Client App de Salesforce de este espacio de trabajo? Los usuarios no podrán conectar sus asistentes hasta que un administrador registre una app de nuevo."

#. placeholder {0}: new Date(account.subscriptionEndDate).toLocaleDateString()
#: src/pages/DashboardPage.tsx:399
msgid "Renews {0}"
msgstr "Se renueva el {0}"

#: src/pages/ResetPasswordPage.tsx:164
msgid "Request a new link"
msgstr "Solicitar un enlace nuevo"

#: src/pages/ResetPasswordPage.tsx:157
msgid "Request a new one below."
msgstr "Solicita uno nuevo aquí abajo."

#: src/pages/ApiKeysPage.tsx:135
msgid "Requests"
msgstr "Solicitudes"

#. placeholder {0}: (oauthScopes.length ? oauthScopes : ['api', 'refresh_token']).join(', ')
#: src/pages/ConnectionsPage.tsx:907
msgid "Required OAuth scopes: <0>{0}</0>"
msgstr "Alcances de OAuth requeridos: <0>{0}</0>"

#: src/pages/ConnectionsPage.tsx:872
msgid "Required Permissions"
msgstr "Permisos requeridos"

#. placeholder {0}: oauthScopes.join(', ') || '…'
#: src/pages/ConnectionsPage.tsx:962
msgid "Required scopes: <0>{0}</0>"
msgstr "Alcances obligatorios: <0>{0}</0>"

#: src/components/Layout.tsx:730
msgid "Requires a Max account. Run uname -m to check your architecture."
msgstr "Requiere una cuenta Max. Ejecuta uname -m para ver tu arquitectura."

#: src/pages/InvitePage.tsx:602
#: src/pages/LoginPage.tsx:221
#: src/pages/SignupPage.tsx:556
msgid "Resend code"
msgstr "Reenviar el código"

#: src/pages/InvitePage.tsx:602
#: src/pages/LoginPage.tsx:221
#: src/pages/SignupPage.tsx:556
msgid "Resend code ({resendCooldown}s)"
msgstr "Reenviar el código ({resendCooldown} s)"

#: src/pages/ForgotPasswordPage.tsx:96
msgid "Resend email"
msgstr "Reenviar el correo"

#: src/pages/ForgotPasswordPage.tsx:96
msgid "Resend email ({cooldown}s)"
msgstr "Reenviar el correo ({cooldown} s)"

#: src/pages/LoginPage.tsx:249
msgid "Resend verification email to {needsVerification}"
msgstr "Reenviar el correo de verificación a {needsVerification}"

#: src/pages/MemoryPage.tsx:125
msgid "Response preferences"
msgstr "Preferencias de respuesta"

#: src/pages/MemoryPage.tsx:741
msgid "Restore"
msgstr "Restaurar"

#: src/components/connections/ConnectionActions.tsx:22
msgid "Retry scan"
msgstr "Reintentar el análisis"

#: src/pages/MemoryPage.tsx:998
msgid "Review"
msgstr "Revisar"

#: src/pages/ApiKeysPage.tsx:161
#: src/pages/PrivateMcpPage.tsx:1357
#: src/pages/PrivateMcpPage.tsx:1420
msgid "Revoke"
msgstr "Revocar"

#: src/pages/PrivateMcpPage.tsx:1418
msgid "Revoke connection"
msgstr "Revocar la conexión"

#: src/pages/PrivateMcpPage.tsx:557
#~ msgid "Revoke the {revokeConnectorId} connection for {revokeWho}? Their assistant will need to reconnect through Salesforce."
#~ msgstr "¿Revocar la conexión {revokeConnectorId} de {revokeWho}? Su asistente tendrá que volver a conectarse por Salesforce."

#: src/pages/PrivateMcpPage.tsx:1419
msgid "Revoke the {revokeConnectorId} connection for {revokeWho}? Their assistant will need to reconnect."
msgstr "¿Revocar la conexión {revokeConnectorId} de {revokeWho}? Su asistente tendrá que volver a conectarse."

#: src/pages/ApiKeysPage.tsx:186
msgid "Revoked"
msgstr "Revocada"

#. placeholder {0}: revokedKeys.length
#: src/pages/ApiKeysPage.tsx:176
msgid "Revoked Keys ({0})"
msgstr "Llaves revocadas ({0})"

#: src/pages/ApiKeysPage.tsx:161
msgid "Revoking..."
msgstr "Revocando..."

#: src/pages/UserManagementPage.tsx:286
msgid "Role"
msgstr "Rol"

#: src/pages/AgentsPage.tsx:821
msgid "RT"
msgstr "TR"

#. placeholder {0}: runInputModal.agent.name
#: src/pages/AgentsPage.tsx:948
msgid "Run {0}"
msgstr "Ejecución {0}"

#: src/pages/AgentsPage.tsx:493
msgid "Run against recent audit data"
msgstr "Ejecutar sobre los datos de auditoría recientes"

#: src/components/Layout.tsx:589
msgid "Run PrivacyPal on your PC with a full installer. Optimized for the Windows 11 experience."
msgstr "Ejecuta PrivacyPal en tu PC con un instalador completo. Optimizado para la experiencia de Windows 11."

#: src/pages/OnboardingPage.tsx:412
msgid "Run Protection"
msgstr "Ejecutar la protección"

#: src/pages/AgentsPage.tsx:1083
msgid "Runtime:"
msgstr "Tiempo de ejecución:"

#: src/pages/PrivateMcpPage.tsx:363
msgid "Salesforce app registration removed"
msgstr "Registro de la app de Salesforce eliminado"

#: src/pages/PrivateMcpPage.tsx:340
msgid "Salesforce app registration saved"
msgstr "Registro de la app de Salesforce guardado"

#: src/pages/SalesforceOAuthCallbackPage.tsx:49
#~ msgid "Salesforce authentication completed."
#~ msgstr "Se completó la autenticación con Salesforce."

#: src/pages/ConnectionsPage.tsx:164
#~ msgid "Salesforce authentication failed"
#~ msgstr "Falló la autenticación con Salesforce"

#: src/pages/SalesforceOAuthCallbackPage.tsx:57
#~ msgid "Salesforce authentication failed."
#~ msgstr "Falló la autenticación con Salesforce."

#: src/pages/ConnectionsPage.tsx:498
#~ msgid "Salesforce authentication was cancelled."
#~ msgstr "Se canceló la autenticación con Salesforce."

#: src/pages/ConnectionsPage.tsx:162
#~ msgid "Salesforce connected successfully"
#~ msgstr "Salesforce se conectó correctamente"

#: src/pages/ConnectionsPage.tsx:454
#~ msgid "Salesforce connection could not be verified"
#~ msgstr "No se pudo verificar la conexión con Salesforce"

#: src/pages/PrivateMcpPage.tsx:470
#~ msgid "Salesforce host"
#~ msgstr "Host de Salesforce"

#: src/pages/ConnectionsPage.tsx:476
#~ msgid "Salesforce OAuth start did not return an authorization URL"
#~ msgstr "El inicio de OAuth de Salesforce no devolvió una URL de autorización"

#: src/pages/MemoryPage.tsx:698
msgid "Same-topic only"
msgstr "Solo mismo tema"

#: src/pages/MemoryPage.tsx:1076
msgid "Save"
msgstr "Guardar"

#: src/pages/SubscriptionPage.tsx:185
msgid "Save {savings}%"
msgstr "Ahorra {savings} %"

#: src/pages/ConnectionsPage.tsx:1193
msgid "Save & Connect"
msgstr "Guardar y conectar"

#: src/pages/AgentsPage.tsx:1453
#: src/pages/DictionaryManagementPage.tsx:552
msgid "Save Catalog"
msgstr "Guardar el catálogo"

#: src/pages/MemoryPage.tsx:1508
msgid "Save correction"
msgstr "Guardar la corrección"

#: src/pages/PrivateMcpPage.tsx:652
#: src/pages/PrivateMcpPage.tsx:816
#: src/pages/PrivateMcpPage.tsx:998
#: src/pages/PrivateMcpPage.tsx:1193
msgid "Save registration"
msgstr "Guardar el registro"

#: src/pages/MemoryPage.tsx:438
msgid "Saved, but held back for your review"
msgstr "Guardado, pero retenido para tu revisión"

#: src/pages/AgentsPage.tsx:929
#: src/pages/AgentsPage.tsx:1453
#: src/pages/DictionaryManagementPage.tsx:552
#: src/pages/PrivateMcpPage.tsx:652
#: src/pages/PrivateMcpPage.tsx:816
#: src/pages/PrivateMcpPage.tsx:998
#: src/pages/PrivateMcpPage.tsx:1193
msgid "Saving..."
msgstr "Guardando..."

#: src/pages/MemoryPage.tsx:1076
msgid "Saving…"
msgstr "Guardando…"

#: src/components/connections/ConnectionActions.tsx:23
msgid "Scan"
msgstr "Analizar"

#: src/pages/ConnectionsPage.tsx:745
msgid "Scan connections to build your catalog"
msgstr "Analiza las conexiones para construir tu catálogo"

#: src/components/connections/ConnectionHealthPanel.tsx:22
#: src/components/connections/ConnectionStatusBadge.tsx:34
msgid "Scan failed"
msgstr "Falló el análisis"

#: src/pages/ConnectionsPage.tsx:293
msgid "Scan failed: {detail}"
msgstr "Falló el análisis: {detail}"

#: src/pages/ConnectionsPage.tsx:603
msgid "Scan files stored in Box cloud storage across all enterprise folders and collaborations."
msgstr "Analiza los archivos guardados en Box en todas las carpetas y colaboraciones de la empresa."

#: src/pages/ConnectionsPage.tsx:638
msgid "Scan HubSpot contacts, companies, deals and custom objects to catalog customer names, account names and deal details, so AI prompts never expose CRM records."
msgstr "Analiza contactos, empresas, negocios y objetos personalizados de HubSpot para catalogar nombres de clientes, nombres de cuentas y detalles de negocios, de modo que los prompts de IA nunca expongan registros del CRM."

#: src/components/connections/ConnectionHealthPanel.tsx:28
msgid "Scan in progress…"
msgstr "Análisis en curso…"

#: src/pages/ConnectionsPage.tsx:299
msgid "Scan is still running — refresh in a moment to see results."
msgstr "El análisis sigue en curso. Actualiza en un momento para ver los resultados."

#: src/pages/ConnectionsPage.tsx:614
msgid "Scan Microsoft Teams channels, chats, and shared files for privacy-sensitive content."
msgstr "Analiza los canales, chats y archivos compartidos de Microsoft Teams en busca de contenido sensible para la privacidad."

#: src/pages/ConnectionsPage.tsx:650
msgid "Scan MongoDB collections for personally identifiable information and sensitive data patterns."
msgstr "Analiza las colecciones de MongoDB en busca de información de identificación personal y patrones de datos sensibles."

#: src/pages/ConnectionsPage.tsx:1139
msgid "Scan Private Channels"
msgstr "Analizar los canales privados"

#: src/pages/ConnectionsPage.tsx:629
msgid "Scan Salesforce Contacts, Leads, Accounts, Cases, and Opportunities to catalog sensitive customer data and ensure AI prompts never expose CRM records."
msgstr "Analiza los contactos, prospectos, cuentas, casos y oportunidades de Salesforce para catalogar los datos sensibles de los clientes y evitar que los prompts de IA expongan registros del CRM."

#: src/components/connections/ConnectionStatusBadge.tsx:27
msgid "Scanning"
msgstr "Analizando"

#. placeholder {0}: conn.serviceName
#: src/pages/ConnectionsPage.tsx:312
msgid "Scanning {0} for sensitive data…"
msgstr "Analizando {0} en busca de datos sensibles…"

#: src/components/connections/ConnectionActions.tsx:21
msgid "Scanning…"
msgstr "Analizando…"

#. placeholder {0}: Number(row.score ?? 0).toFixed(2)
#: src/pages/MemoryPage.tsx:1365
msgid "score {0}"
msgstr "puntaje {0}"

#: src/pages/OnboardingPage.tsx:433
msgid "SDK, API & CI/CD integrations"
msgstr "Integraciones de SDK, API y CI/CD"

#: src/pages/OnboardingPage.tsx:305
msgid "Seal the leak"
msgstr "Sella la fuga"

#: src/pages/MemoryPage.tsx:1155
msgid "Search memories…"
msgstr "Buscar en los recuerdos…"

#: src/pages/UserDetailAuditPage.tsx:766
msgid "Search prompts, files, or metadata..."
msgstr "Busca prompts, archivos o metadatos..."

#: src/pages/ConnectionsPage.tsx:863
msgid "Secure Connection"
msgstr "Conexión segura"

#: src/pages/OnboardingPage.tsx:206
msgid "See it Work"
msgstr "Míralo funcionar"

#: src/pages/ConnectionsPage.tsx:1112
msgid "Select File Types"
msgstr "Selecciona los tipos de archivo"

#: src/pages/OnboardingPage.tsx:467
msgid "Select one to continue"
msgstr "Selecciona uno para continuar"

#: src/pages/UserDetailAuditPage.tsx:788
msgid "Select Time Range"
msgstr "Selecciona el rango de tiempo"

#: src/pages/VerifyEmailPage.tsx:115
msgid "Send a new link to {email}"
msgstr "Enviar un enlace nuevo a {email}"

#: src/pages/MemoryPage.tsx:863
msgid "Send my profile once per conversation"
msgstr "Enviar mi perfil una vez por conversación"

#: src/pages/ForgotPasswordPage.tsx:142
msgid "Send reset link"
msgstr "Enviar el enlace de restablecimiento"

#: src/pages/ForgotPasswordPage.tsx:96
#: src/pages/ForgotPasswordPage.tsx:142
#: src/pages/InvitePage.tsx:602
#: src/pages/LoginPage.tsx:221
#: src/pages/LoginPage.tsx:249
#: src/pages/SignupPage.tsx:556
#: src/pages/VerifyEmailPage.tsx:115
msgid "Sending…"
msgstr "Enviando…"

#: src/components/ProviderDetailModal.tsx:406
msgid "Sensitive items"
msgstr "Elementos sensibles"

#: src/components/ProviderDetailModal.tsx:209
msgid "Sensitive items twinned"
msgstr "Elementos sensibles con valor sintético"

#: src/pages/MemoryPage.tsx:873
msgid "Sensitive topics"
msgstr "Temas sensibles"

#: src/pages/UserDetailAuditPage.tsx:708
#~ msgid "Sensitivity Score"
#~ msgstr "Puntaje de sensibilidad"

#: src/pages/ConnectionsPage.tsx:1215
msgid "Service"
msgstr "Servicio"

#: src/pages/ConnectionsPage.tsx:652
msgid "Service role key or direct database connection with read-only access. Find credentials in Supabase dashboard > Settings > API."
msgstr "Llave de rol de servicio o conexión directa a la base de datos con acceso de solo lectura. Encuentra las credenciales en el panel de Supabase > Settings > API."

#: src/components/ProviderDetailModal.tsx:453
msgid "Session risk levels"
msgstr "Niveles de riesgo de la sesión"

#: src/components/ProviderDetailModal.tsx:202
#: src/components/ProviderDetailModal.tsx:403
msgid "Sessions"
msgstr "Sesiones"

#: src/pages/ResetPasswordPage.tsx:250
msgid "Set new password"
msgstr "Definir la contraseña nueva"

#: src/pages/PrivateMcpPage.tsx:983
msgid "Set this and only accounts in that Google Workspace can connect; a personal account is refused."
msgstr "Si lo define, solo las cuentas de ese Google Workspace podrán conectarse; una cuenta personal queda rechazada."

#: src/pages/PrivateMcpPage.tsx:1178
msgid "Set this and only that HubSpot account can be connected; a user who picks a different account is refused."
msgstr "Si lo configuras, solo se puede conectar esa cuenta de HubSpot; si un usuario elige otra cuenta, se rechaza."

#: src/pages/SubscriptionPage.tsx:1148
msgid "Set up a subscription for your company. This will allow you to add licenses for your team members. Teams run on PrivacyPal Max: the per-seat price drops automatically as your team grows."
msgstr "Configura una suscripción para tu empresa. Así podrás agregar licencias para tu equipo. Los equipos funcionan con PrivacyPal Max: el precio por puesto baja automáticamente a medida que crece el equipo."

#: src/pages/SignupPage.tsx:590
msgid "Set up my team"
msgstr "Configurar mi equipo"

#: src/pages/DashboardPage.tsx:636
#: src/pages/MemoryPage.tsx:728
msgid "Share"
msgstr "Compartir"

#: src/components/Layout.tsx:494
msgid "Share this link with users you want to invite to your company:"
msgstr "Comparte este enlace con las personas que quieras invitar a tu empresa:"

#: src/pages/MemoryPage.tsx:726
msgid "Share this memory with your team as stable twins"
msgstr "Comparte este recuerdo con tu equipo como valores sintéticos estables"

#: src/pages/MemoryPage.tsx:1418
msgid "Shared by you"
msgstr "Compartido por ti"

#: src/pages/ResetPasswordPage.tsx:210
msgid "Show"
msgstr "Mostrar"

#: src/pages/UserDetailAuditPage.tsx:1030
msgid "Show Less"
msgstr "Mostrar menos"

#: src/pages/UserDetailAuditPage.tsx:1030
msgid "Show More"
msgstr "Mostrar más"

#: src/pages/ResetPasswordPage.tsx:208
msgid "Show password"
msgstr "Mostrar la contraseña"

#. placeholder {0}: businessDataCatalog.length
#: src/pages/ConnectionsPage.tsx:809
msgid "Showing 100 of {0} entries"
msgstr "Mostrando 100 de {0} entradas"

#: src/pages/MemoryPage.tsx:461
#~ msgid "Showing quarantined (back to active)"
#~ msgstr "Mostrando los que están en cuarentena (volver a los activos)"

#: src/pages/ResetPasswordPage.tsx:267
msgid "Sign in"
msgstr "Ingresar"

#: src/pages/LoginPage.tsx:331
msgid "Sign In"
msgstr "Ingresar"

#: src/pages/LoginPage.tsx:170
msgid "Sign in to your PrivacyPal account"
msgstr "Ingresa a tu cuenta de PrivacyPal"

#: src/components/Layout.tsx:402
#: src/components/Layout.tsx:480
msgid "Sign Out"
msgstr "Cerrar sesión"

#: src/pages/InvitePage.tsx:638
#: src/pages/SignupPage.tsx:460
msgid "Sign up with Google"
msgstr "Registrarse con Google"

#: src/pages/InvitePage.tsx:648
#: src/pages/SignupPage.tsx:466
msgid "Sign up with Microsoft"
msgstr "Registrarse con Microsoft"

#: src/pages/OnboardingPage.tsx:324
msgid "Slack, Gmail, code editors, ChatGPT..."
msgstr "Slack, Gmail, editores de código, ChatGPT..."

#: src/pages/ForgotPasswordPage.tsx:41
msgid "Something went wrong. Please try again."
msgstr "Algo salió mal. Inténtalo de nuevo."

#: src/pages/LoginPage.tsx:148
msgid "SSO login failed"
msgstr "Falló el ingreso con SSO"

#: src/pages/MemoryPage.tsx:126
msgid "Standing requests"
msgstr "Solicitudes permanentes"

#: src/pages/SubscriptionPage.tsx:505
#~ msgid "Start {trialDays}-day trial: {tierName} {planName}"
#~ msgstr "Empezar la prueba de {trialDays} días: {tierName} {planName}"

#: src/pages/SignupPage.tsx:622
msgid "Start Free"
msgstr "Empieza gratis"

#: src/pages/OnboardingPage.tsx:223
#~ msgid "Start My {trialDays}-Day Trial"
#~ msgstr "Empieza tu prueba de {trialDays} días"

#: src/pages/LoginPage.tsx:172
msgid "Start protecting your data with PrivacyPal"
msgstr "Empieza a proteger tus datos con PrivacyPal"

#: src/pages/SignupPage.tsx:617
#~ msgid "Start with a {trialDays}-day free trial. No charge until your trial ends."
#~ msgstr "Empieza con una prueba gratis de {trialDays} días. No se cobra nada hasta que termine."

#: src/components/UpgradeModal.tsx:650
msgid "Start with a card"
msgstr "Empezar con tarjeta"

#: src/pages/OnboardingPage.tsx:700
#~ msgid "Start your {trialDays}-day trial."
#~ msgstr "Empieza tu prueba de {trialDays} días."

#: src/pages/OnboardingPage.tsx:223
#~ msgid "Starting trial..."
#~ msgstr "Iniciando la prueba..."

#: src/pages/AgentsPage.tsx:671
#: src/pages/ConnectionsPage.tsx:1217
#: src/pages/DashboardPage.tsx:637
#: src/pages/DictionaryManagementPage.tsx:207
#: src/pages/UserManagementPage.tsx:285
msgid "Status"
msgstr "Estado"

#: src/pages/OnboardingPage.tsx:227
msgid "Step {step} of {TOTAL}"
msgstr "Paso {step} de {TOTAL}"

#: src/pages/SignupPage.tsx:401
msgid "Step {stepNumber} of 3"
msgstr "Paso {stepNumber} de 3"

#: src/pages/SignupPage.tsx:466
#~ msgid "Step {stepNumber} of 4"
#~ msgstr "Paso {stepNumber} de 4"

#: src/pages/PrivateMcpPage.tsx:1027
#: src/pages/PrivateMcpPage.tsx:1222
msgid "Stored"
msgstr "Guardado"

#: src/pages/MemoryPage.tsx:1122
msgid "Stored as a Privacy Twin like every other memory, and marked as written by you."
msgstr "Se guarda como Privacy Twin igual que cualquier otro recuerdo, y se marca como escrito por ti."

#: src/pages/PrivateMcpPage.tsx:959
#: src/pages/PrivateMcpPage.tsx:1153
msgid "Stored. Enter a new secret only to replace it."
msgstr "Guardado. Escriba un secreto nuevo solo si quiere reemplazarlo."

#: src/pages/SubscriptionPage.tsx:420
msgid "Subscribe now: {tierName} {planName}"
msgstr "Suscríbete ahora: {tierName} {planName}"

#: src/pages/SubscriptionPage.tsx:329
msgid "Subscribe to PrivacyPal Max"
msgstr "Suscríbete a PrivacyPal Max"

#: src/components/Layout.tsx:181
#: src/pages/SubscriptionPage.tsx:760
#: src/pages/SubscriptionPage.tsx:865
#: src/pages/SubscriptionPage.tsx:1179
msgid "Subscription"
msgstr "Suscripción"

#: src/pages/SubscriptionPage.tsx:301
msgid "Subscription Activated!"
msgstr "¡Suscripción activada!"

#: src/pages/DashboardPage.tsx:613
msgid "Supported AI Apps"
msgstr "Apps de IA compatibles"

#: src/components/Layout.tsx:380
msgid "Switch to dark mode"
msgstr "Cambiar al modo oscuro"

#: src/components/Layout.tsx:380
msgid "Switch to light mode"
msgstr "Cambiar al modo claro"

#: src/pages/ConnectionsPage.tsx:759
msgid "Sync All"
msgstr "Sincronizar todo"

#: src/pages/ConnectionsPage.tsx:757
msgid "Syncing…"
msgstr "Sincronizando…"

#: src/pages/ConnectionsPage.tsx:616
msgid "System Admin personal access token or bot account with read access to channels and posts."
msgstr "Token de acceso personal de administrador del sistema o cuenta de bot con acceso de lectura a canales y publicaciones."

#: src/pages/AgentsPage.tsx:555
#: src/pages/AgentsPage.tsx:902
msgid "System Prompt"
msgstr "Prompt del sistema"

#: src/pages/DashboardPage.tsx:284
msgid "Team Activity Stream"
msgstr "Flujo de actividad del equipo"

#: src/pages/DashboardPage.tsx:581
msgid "Team AI Activity"
msgstr "Actividad de IA del equipo"

#: src/pages/MemoryPage.tsx:645
msgid "Team memory"
msgstr "Memoria del equipo"

#: src/pages/MemoryPage.tsx:916
msgid "Team memory (Multiplayer)"
msgstr "Memoria del equipo (multijugador)"

#: src/pages/MemoryPage.tsx:1391
msgid "Team memory is off for you, so none of these are used in your prompts. Turn it on in the settings above."
msgstr "La memoria del equipo está apagada para ti, así que ninguno de estos se usa en tus prompts. Enciéndela en la configuración de arriba."

#: src/pages/MemoryPage.tsx:323
msgid "Team memory is off. Your memory is personal again."
msgstr "La memoria del equipo está apagada. Tu memoria vuelve a ser personal."

#: src/pages/MemoryPage.tsx:322
msgid "Team memory is on. Only the memories you share are visible to teammates."
msgstr "La memoria del equipo está encendida. Tus compañeros solo ven los recuerdos que compartas."

#: src/pages/MemoryPage.tsx:300
msgid "Team memory removed"
msgstr "Memoria del equipo eliminada"

#: src/pages/SubscriptionPage.tsx:790
msgid "Team seats, central provisioning and volume pricing"
msgstr "Puestos de equipo, aprovisionamiento central y precios por volumen"

#: src/pages/ConnectionsPage.tsx:604
msgid "team_data.member access via Dropbox Business API. Requires a scoped app on the Dropbox App Console."
msgstr "Acceso team_data.member por la API de Dropbox Business. Requiere una app con alcances en la consola de apps de Dropbox."

#: src/components/UpgradeModal.tsx:460
msgid "Tell us how many people you need covered and we will issue a company-wide trial code on the call. No card, no auto-renewal."
msgstr "Cuéntanos a cuántas personas necesitas cubrir y te emitimos un código de prueba para toda la empresa en la llamada. Sin tarjeta y sin renovación automática."

#: src/pages/PrivateMcpPage.tsx:783
msgid "Tenant GUID, or a verified domain such as contoso.onmicrosoft.com"
msgstr "GUID del tenant o un dominio verificado como contoso.onmicrosoft.com"

#: src/pages/AgentsPage.tsx:672
#: src/pages/AgentsPage.tsx:1414
#: src/pages/DictionaryManagementPage.tsx:208
#: src/pages/DictionaryManagementPage.tsx:474
msgid "Terms"
msgstr "Términos"

#. placeholder {0}: selectedDictionary.terms.length
#: src/pages/AgentsPage.tsx:745
#: src/pages/DictionaryManagementPage.tsx:305
msgid "Terms ({0})"
msgstr "Términos ({0})"

#: src/pages/AgentsPage.tsx:493
msgid "Test agent with sample prompt"
msgstr "Probar el agente con un prompt de ejemplo"

#: src/pages/AgentsPage.tsx:1054
msgid "Testing against input..."
msgstr "Probando contra la entrada..."

#: src/pages/SubscriptionPage.tsx:1111
msgid "Thank you for trying PrivacyPal! Enter your payment method below to continue protecting your data."
msgstr "¡Gracias por probar PrivacyPal! Escribe tu método de pago aquí abajo para seguir protegiendo tus datos."

#: src/pages/InvitePage.tsx:134
#: src/pages/LoginPage.tsx:108
#: src/pages/SignupPage.tsx:242
msgid "That code is invalid or has expired."
msgstr "Ese código no es válido o ya venció."

#: src/pages/PrivateMcpPage.tsx:114
msgid "That does not look like a Directory (tenant) ID. Use the tenant GUID from the app registration overview, a verified domain such as contoso.onmicrosoft.com, or organizations."
msgstr "Eso no parece un ID de directorio (tenant). Usa el GUID del tenant que aparece en la vista general del registro de la app, un dominio verificado como contoso.onmicrosoft.com u organizations."

#: src/pages/PrivateMcpPage.tsx:125
msgid "That does not look like a Google OAuth client ID. Copy the full value ending in .apps.googleusercontent.com from your Google Cloud credentials page."
msgstr "Eso no parece un ID de cliente de OAuth de Google. Copie el valor completo que termina en .apps.googleusercontent.com desde la página de credenciales de Google Cloud."

#: src/pages/PrivateMcpPage.tsx:127
msgid "That does not look like a Google OAuth client secret. Copy the value shown next to the client ID in Google Cloud."
msgstr "Eso no parece un secreto de cliente de OAuth de Google. Copie el valor que aparece junto al ID de cliente en Google Cloud."

#: src/pages/PrivateMcpPage.tsx:142
msgid "That does not look like a HubSpot client secret. Copy the value shown on the connector's details page."
msgstr "Eso no parece un secreto de cliente de HubSpot. Copia el valor que aparece en la página de detalles del conector."

#: src/pages/PrivateMcpPage.tsx:140
msgid "That does not look like a HubSpot MCP connector client ID. Copy it from the connector's details page in HubSpot."
msgstr "Eso no parece un ID de cliente de un conector MCP de HubSpot. Cópialo de la página de detalles del conector en HubSpot."

#: src/pages/PrivateMcpPage.tsx:101
msgid "That does not look like a Salesforce My Domain login URL. Use the form https://yourcompany.my.salesforce.com."
msgstr "Eso no parece una URL de ingreso de My Domain de Salesforce. Usa el formato https://yourcompany.my.salesforce.com."

#: src/pages/PrivateMcpPage.tsx:116
msgid "That does not look like an Application (client) ID. Copy the GUID from the app registration overview in Microsoft Entra."
msgstr "Eso no parece un ID de aplicación (cliente). Copia el GUID de la vista general del registro de la app en Microsoft Entra."

#: src/pages/PrivateMcpPage.tsx:103
msgid "That does not look like an External Client App consumer key. Copy it from the app's OAuth settings in Salesforce."
msgstr "Eso no parece un consumer key de una External Client App. Cópialo de la configuración de OAuth de la app en Salesforce."

#: src/pages/PrivateMcpPage.tsx:105
msgid "That is not a valid hosted MCP server slug. Use the platform/name form, for example platform/sobject-all."
msgstr "Ese no es un identificador válido de servidor MCP alojado. Usa el formato plataforma/nombre, por ejemplo platform/sobject-all."

#: src/pages/AuthCallbackPage.tsx:151
#: src/pages/SignupPage.tsx:547
msgid "The code expires in 10 minutes. Check your spam folder if you don't see it."
msgstr "El código vence en 10 minutos. Revisa la carpeta de spam si no lo ves."

#: src/pages/InvitePage.tsx:500
#: src/pages/SignupPage.tsx:415
msgid "The first-ever Privacy Agent designed specifically for the Generative AI era. Stop the manual redaction. Stop the data leaks. Get 100% accurate results without the risk."
msgstr "El primer agente de privacidad diseñado específicamente para la era de la IA generativa. Deja atrás la censura manual. Deja atrás las fugas de datos. Obtén resultados 100 % precisos sin el riesgo."

#: src/pages/MemoryPage.tsx:1487
msgid "The old version is kept as history and marked superseded; nothing is silently rewritten."
msgstr "La versión anterior se conserva como historial y se marca como reemplazada; nada se reescribe en silencio."

#: src/pages/PrivateMcpPage.tsx:131
#: src/pages/PrivateMcpPage.tsx:146
msgid "The Private MCP credential vault is not configured on the server yet, so the client secret cannot be stored. Contact PrivacyPal support."
msgstr "La bóveda de credenciales del Private MCP todavía no está configurada en el servidor, así que no se puede guardar el secreto de cliente. Comuníquese con el soporte de PrivacyPal."

#: src/pages/PrivateMcpPage.tsx:1313
msgid "The Private MCP vault key is not configured on the server; connections cannot be stored."
msgstr "La llave de la bóveda del Private MCP no está configurada en el servidor; no se pueden guardar las conexiones."

#: src/pages/OnboardingPage.tsx:247
msgid "Think of me as a dedicated member of your team: one who works around the clock to make sure your sensitive data never ends up where it shouldn't. Ready to get started?"
msgstr "Piensa en mí como un integrante dedicado de tu equipo: uno que trabaja a toda hora para que tus datos sensibles nunca terminen donde no deben. ¿Empezamos?"

#: src/pages/UserManagementPage.tsx:184
msgid "This adds a license for this user, billed at your domain's tier ({domainTier}: teams with more than one user always run on Max). Your payment method is charged for the new seat. Continue?"
msgstr "Esto agrega una licencia para este usuario, facturada según el nivel de tu dominio ({domainTier}: los equipos con más de un usuario siempre funcionan con Max). Se cobrará el puesto nuevo a tu método de pago. ¿Continuar?"

#: src/pages/UserManagementPage.tsx:182
msgid "This assigns this user a prepaid seat at your domain's tier ({domainTier}). If no {domainTier} seat is free, the request is refused. Continue?"
msgstr "Esto le asigna a este usuario un puesto prepagado del nivel de tu dominio ({domainTier}). Si no hay un puesto {domainTier} libre, la solicitud se rechaza. ¿Continuar?"

#. placeholder {0}: valid.trialDays
#: src/components/UpgradeModal.tsx:438
msgid "This code runs Max as a normal subscription for {0} days before it bills. Your card is collected now and nothing is charged until then."
msgstr "Este código ejecuta Max como una suscripción normal durante {0} días antes de facturar. Registramos tu tarjeta ahora y no te cobramos nada hasta entonces."

#: src/components/UpgradeModal.tsx:440
msgid "This code runs Max as a normal subscription, so your card is collected now."
msgstr "Este código ejecuta Max como una suscripción normal, así que registramos tu tarjeta ahora."

#: src/pages/MemoryPage.tsx:1518
msgid "This destroys your memory encryption keys and deletes every stored memory. Exported and synced copies become permanently unreadable. This cannot be undone."
msgstr "Esto destruye las llaves de cifrado de tu memoria y elimina todos los recuerdos guardados. Las copias exportadas y sincronizadas quedan ilegibles para siempre. No se puede deshacer."

#. placeholder {0}: new Date(subscriptionDetails.discount.end).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })
#: src/pages/SubscriptionPage.tsx:985
msgid "This discount expires on {0}. After that, your rate will return to ${baseRateLabel} / {intervalName}."
msgstr "Este descuento vence el {0}. Después, tu tarifa vuelve a ${baseRateLabel} / {intervalName}."

#: src/utils/licenses.ts:164
msgid "This domain has no prepaid {tierLabel} seats.{overClaimed} {noSeatLine}"
msgstr "Este dominio no tiene puestos {tierLabel} prepagados.{overClaimed} {noSeatLine}"

#: src/pages/PrivateMcpPage.tsx:624
#: src/pages/PrivateMcpPage.tsx:801
msgid "This is a public client identifier, not a secret."
msgstr "Este es un identificador de cliente público, no un secreto."

#: src/pages/UserManagementPage.tsx:171
msgid "This moves one seat from Max to Pro. A prorated credit is applied to your next invoice. Continue?"
msgstr "Esto mueve un puesto de Max a Pro. Se aplica un crédito prorrateado a tu próxima factura. ¿Continuar?"

#: src/pages/UserManagementPage.tsx:169
msgid "This moves one seat from Pro to Max. The prorated difference for the rest of the current billing period is charged to your payment method immediately. Continue?"
msgstr "Esto mueve un puesto de Pro a Max. La diferencia prorrateada por lo que queda del periodo de facturación actual se cobra de inmediato a tu método de pago. ¿Continuar?"

#: src/utils/licenses.ts:169
msgid "This moves the user to a prepaid {tierLabel} seat. Your company has {free} of {licensed} {tierLabel} seats free, so no charge applies. Continue?"
msgstr "Esto mueve al usuario a un puesto {tierLabel} prepagado. Tu empresa tiene {free} de {licensed} puestos {tierLabel} libres, así que no hay cobro. ¿Continuar?"

#: src/pages/ResetPasswordPage.tsx:153
msgid "This password reset link has expired — links are valid for 20 minutes."
msgstr "Este enlace de restablecimiento venció: los enlaces son válidos por 20 minutos."

#: src/pages/ResetPasswordPage.tsx:155
msgid "This password reset link is invalid or has already been used."
msgstr "Este enlace de restablecimiento no es válido o ya se usó."

#: src/utils/licenses.ts:200
msgid "This seat cannot be moved to {tierLabel} automatically: the subscription has no seat to move from. Contact PrivacyPal support to reconcile the subscription."
msgstr "Este puesto no se puede mover a {tierLabel} automáticamente: la suscripción no tiene un puesto de origen. Contacta al soporte de PrivacyPal para reconciliar la suscripción."

#: src/pages/PrivateMcpPage.tsx:510
#: src/pages/UserDetailAuditPage.tsx:555
msgid "this user"
msgstr "este usuario"

#: src/pages/UserManagementPage.tsx:472
msgid "This user will have full administrative access. Continue?"
msgstr "Este usuario tendrá acceso administrativo completo. ¿Continuar?"

#: src/pages/UserManagementPage.tsx:473
msgid "This user will lose administrative access and become a regular member. Continue?"
msgstr "Este usuario perderá el acceso administrativo y pasará a ser un integrante normal. ¿Continuar?"

#: src/pages/VerifyEmailPage.tsx:44
msgid "This verification link has expired."
msgstr "Este enlace de verificación venció."

#: src/pages/MemoryPage.tsx:642
msgid "Timeline"
msgstr "Línea de tiempo"

#: src/pages/UserDetailAuditPage.tsx:953
msgid "Timestamp: {detailTimestamp}"
msgstr "Marca de tiempo: {detailTimestamp}"

#: src/pages/AuthCallbackPage.tsx:117
msgid "To keep your account secure, we need to confirm you own <0>{pendingEmail}</0>. If that address can receive mail, we've sent it a 6-digit code — enter it below to finish signing in."
msgstr "Para mantener segura tu cuenta, necesitamos confirmar que <0>{pendingEmail}</0> es tuyo. Si esa dirección puede recibir correo, ya se le envió un código de 6 dígitos: escríbelo aquí abajo para terminar de ingresar."

#: src/components/ProviderDetailModal.tsx:204
#: src/components/ProviderDetailModal.tsx:404
#: src/pages/DashboardPage.tsx:635
msgid "Tokens"
msgstr "Tokens"

#: src/pages/DashboardPage.tsx:362
msgid "Tokens ({effectiveUsageDays}d)"
msgstr "Tokens ({effectiveUsageDays} d)"

#: src/pages/DashboardPage.tsx:311
#~ msgid "Tokens ({usageDays}d)"
#~ msgstr "Tokens ({usageDays} d)"

#: src/pages/DashboardPage.tsx:362
msgid "Tokens (24h)"
msgstr "Tokens (24 h)"

#: src/components/ProviderDetailModal.tsx:401
msgid "Tool"
msgstr "Herramienta"

#: src/components/ProviderDetailModal.tsx:393
msgid "Tool statistics"
msgstr "Estadísticas por herramienta"

#: src/components/ProviderDetailModal.tsx:471
msgid "Top models"
msgstr "Modelos principales"

#: src/pages/DashboardPage.tsx:77
msgid "Total"
msgstr "Total"

#: src/pages/ApiKeysPage.tsx:185
msgid "Total Elements"
msgstr "Elementos totales"

#: src/pages/DashboardPage.tsx:336
#: src/pages/UserDetailAuditPage.tsx:753
msgid "Total Prompts"
msgstr "Prompts totales"

#: src/pages/ApiKeysPage.tsx:184
msgid "Total Requests"
msgstr "Solicitudes totales"

#: src/pages/UserDetailAuditPage.tsx:1087
msgid "Transaction Hash:"
msgstr "Hash de la transacción:"

#: src/pages/MemoryPage.tsx:119
msgid "Travel"
msgstr "Viajes"

#: src/pages/DashboardPage.tsx:376
#: src/pages/UserDetailAuditPage.tsx:639
#: src/pages/UserManagementPage.tsx:300
#: src/pages/UserManagementPage.tsx:407
msgid "Trial"
msgstr "Prueba"

#: src/pages/OnboardingPage.tsx:722
#~ msgid "Trial activated. Let's bring PrivacyPal online."
#~ msgstr "Prueba activada. Vamos a poner PrivacyPal en línea."

#: src/components/UpgradeModal.tsx:369
msgid "Trial Code"
msgstr "Código de prueba"

#. placeholder {0}: codes.trialCode
#: src/pages/SignupPage.tsx:445
msgid "Trial code <0>{0}</0> is attached. We apply it the moment your account is created."
msgstr "El código de prueba <0>{0}</0> quedó adjunto. Lo aplicamos en el momento en que se cree tu cuenta."

#: src/components/UpgradeModal.tsx:250
msgid "Trial code <0>{attachedTrialCode}</0> needs a card, so it runs as a normal Max subscription."
msgstr ""

#: src/components/UpgradeModal.tsx:250
#~ msgid "Trial code <0>{attachedTrialCode}</0> needs a card, so it runs as a normal Max subscription. Keep the code: sales can see it on your account."
#~ msgstr "El código de prueba <0>{attachedTrialCode}</0> necesita una tarjeta, así que funciona como una suscripción normal de Max. Guarda el código: el equipo comercial puede verlo en tu cuenta."

#: src/components/UpgradeModal.tsx:653
msgid "Trial code or a 15 minute call"
msgstr "Código de prueba o una llamada de 15 minutos"

#: src/pages/ConnectionsPage.tsx:1229
msgid "Try Again"
msgstr "Intentar de nuevo"

#: src/components/MaxUpsell.tsx:94
msgid "Try Max company-wide"
msgstr "Probar Max en toda la empresa"

#: src/pages/MemoryPage.tsx:808
msgid "Turn memory on to carry context between ChatGPT, Claude, Gemini, Copilot, and your agents."
msgstr "Enciende la memoria para llevar el contexto entre ChatGPT, Claude, Gemini, Copilot y tus agentes."

#: src/pages/MemoryPage.tsx:820
msgid "Turn off memory"
msgstr "Apagar la memoria"

#: src/pages/MemoryPage.tsx:941
msgid "Turn off team memory"
msgstr "Apagar la memoria del equipo"

#: src/pages/MemoryPage.tsx:820
msgid "Turn on memory"
msgstr "Encender la memoria"

#: src/pages/MemoryPage.tsx:941
msgid "Turn on team memory"
msgstr "Encender la memoria del equipo"

#: src/pages/MemoryPage.tsx:952
msgid "Turns captured"
msgstr "Turnos capturados"

#. placeholder {0}: formatEpochMs(googleApp.updatedAt)
#: src/pages/PrivateMcpPage.tsx:893
msgid "Twin-translating Gmail and Drive access · last updated {0}"
msgstr "Acceso a Gmail y Drive con traducción de gemelos · última actualización {0}"

#. placeholder {0}: formatEpochMs(hubspotApp.updatedAt)
#: src/pages/PrivateMcpPage.tsx:1085
msgid "Twin-translating HubSpot CRM access · last updated {0}"
msgstr "Acceso al CRM de HubSpot con traducción de gemelos · última actualización {0}"

#. placeholder {0}: formatEpochMs(m365App.updatedAt)
#: src/pages/PrivateMcpPage.tsx:731
msgid "Twin-translating Microsoft 365 access · last updated {0}"
msgstr "Acceso a Microsoft 365 con traducción de valores sintéticos · última actualización {0}"

#. placeholder {0}: formatEpochMs(app.updatedAt)
#: src/pages/PrivateMcpPage.tsx:554
msgid "Twin-translating Salesforce access · last updated {0}"
msgstr "Acceso a Salesforce con traducción de valores sintéticos · última actualización {0}"

#: src/pages/AgentsPage.tsx:839
#: src/pages/OnboardingPage.tsx:396
msgid "Type"
msgstr "Tipo"

#: src/pages/OnboardingPage.tsx:349
msgid "Type anything containing sensitive data below. PrivacyPal replaces each piece of real PII with a realistic Privacy Twin: indistinguishable to the AI, meaningless to an attacker."
msgstr "Escribe abajo cualquier cosa que tenga datos sensibles. PrivacyPal reemplaza cada dato real de PII con un valor sintético realista: indistinguible para la IA y sin sentido para un atacante."

#: src/pages/MemoryPage.tsx:1247
msgid "Undated"
msgstr "Sin fecha"

#: src/pages/PrivateMcpPage.tsx:154
#: src/pages/PrivateMcpPage.tsx:156
#: src/pages/PrivateMcpPage.tsx:1347
#: src/pages/UserDetailAuditPage.tsx:451
msgid "unknown"
msgstr "desconocido"

#: src/pages/AgentsPage.tsx:1221
msgid "Unknown"
msgstr "Desconocido"

#: src/pages/ConnectionsPage.tsx:292
msgid "unknown error"
msgstr "error desconocido"

#: src/pages/MemoryPage.tsx:736
msgid "Unpin"
msgstr "Desfijar"

#: src/pages/OnboardingPage.tsx:292
msgid "Unprotected AI: your data exposed"
msgstr "IA sin protección: tus datos quedan expuestos"

#: src/pages/AgentsPage.tsx:929
msgid "Update Agent"
msgstr "Actualizar el agente"

#: src/pages/DashboardPage.tsx:307
msgid "Update payment method"
msgstr "Actualizar el método de pago"

#: src/pages/SubscriptionPage.tsx:525
#: src/pages/SubscriptionPage.tsx:554
msgid "Update Payment Method"
msgstr "Actualizar el método de pago"

#: src/pages/PrivateMcpPage.tsx:652
#: src/pages/PrivateMcpPage.tsx:816
#: src/pages/PrivateMcpPage.tsx:998
#: src/pages/PrivateMcpPage.tsx:1193
msgid "Update registration"
msgstr "Actualizar el registro"

#. placeholder {0}: new Date(agent.updated_at).toLocaleDateString()
#: src/pages/AgentsPage.tsx:529
msgid "Updated {0}"
msgstr "Actualizado {0}"

#: src/pages/SubscriptionPage.tsx:554
msgid "Updating..."
msgstr "Actualizando..."

#: src/pages/ResetPasswordPage.tsx:250
msgid "Updating…"
msgstr "Actualizando…"

#: src/components/Layout.tsx:288
#: src/components/MaxUpsell.tsx:87
#: src/pages/SubscriptionPage.tsx:798
#: src/pages/SubscriptionPage.tsx:1023
#: src/pages/SubscriptionPage.tsx:1059
#: src/pages/UserManagementPage.tsx:364
#: src/pages/UserManagementPage.tsx:451
#: src/pages/UserManagementPage.tsx:478
msgid "Upgrade to Max"
msgstr "Mejorar a Max"

#: src/pages/DashboardPage.tsx:409
msgid "Upgrade to Max →"
msgstr "Mejorar a Max →"

#: src/components/UpgradeModal.tsx:302
#: src/components/UpgradeModal.tsx:523
msgid "Upgrade to Max now"
msgstr "Mejorar a Max ahora"

#: src/components/UpgradeModal.tsx:620
#: src/pages/SubscriptionPage.tsx:1057
msgid "Upgrade to PrivacyPal Max"
msgstr "Mejorar a PrivacyPal Max"

#: src/pages/DashboardPage.tsx:356
#~ msgid "Upgrade to Pro →"
#~ msgstr "Mejorar a Pro →"

#: src/pages/UserManagementPage.tsx:476
msgid "Upgrade User to Max"
msgstr "Mejorar el usuario a Max"

#: src/pages/SubscriptionPage.tsx:1023
msgid "Upgrading..."
msgstr "Mejorando..."

#: src/pages/ConnectionsPage.tsx:996
msgid "Use an access token"
msgstr "Usa un token de acceso"

#. placeholder {0}: promo.code
#. placeholder {1}: promo.percentOff
#. placeholder {2}: promo.durationMonths
#: src/components/MaxUpsell.tsx:75
msgid "Use code <0>{0}</0> for {1}% off your first {2} months."
msgstr "Usa el código <0>{0}</0> y obtén {1}% de descuento en tus primeros {2} meses."

#: src/pages/AgentsPage.tsx:1442
msgid "Use deny list to prevent false positives."
msgstr "Usa la lista de bloqueo para evitar falsos positivos."

#: src/pages/DictionaryManagementPage.tsx:523
msgid "Use deny list to prevent false positives. For example, add \"Cancer\" to prevent the name \"Cancer\" from being detected as a medical condition."
msgstr "Usa la lista de bloqueo para evitar falsos positivos. Por ejemplo, agrega «Cáncer» para que el apellido «Cáncer» no se detecte como una condición médica."

#: src/pages/MemoryPage.tsx:835
msgid "Use memory in prompts"
msgstr "Usar la memoria en los prompts"

#: src/pages/ConnectionsPage.tsx:1170
msgid "Use the <0>Object.FieldApiName</0> format. Leave blank to scan all relevant fields."
msgstr "Usa el formato <0>Object.FieldApiName</0>. Déjalo vacío para analizar todos los campos relevantes."

#: src/pages/ConnectionsPage.tsx:1155
msgid "Use the <0>objectType.property</0> format with internal property names. Leave blank to scan all relevant properties."
msgstr "Usa el formato <0>objectType.property</0> con los nombres internos de las propiedades. Déjalo en blanco para analizar todas las propiedades relevantes."

#: src/pages/ConnectionsPage.tsx:1133
msgid "Use the connecting user's own permissions when accessing files"
msgstr "Usar los permisos propios del usuario que se conecta al acceder a los archivos"

#: src/pages/ConnectionsPage.tsx:951
msgid "Use your own HubSpot app"
msgstr "Usa tu propia app de HubSpot"

#: src/pages/ConnectionsPage.tsx:896
msgid "Use your own Salesforce Connected App"
msgstr "Usa tu propia Connected App de Salesforce"

#. placeholder {0}: fact.recallCount
#: src/pages/MemoryPage.tsx:709
msgid "used {0}×"
msgstr "usada {0} veces"

#: src/pages/PrivateMcpPage.tsx:1328
#: src/pages/UserManagementPage.tsx:284
msgid "User"
msgstr "Usuario"

#: src/pages/UserManagementPage.tsx:328
msgid "User actions"
msgstr "Acciones del usuario"

#: src/pages/UserManagementPage.tsx:191
msgid "User demoted to member successfully"
msgstr "El usuario pasó a ser integrante"

#: src/pages/UserManagementPage.tsx:122
msgid "User made administrator successfully"
msgstr "El usuario ahora es administrador"

#: src/components/Layout.tsx:259
#: src/pages/UserManagementPage.tsx:237
msgid "User Management"
msgstr "Gestión de usuarios"

#: src/pages/UserManagementPage.tsx:145
msgid "User moved to Pro"
msgstr "Usuario movido a Pro"

#: src/pages/UserDetailAuditPage.tsx:573
msgid "User Not Found"
msgstr "Usuario no encontrado"

#: src/pages/UserManagementPage.tsx:145
msgid "User upgraded to Max"
msgstr "Usuario mejorado a Max"

#: src/pages/ConnectionsPage.tsx:1069
msgid "Username"
msgstr "Usuario"

#: src/components/ProviderDetailModal.tsx:407
msgid "Users"
msgstr "Usuarios"

#: src/pages/InvitePage.tsx:200
msgid "Validating invite link..."
msgstr "Validando el enlace de invitación..."

#: src/pages/AuthCallbackPage.tsx:107
#: src/pages/InvitePage.tsx:165
#: src/pages/LoginPage.tsx:119
#: src/pages/SignupPage.tsx:297
#: src/pages/VerifyEmailPage.tsx:135
msgid "Verification failed"
msgstr "Falló la verificación"

#: src/pages/VerifyEmailPage.tsx:47
msgid "Verification failed."
msgstr "Falló la verificación."

#: src/pages/AuthCallbackPage.tsx:104
msgid "Verification session expired. Please sign in again."
msgstr "La sesión de verificación venció. Vuelve a ingresar."

#: src/pages/InvitePage.tsx:592
msgid "Verify & accept invite"
msgstr "Verificar y aceptar la invitación"

#: src/pages/AuthCallbackPage.tsx:147
msgid "Verify & continue"
msgstr "Verificar y continuar"

#: src/pages/LoginPage.tsx:212
#: src/pages/SignupPage.tsx:543
msgid "Verify & create account"
msgstr "Verificar y crear la cuenta"

#: src/pages/AuthCallbackPage.tsx:115
#: src/pages/InvitePage.tsx:570
#: src/pages/LoginPage.tsx:180
#: src/pages/SignupPage.tsx:521
msgid "Verify your email"
msgstr "Verifica tu correo"

#: src/pages/VerifyEmailPage.tsx:91
msgid "Verifying your email…"
msgstr "Verificando tu correo…"

#: src/pages/AuthCallbackPage.tsx:147
#: src/pages/InvitePage.tsx:592
#: src/pages/LoginPage.tsx:212
#: src/pages/SignupPage.tsx:543
msgid "Verifying…"
msgstr "Verificando…"

#: src/pages/UserManagementPage.tsx:431
msgid "View Audit"
msgstr "Ver la auditoría"

#: src/pages/MemoryPage.tsx:1465
msgid "View audit trail"
msgstr "Ver el registro de auditoría"

#: src/pages/UserDetailAuditPage.tsx:1095
msgid "View on Peaq Subscan"
msgstr "Ver en Peaq Subscan"

#: src/pages/UserManagementPage.tsx:348
msgid "View User Audit"
msgstr "Ver la auditoría del usuario"

#: src/pages/ConnectionsPage.tsx:1092
msgid "Waiting for HubSpot…"
msgstr "Esperando a HubSpot…"

#: src/pages/ConnectionsPage.tsx:1088
msgid "Waiting for Salesforce…"
msgstr "Esperando a Salesforce…"

#: src/pages/OnboardingPage.tsx:347
msgid "Watch PrivacyPal work."
msgstr "Mira a PrivacyPal trabajar."

#: src/components/UpgradeModal.tsx:243
msgid "We could not apply that code, so this is the list price."
msgstr "No pudimos aplicar ese código, así que este es el precio de lista."

#: src/pages/SignupPage.tsx:608
msgid "We could not apply that trial code. Your account is set up on the free plan."
msgstr "No pudimos aplicar ese código de prueba. Tu cuenta quedó en el plan gratuito."

#: src/components/UpgradeModal.tsx:393
msgid "We could not check that code just now. Try again in a moment."
msgstr "No pudimos verificar ese código en este momento. Inténtalo de nuevo en un momento."

#: src/pages/SubscriptionPage.tsx:341
msgid "We couldn't complete your subscription"
msgstr "No se pudo completar tu suscripción"

#: src/pages/ConnectionsPage.tsx:549
#: src/pages/OnboardingPage.tsx:206
msgid "Welcome"
msgstr "Bienvenido"

#: src/pages/LoginPage.tsx:166
msgid "Welcome Back"
msgstr "Te damos la bienvenida de nuevo"

#: src/pages/SubscriptionPage.tsx:675
msgid "Welcome to PrivacyPal Max"
msgstr "Te damos la bienvenida a PrivacyPal Max"

#: src/components/UpgradeModal.tsx:155
#: src/components/UpgradeModal.tsx:491
msgid "Welcome to PrivacyPal Max. Every surface is now protected."
msgstr "Bienvenido a PrivacyPal Max. Ahora todas las superficies están protegidas."

#: src/pages/OnboardingPage.tsx:250
msgid "What should I call you? (We'll use your first name if you skip this.)"
msgstr "¿Cómo te digo? (Si lo omites, usamos tu nombre.)"

#: src/pages/PrivateMcpPage.tsx:1294
msgid "Who has connected their assistant through this Private MCP. Metadata only; tokens never leave the vault."
msgstr "Quiénes han conectado su asistente por este Private MCP. Solo metadatos; los tokens nunca salen de la bóveda."

#: src/pages/MemoryPage.tsx:771
msgid "Why PrivacyPal remembers this"
msgstr "Por qué PrivacyPal recuerda esto"

#: src/pages/MemoryPage.tsx:1342
msgid "Why these?"
msgstr "¿Por qué estas?"

#: src/components/Layout.tsx:742
msgid "Windows: run the installer as a user with permission to install applications; SmartScreen may ask you to confirm the publisher."
msgstr "Windows: ejecuta el instalador con un usuario que tenga permiso para instalar aplicaciones; SmartScreen puede pedirte confirmar el editor."

#: src/pages/MemoryPage.tsx:112
msgid "Work"
msgstr "Trabajo"

#: src/pages/InvitePage.tsx:684
#: src/pages/SignupPage.tsx:486
msgid "Work Email"
msgstr "Correo del trabajo"

#: src/pages/MemoryPage.tsx:124
msgid "Working context"
msgstr "Contexto de trabajo"

#: src/pages/PrivateMcpPage.tsx:1019
msgid "Workspace domain"
msgstr "Dominio del espacio de trabajo"

#: src/pages/PrivateMcpPage.tsx:972
msgid "Workspace domain (optional)"
msgstr "Dominio del espacio de trabajo (opcional)"

#: src/pages/SubscriptionPage.tsx:834
msgid "year"
msgstr "año"

#: src/pages/AgentsPage.tsx:742
#: src/pages/DictionaryManagementPage.tsx:301
msgid "Yes"
msgstr "Sí"

#: src/utils/relativeTime.ts:16
msgid "yesterday"
msgstr "ayer"

#: src/pages/UserDetailAuditPage.tsx:431
msgid "Yesterday"
msgstr "Ayer"

#: src/pages/MemoryPage.tsx:1030
msgid "you"
msgstr "ti"

#: src/pages/OnboardingPage.tsx:703
#~ msgid "You already have an active subscription. Continue to complete your setup."
#~ msgstr "Ya tienes una suscripción activa. Continúa para terminar la configuración."

#: src/pages/OnboardingPage.tsx:513
msgid "You are on PrivacyPal Pro, free forever: ChatGPT, Claude, Gemini, Grok and Perplexity chats protected. Agent surfaces and team features come with Max, whenever you want them."
msgstr "Estás en PrivacyPal Pro, gratis para siempre: chats de ChatGPT, Claude, Gemini, Grok y Perplexity protegidos. Las superficies de agentes y las funciones de equipo vienen con Max, cuando las quieras."

#: src/pages/DashboardPage.tsx:320
msgid "You are on Pro, free."
msgstr "Estás en Pro, gratis."

#: src/pages/SalesforceOAuthCallbackPage.tsx:65
msgid "You can close this window and try again."
msgstr "Puedes cerrar esta ventana e intentar de nuevo."

#: src/pages/SalesforceOAuthCallbackPage.tsx:56
msgid "You can close this window."
msgstr "Puedes cerrar esta ventana."

#: src/pages/SubscriptionPage.tsx:729
msgid "You don't have access to subscription management. Only administrators can manage subscriptions."
msgstr "No tienes acceso a la gestión de suscripciones. Solo los administradores pueden gestionarlas."

#: src/pages/UserManagementPage.tsx:220
msgid "You must be an administrator to access this page."
msgstr "Debes ser administrador para entrar a esta página."

#: src/pages/OnboardingPage.tsx:531
msgid "You're a Privacy Engineer."
msgstr "Eres ingeniero de privacidad."

#: src/pages/OnboardingPage.tsx:206
msgid "You're In"
msgstr "Ya estás dentro"

#: src/pages/SignupPage.tsx:598
msgid "You're in. Choose how you start."
msgstr "Ya estás dentro. Elige cómo empezar."

#: src/pages/SubscriptionPage.tsx:1188
msgid "You're on a free trial"
msgstr "Estás en una prueba gratis"

#. placeholder {0}: subscriptionDetails.discount.coupon.percent_off
#: src/pages/SubscriptionPage.tsx:979
msgid "You're saving {0}% off your subscription"
msgstr "Estás ahorrando {0} % en tu suscripción"

#. placeholder {0}: discountDollars.toFixed(2)
#: src/pages/SubscriptionPage.tsx:981
msgid "You're saving ${0} per {intervalName}"
msgstr "Estás ahorrando ${0} por {intervalName}"

#: src/pages/VerifyEmailPage.tsx:99
msgid "You're signed in. Redirecting…"
msgstr "Ya ingresaste. Redirigiendo…"

#: src/components/UpgradeModal.tsx:417
msgid "Your account already exists, so we activate this one for you. Book a 15 minute call and we will switch it on while you are on it."
msgstr "Tu cuenta ya existe, así que nosotros activamos este código. Agenda una llamada de 15 minutos y lo encendemos mientras hablamos."

#: src/components/ProviderDetailModal.tsx:105
#: src/pages/DashboardPage.tsx:624
msgid "your activity"
msgstr "tu actividad"

#: src/pages/DashboardPage.tsx:581
msgid "Your AI Activity"
msgstr "Tu actividad de IA"

#: src/pages/OnboardingPage.tsx:324
msgid "Your Apps"
msgstr "Tus apps"

#: src/pages/OnboardingPage.tsx:214
#~ msgid "Your card is encrypted. You will not be charged until your {trialDays}-day trial ends."
#~ msgstr "Tu tarjeta está cifrada. No se te cobrará hasta que termine tu prueba de {trialDays} días."

#: src/components/UpgradeModal.tsx:497
msgid "Your card was declined. Update your payment method on the Subscription page and try again."
msgstr "Tu tarjeta fue rechazada. Actualiza tu método de pago en la página de Suscripción e inténtalo de nuevo."

#: src/pages/SignupPage.tsx:151
#~ msgid "Your card will be verified but not charged until your {trialDays}-day trial ends."
#~ msgstr "Tu tarjeta se verifica, pero no se cobra hasta que termine tu prueba de {trialDays} días."

#: src/pages/SignupPage.tsx:674
#~ msgid "Your card will be verified but not charged until your trial ends."
#~ msgstr "Tu tarjeta se verifica, pero no se cobra hasta que termine tu prueba."

#: src/pages/SubscriptionPage.tsx:1135
msgid "Your company has an active subscription. You can manage users and licenses from the User Management page."
msgstr "Tu empresa tiene una suscripción activa. Puedes gestionar los usuarios y las licencias desde la página de Gestión de usuarios."

#: src/pages/ConnectionsPage.tsx:1081
msgid "Your credentials are encrypted using AES-256 before storage and are never exposed in logs or API responses."
msgstr "Tus credenciales se cifran con AES-256 antes de guardarse y nunca se exponen en registros ni en respuestas de la API."

#: src/pages/MemoryPage.tsx:1445
msgid "Your data"
msgstr "Tus datos"

#: src/pages/OnboardingPage.tsx:273
msgid "Your data is leaking, silently."
msgstr "Tus datos se están filtrando, en silencio."

#: src/components/UpgradeModal.tsx:509
msgid "Your existing subscription moves to Max using the card on file. The difference is prorated and charged immediately."
msgstr "Tu suscripción actual pasa a Max con la tarjeta registrada. La diferencia se prorratea y se cobra de inmediato."

#: src/pages/MemoryPage.tsx:865
msgid "Your four profile blocks open each new conversation. Relevant notes are added only when they match what you type."
msgstr "Tus cuatro bloques de perfil abren cada conversación nueva. Las notas relevantes se agregan solo cuando coinciden con lo que escribes."

#: src/pages/ConnectionsPage.tsx:944
msgid "Your HubSpot app (OAuth)"
msgstr "Tu app de HubSpot (OAuth)"

#: src/pages/OnboardingPage.tsx:354
msgid "Your input"
msgstr "Tu entrada"

#: src/pages/ConnectionsPage.tsx:1213
msgid "Your integration is active and ready. PrivacyPal will begin scanning data according to your configuration."
msgstr "Tu integración está activa y lista. PrivacyPal empezará a analizar los datos según tu configuración."

#: src/pages/SubscriptionPage.tsx:773
msgid "Your Max access is managed by PrivacyPal. There is nothing to pay here."
msgstr "Tu acceso a Max lo administra PrivacyPal. Aquí no hay nada que pagar."

#: src/pages/SignupPage.tsx:573
msgid "Your Max trial is live."
msgstr "Tu prueba de Max está activa."

#: src/pages/OnboardingPage.tsx:254
msgid "Your name"
msgstr "Tu nombre"

#: src/pages/ConnectionsPage.tsx:639
#~ msgid "Your own HubSpot app (OAuth 2.0, recommended) with the callback URL shown in the wizard and read access to contacts, companies and deals, or a static access token from an app created in your HubSpot account with the same read scopes."
#~ msgstr ""

#: src/pages/ConnectionsPage.tsx:639
msgid "Your own HubSpot app (OAuth 2.0, recommended) with the callback URL shown in the wizard and read access to contacts, companies and deals, or an access token from a service key or legacy private app in your HubSpot account with the same read scopes."
msgstr "Tu propia app de HubSpot (OAuth 2.0, recomendado) con la URL de retorno que muestra el asistente y acceso de lectura a contactos, empresas y negocios, o un token de acceso de una service key o de una app privada heredada en tu cuenta de HubSpot con los mismos alcances de lectura."

#: src/pages/ConnectionsPage.tsx:630
msgid "Your own Salesforce Connected App (OAuth 2.0 Authorization Code + Refresh Token). Enable OAuth, register the callback URL shown in the wizard, and grant the api and refresh_token scopes with read access to Contact, Lead, Account, Case, Opportunity."
msgstr "Tu propia Connected App de Salesforce (OAuth 2.0 con Authorization Code y Refresh Token). Habilita OAuth, registra la URL de retorno que aparece en el asistente y otorga los alcances api y refresh_token con acceso de lectura a Contact, Lead, Account, Case y Opportunity."

#: src/pages/OnboardingPage.tsx:208
msgid "Your Pal"
msgstr "Tu Pal"

#: src/pages/ResetPasswordPage.tsx:98
msgid "Your password has been updated."
msgstr "Tu contraseña se actualizó."

#: src/pages/SubscriptionPage.tsx:761
msgid "Your plan and upgrade options"
msgstr "Tu plan y opciones de mejora"

#: src/pages/OnboardingPage.tsx:509
msgid "Your Privacy Agent is configured and waiting. Hit activate to go live."
msgstr "Tu agente de privacidad está configurado y esperando. Presiona activar para ponerlo en marcha."

#: src/pages/OnboardingPage.tsx:460
msgid "Your PrivacyPal desktop app is already configured. Once you complete setup, it will silently route all AI traffic through your personal protection layer."
msgstr "Tu app de escritorio de PrivacyPal ya está configurada. Cuando termines la configuración, enrutará en silencio todo el tráfico de IA por tu capa personal de protección."

#: src/pages/LoginPage.tsx:46
msgid "Your session has expired. Please sign in again to continue."
msgstr "Tu sesión venció. Vuelve a ingresar para continuar."

#: src/pages/SubscriptionPage.tsx:702
msgid "Your subscription has been cancelled. You will have access until the end of your current billing period."
msgstr "Tu suscripción se canceló. Conservarás el acceso hasta que termine el periodo de facturación actual."

#: src/pages/OnboardingPage.tsx:700
#~ msgid "Your subscription is active"
#~ msgstr "Tu suscripción está activa"

#: src/pages/OnboardingPage.tsx:714
#~ msgid "Your subscription is active. Let's bring PrivacyPal online."
#~ msgstr "Tu suscripción está activa. Vamos a poner PrivacyPal en línea."

#: src/pages/SubscriptionPage.tsx:1058
msgid "Your subscription switches to PrivacyPal Max on your current {intervalWord} interval. The prorated difference for the rest of the current billing period is charged to your payment method immediately."
msgstr "Tu suscripción cambia a PrivacyPal Max en tu intervalo {intervalWord} actual. La diferencia prorrateada por lo que queda del periodo de facturación actual se cobra de inmediato a tu método de pago."

#: src/pages/SubscriptionPage.tsx:701
msgid "Your trial has been cancelled. You won't be charged."
msgstr "Tu prueba se canceló. No se te cobrará."

#: src/pages/SubscriptionPage.tsx:1109
msgid "Your Trial Has Ended"
msgstr "Tu prueba terminó"

#: src/pages/OnboardingPage.tsx:484
msgid "Zero data leaks"
msgstr "Cero fugas de datos"
